/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: ' + 769 + 'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Impulse theme (' + theme.settings.themeVersion + ') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

theme.removeRecentlyViewedHandle = function(handle) {
  if (!handle || !theme.recentlyViewed || !theme.recentlyViewed.recent) {
    return;
  }

  delete theme.recentlyViewed.recent[handle];

  if (theme.recentlyViewed.productInfo && theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
    delete theme.recentlyViewed.productInfo[handle];
  }

  if (theme.config.hasLocalStorage) {
    window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
  }

  if (theme.config.hasSessionStorage) {
    sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
  }
};

// Single cached entry point for /products/<handle>.js lookups. Multiple
// features (search recently-viewed, zero-results colour fallback, and any
// future callers) fetch product JSON by handle; without a shared cache the
// same handle was fetched repeatedly, and deleted-product handles 404'd on
// every call. This dedupes in-flight requests AND caches negative (404 / error)
// results as null so a dead handle is fetched at most once per page.
theme.productJsonCache = theme.productJsonCache || {};
theme.productJsonInflight = theme.productJsonInflight || {};
theme.fetchProductJson = function (handle) {
  handle = (handle || '').replace(/^\/+/, '');
  if (!handle) return Promise.resolve(null);

  if (Object.prototype.hasOwnProperty.call(theme.productJsonCache, handle)) {
    return Promise.resolve(theme.productJsonCache[handle]);
  }

  if (theme.productJsonInflight[handle]) {
    return theme.productJsonInflight[handle];
  }

  var request = fetch('/products/' + handle + '.js')
    .then(function (r) {
      if (!r.ok) {
        // Cache the miss so this handle is never re-fetched this page.
        theme.productJsonCache[handle] = null;
        return null;
      }
      return r.json().then(function (product) {
        theme.productJsonCache[handle] = product;
        return product;
      });
    })
    .catch(function () {
      theme.productJsonCache[handle] = null;
      return null;
    })
    .finally(function () {
      delete theme.productJsonInflight[handle];
    });

  theme.productJsonInflight[handle] = request;
  return request;
};

(function () {
  'use strict';

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces) // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },

    prepareTransition: function (el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === 'function') {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();

      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');

          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

  theme.Images = (function () {

    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    function buildImagePath(string, widths) {

      if (string == null) return [];

      if (widths) {
        const imageUrls = [];

        widths.forEach(width => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`
          } else {
            url += ` ${width}w,`
          }
          imageUrls.push(url);
        })
        return imageUrls;
      } else {
        return [string];
      }
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath
    };
  })();

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0

    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })

    observer.observe(options.element)
  }

  theme.LibraryLoader = (function () {
    var types = {
      link: 'link',
      script: 'script'
    };

    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () { };
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll('[data-section-id]');

      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section, options) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload(options);
          }
        }
      }
    }
  });

  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function () {

    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();

      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {

      _getCurrentOptions: function () {
        var result = [];

        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function (key) {
        return parseInt(key.substr(-1));
      },

      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function (variant) {
        return this._getCurrentOptions().reduce((count, { value, index }) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        }, 0)
      },

      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({ value, index }) => {
            return variant[index] === value;
          });

          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },

      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function (lastSelectedOption) {
        if (!lastSelectedOption) return null;

        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({ value, index }) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({ value, index }) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });

        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;

          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);

          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },

      _getVariantFromOptions: function (lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);

        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }

      },

      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;

          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value
            if (input.checked) {
              input.dispatchEvent(new Event('updateSwatch'));
            }
          } else {
            input.value = variant[index];
          }
        }
      },

      _onSelectChange: function ({ srcElement }) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);

        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });

        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))

        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();

        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index
        }

        this.container.dispatchEvent(new CustomEvent('variantChange', { detail }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail }));

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function (variant) {
        if (!variant.featured_image) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updatePrice: function (variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateUnitPrice: function (variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateSKU: function (variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      },

      _updateMasterSelect: function (variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;

        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true
        theme.config.vimeoLoading = false
        document.dispatchEvent(new CustomEvent('vimeoReady'))
      })
  }

  function checkIfVimeoIsReady() {
    let wait
    let timeout

    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!window.Vimeo) {
          return
        }

        clearInterval(wait)
        clearTimeout(timeout)
        resolve()
      }, 500)

      timeout = setTimeout(function () {
        clearInterval(wait)
        reject()
      }, 4000) // subjective. test up to 8 times over 4 seconds
    })
  }

  theme.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    }

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId
      this.el = document.getElementById(divId)
      this.videoId = videoId
      this.iframe = null
      this.options = options

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent)
      }

      this.setAsLoading()

      if (theme.config.vimeoReady) {
        this.init()
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady)
        document.addEventListener('vimeoReady', this.init.bind(this))
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults
        args.id = this.videoId

        this.videoPlayer = new Vimeo.Player(this.el, args)

        this.videoPlayer.ready().then(this.playerReady.bind(this))
      },

      playerReady: function () {
        this.iframe = this.el.querySelector('iframe')
        this.iframe.setAttribute('tabindex', '-1')

        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false)
        }

        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1)
        } else {
          this.videoPlayer.setVolume(0)
        }

        this.setAsLoaded()

        // pause when out of view
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play()
            } else {
              this.pause()
            }
          })
        }, { rootMargin: '0px 0px 50px 0px' })

        observer.observe(this.iframe)
      },

      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },

      setAsLoaded: function () {
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play()
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause()
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy()
        }
      }
    })

    return VimeoPlayer
  })()

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }

      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.style !== 'sound') {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { rootMargin: '0px 0px 50px 0px' });

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return YouTube;
  })();

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener('touchstart', function (i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })

    document.body.addEventListener('touchmove', function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();


  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams)

        // Latest-wins interrupt: every render is sequence-stamped; when a
        // response lands it only paints if it is still the NEWEST request.
        // Rapid filter clicks therefore never paint intermediate states —
        // in-flight renders are superseded and discarded, and only the
        // final state hits the DOM.
        this._renderSeq = (this._renderSeq || 0) + 1;
        const seq = this._renderSeq;

        const sectionRenders = this.sections.map(section => {
          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cached = this.cachedSections.find(c => c.url === url);

          const entryPromise = cached
            ? Promise.resolve(cached)
            : fetch(url)
                .then(response => response.text())
                .then(html => {
                  const entry = { html, url };
                  this.cachedSections = [...this.cachedSections, entry];
                  // Cap the cache: each entry is a full section's HTML (and a
                  // parsed doc memoised onto it later), so an open-ended
                  // search/sort/filter session would grow it without bound.
                  if (this.cachedSections.length > 12) {
                    this.cachedSections = this.cachedSections.slice(-12);
                  }
                  return entry;
                });

          return entryPromise
            .then(entry => {
              if (seq !== this._renderSeq) return null;
              // Gate the paint on the new grid's images: load + DECODE the
              // first rows' images BEFORE swapping the DOM, so the new grid
              // arrives fully painted — nothing can pop in afterwards. The
              // old grid (and the deferred overlay, if it showed) stays up
              // during the wait. Prefetch-warmed images resolve instantly.
              if (typeof entry === 'string') return entry;
              const doc = entry.doc || (entry.doc = new DOMParser().parseFromString(entry.html, 'text/html'));
              const imgs = Array.prototype.slice.call(
                doc.querySelectorAll('.collection-product-grid img'), 0, 24
              );
              if (!imgs.length) return entry;
              const decodes = imgs.map(node => new Promise(resolve => {
                const im = new Image();
                const sizes = node.getAttribute('sizes');
                const srcset = node.getAttribute('srcset');
                const src = node.getAttribute('src');
                if (sizes) im.sizes = sizes;
                if (srcset) im.srcset = srcset;
                if (src) im.src = src;
                if (!src && !srcset) return resolve();
                if (im.decode) {
                  im.decode().then(resolve, resolve);
                } else {
                  im.onload = im.onerror = resolve;
                }
              }));
              // Never paint a half-loaded grid; cap only as a broken-image
              // escape hatch. 3s (was 10s): on a slow network a stale grid
              // held the screen for up to 10s after the user acted —
              // partially-loaded-but-current beats stale-but-complete
              // beyond a few seconds.
              const cap = new Promise(resolve => setTimeout(resolve, 3000));
              return Promise.race([Promise.all(decodes), cap]).then(() => entry);
            })
            .then(entry => {
              if (!entry || seq !== this._renderSeq) {
                this.log(`[AjaxRenderer] discarding stale render: url=${url}`);
                return section;
              }
              this.renderSection(entry, section);
              return section;
            });
        });

        if (updateURLHash) this.updateURLHash(updatedParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },

      renderSection: function (entry, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );

        // Accepts a cache entry ({html, url}) or a raw html string (legacy
        // callers). Parsed documents are memoised on the entry so repeat
        // paints of a cached URL skip the DOMParser cost entirely.
        const newDom = typeof entry === 'string'
          ? new DOMParser().parseFromString(entry, 'text/html')
          : (entry.doc || (entry.doc = new DOMParser().parseFromString(entry.html, 'text/html')));
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }

            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];

        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          };
        }

        // Preserved params are single-valued: when the new render explicitly
        // provides one, it REPLACES the old value. Without this, an in-page
        // re-search appended q after q (?q=blue&q=orange&q=green...).
        for (const key of preservedParams) {
          if (newParams.has(key)) clone.delete(key);
        }

        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }

        return clone;
      },

      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${searchParams && '?'.concat(searchParams)
          }`,
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  theme.cart = {
    getCart: function () {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => {
        if (!response.ok) {
          throw new Error(theme.strings.cartUpdateError || 'Cart request failed (' + response.status + ')');
        }
        return response.json();
      });
    },

    getCartProductMarkup: function () {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
        .then(response => response.text())
        .catch(e => console.error(e));
    },

    changeItem: function (key, qty) {

      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
        .then(response => {
          return response.text().then(body => {
            // 422 carries a structured body ({status, message, description})
            // that callers branch on — pass it through untouched. Any other
            // non-OK response has no contract with the callers, so surface
            // it instead of letting them JSON.parse an error page.
            if (!response.ok && response.status !== 422) {
              var message;
              try {
                var parsed = JSON.parse(body);
                message = parsed.description || parsed.message;
              } catch (e) { /* non-JSON body (e.g. HTML error page) */ }
              throw new Error(message || theme.strings.cartUpdateError || 'Cart request failed (' + response.status + ')');
            }
            return body;
          });
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },

    attributeToString: function (attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',

      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };

    var classes = {
      btnLoading: 'btn--loading'
    };

    var config = {
      requiresTerms: false
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      this.cartItemsUpdated = false;

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function () {
        this.initQtySelectors();

        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener('change', function () {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function () {
          this.buildCart();
        }.bind(this));
      },

      reInit: function () {
        this.initQtySelectors();
      },

      onSubmit: function (evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        /*
          Checks for drawer or cart open class on body element
          and then stops the form from being submitted. We are also
          checking against a custom property, this.cartItemsUpdated = false.
  
          Error is handled in the quantityChanged method
  
          For Expanse/Fetch/Gem quick add, if an error is present it is alerted
          through the add to cart fetch request in quick-add.js.
  
          Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
          Expanse/Fetch/Gem when using quick add
        */

        if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
          document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
          this.submitBtn.classList.remove(classes.btnLoading);
          evt.preventDefault();
          return false;
        }

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (text) {
        const html = document.createElement('div');
        html.innerHTML = text;

        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts'),
          shippingSummary: html.querySelector('[data-cart-ajax-shipping-summary]')
        }
      },

      buildCart: function () {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function (text) {
        var markup = this._parseProductHTML(text);
        var items = markup.items;
        if (!items) {
          return;
        }
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }

        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);

        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

        // Keep the free-shipping bar in sync on every cart change
        this.updateShippingSummary(markup.shippingSummary);

        this.reInit();

        // AOS.refreshHard() is load-bearing here, NOT wasted: the theme hides
        // every <image-element> at opacity:0 until AOS adds .aos-animate, and
        // this is what reveals the cart thumbnails in the AJAX-rebuilt drawer.
        // (A CSS opacity:1 override on .cart__image also guarantees it — belt
        // and braces — but keep this so nothing else in the rebuild regresses.)
        if (window.AOS) { AOS.refreshHard() }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },

      updateShippingSummary: function (markup) {
        if (!markup) {
          return;
        }
        // Replace every shipping-summary anchor on the page (cart drawer + cart
        // page) with the freshly server-rendered summary for the new cart total.
        document.querySelectorAll('[data-cart-drawer-shipping-summary]').forEach(function (el) {
          el.innerHTML = markup.innerHTML;

          // The replaced fill is created already at its final width, so it would
          // "jump". Inside the drawer, re-trigger the grow animation: pin it to
          // scaleX(0), let that frame paint (transform is composited, so a layout
          // reflow isn't enough — wait two frames), then release it so the CSS
          // transition animates up to the new value.
          if (el.closest('.cart-drawer')) {
            var fill = el.querySelector('.cart-drawer-shipping-summary__progress-fill');
            if (fill) {
              fill.style.transform = 'scaleX(0)';
              window.requestAnimationFrame(function () {
                window.requestAnimationFrame(function () {
                  fill.style.transform = '';
                });
              });
            }
          }
        });
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }

        theme.cart.changeItem(key, qty)
          .then(function (cart) {

            const parsedCart = JSON.parse(cart);

            if (parsedCart.status === 422) {
              alert(parsedCart.message);
            } else {
              const updatedItem = parsedCart.items.find(item => item.key === key);

              // Update cartItemsUpdated property on object so we can reference later
              if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                this.cartItemsUpdated = true;
              }

              if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                if (updatedItem.quantity !== qty) {
                }
                // Reset property on object so that checkout button will work as usual
                this.cartItemsUpdated = false;
              }

              if (parsedCart.item_count > 0) {
                this.wrapper.classList.remove('is-empty');
              } else {
                this.wrapper.classList.add('is-empty');
              }
            }

            this.buildCart();

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: parsedCart
              }
            }));
          }.bind(this))
          .catch(function (err) {
            // The item row was left in a loading state and the failure was
            // silent — clear the state and tell the shopper, matching the
            // alert the 422 path already uses. Always the localized string:
            // err.message here can be a raw parse/DOM error (e.g. a 200 with
            // a non-JSON body rejects into this same catch), which must
            // never reach the shopper.
            if (el) {
              el.classList.remove('is-loading');
            }
            console.error('Cart update failed:', err);
            alert(theme.strings.cartUpdateError || 'Something went wrong. Please try again.');
          });
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },

      updateCount: function (count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');

        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }

        // Drawer footer "X items in your cart" text — server-rendered only,
        // so keep it in sync on every cart change (was stuck at the page-load value).
        var itemCount = parseInt(count, 10) || 0;
        document.querySelectorAll('[data-cart-item-count-text]').forEach(function (el) {
          el.innerHTML = '<span class="sans-serif-number">' + itemCount + '</span> ' + (itemCount === 1 ? 'item' : 'items') + ' in your cart';
        });

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);

        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }

        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {

        container.style.height = height + 'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.style.height = 'auto';
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
      listVisible: 'disclosure-list--visible'
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });

    return Disclosure;
  })();

  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.nodes = {
        page: document.querySelector('#MainContent')
      };

      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function () {
          this.close();
        }.bind(this));
      },

      open: function (evt, returnFocusEl, skipTransition) {
        if (evt) {
          evt.preventDefault();
        }

        // Sync drawer reference in case DOM was updated
        var currentDrawer = document.querySelector('#' + this.config.id);
        if (currentDrawer && currentDrawer !== this.drawer) {
          this.drawer = currentDrawer;
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        if (skipTransition) {
          this.drawer.classList.add(this.config.activeDrawer);
        } else {
          theme.utils.prepareTransition(this.drawer, function () {
            this.drawer.classList.add(this.config.activeDrawer);
          }.bind(this));
        }

        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

        this.bindEvents();
      },

      close: function (evt) {
        if (!this.isOpen) {
          return;
        }

        if (evt && evt.composedPath) {
          var eventPath = evt.composedPath();
          if (eventPath && eventPath.indexOf(this.drawer) !== -1) {
            if (!evt.target.closest('.js-drawer-close')) {
              return;
            }
          }
        }

        if (evt && this.config.id === 'FilterDrawer') {
          if (
            evt.target.closest('.filter-form') ||
            evt.target.closest('.tag-list--active-tags') ||
            evt.target.closest('.collection-filter')
          ) {
            return;
          }
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }

        // deselect any focused form elements
        document.activeElement.blur();

        theme.utils.prepareTransition(this.drawer, function () {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);

        window.setTimeout(function () {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        this.unbindEvents();
      },

      bindEvents: function () {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function (evt) {
          this.close(evt)
          return;
        }.bind(this));

        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function () {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);

        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });

    return Drawers;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector('.modal__inner');

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function () {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        evt.currentTarget.setAttribute('aria-expanded', 'true');
        this.activeSource = evt.currentTarget;
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      }, 100);


      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(function () {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false');
          this.activeSource.focus();
        }
      }.bind(this), 500); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on('keyup.modal', function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();

  /*============================================================================
    ParallaxImage
  ==============================================================================*/

  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [1, 0],
        90: [0, -1],
        180: [-1, 0],
        270: [0, 1]
      }

      this.init();
      window.addEventListener('scroll', () => this.scrollHandler());
    }

    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;

      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));

      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);

      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px

      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360

      const toLeft = angle > 90 && angle < 270;
      const toTop = angle < 180;

      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop ? 'top' : 'bottom'] = 0;

      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [Math.cos(radians), Math.sin(radians) * -1] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }

      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;

      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }

    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();;

      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;

      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }

      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }

    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }

      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }

  customElements.define('parallax-image', ParallaxImage);

  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };

    function PriceRange(container, { onChange, onUpdate, ...sliderOptions } = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }

        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat,
          );

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function () {
    var status = {
      loading: false
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : '.add-to-cart';

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');

        status.loading = true;

        var data = theme.utils.serialize(this.form);
        var quantityInput = this.form.querySelector('[name="quantity"]');
        var quantityAdded = quantityInput ? parseInt(quantityInput.value, 10) : 1;

        if (!quantityAdded || quantityAdded < 1) {
          quantityAdded = 1;
        }

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(response => response.json())
          .then(function (data) {
            if (data.status === 422) {
              this.error(data);
            } else {
              var product = data;
              this.success(product, quantityAdded);
            }

            status.loading = false;
            this.addToCart.classList.remove('btn--loading');

            // Reload page if adding product from a section on the cart page
            if (document.body.classList.contains('template-cart')) {
              window.scrollTo(0, 0);
              location.reload();
            }
          }.bind(this));
      },

      success: function (product, quantityAdded) {
        // Pre-warm the cart-toast thumbnail (same URL/size the toast uses) the
        // moment the add succeeds, so it's already cached when the toast renders.
        try {
          var toastImgSrc = (product && product.featured_image && product.featured_image.url) || (product && product.image) || '';
          if (toastImgSrc && theme.Images && typeof theme.Images.getSizedImageUrl === 'function') {
            var warmImg = new Image();
            warmImg.fetchPriority = 'high';
            warmImg.src = theme.Images.getSizedImageUrl(toastImgSrc, '180x225') || toastImgSrc;
          }
        } catch (e) {}

        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        if (theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
        }

        this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            quantityAdded: quantityAdded,
            addToCartBtn: this.addToCart
          },
          bubbles: true
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              quantityAdded: quantityAdded,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');

        if (typeof error.description === 'object') {
          errorDiv.textContent = error.message;
        } else {
          errorDiv.textContent = error.description;
        }

        this.form.append(errorDiv);

        this.form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          },
          bubbles: true
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });

    return ProductForm;
  })();

  /*============================================================================
    Pre-warm the cart "item added" toast thumbnail on the product page.
    Once a shopper is viewing a product we fetch that product/variant image at
    the exact size the toast uses, so if they add to cart the thumbnail is
    already cached and shows instantly. Re-warms on each variant change.
  ==============================================================================*/
  (function () {
    function toastSizedUrl(src) {
      if (!src) return '';
      if (theme.Images && typeof theme.Images.getSizedImageUrl === 'function') {
        return theme.Images.getSizedImageUrl(src, '180x225') || src;
      }
      return src;
    }

    function warmImage(src) {
      var url = toastSizedUrl(src);
      if (!url) return;
      var img = new Image();
      // Low priority so it never competes with the product page's own images.
      img.fetchPriority = 'low';
      img.decoding = 'async';
      img.src = url;
    }

    function imageSrcFromVariant(variant) {
      if (!variant || !variant.featured_image) return '';
      var fi = variant.featured_image;
      if (typeof fi === 'string') return fi;
      return fi.src || fi.url || '';
    }

    // Warm on every variant selection.
    document.addEventListener('variant:change', function (evt) {
      if (evt.detail && evt.detail.variant) {
        warmImage(imageSrcFromVariant(evt.detail.variant));
      }
    });

    // Warm the initial/default variant once the product page is ready.
    function warmInitial() {
      try {
        var currentEl = document.querySelector('[data-current-variant-json]');
        if (currentEl && currentEl.textContent.trim()) {
          warmImage(imageSrcFromVariant(JSON.parse(currentEl.textContent)));
          return;
        }
        var variantsEl = document.querySelector('[data-variant-json]');
        if (variantsEl && variantsEl.textContent.trim()) {
          var variants = JSON.parse(variantsEl.textContent);
          if (Array.isArray(variants) && variants.length) {
            warmImage(imageSrcFromVariant(variants[0]));
          }
        }
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', warmInitial);
    } else {
      warmInitial();
    }
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };

      });

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);

      theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector('#ModelJson-' + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener('mediaVisible', function (event) {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        if (!event.detail.autoplayMedia) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener('mediaHidden', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });

      model.container.addEventListener('xrLaunch', function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        this.plus.addEventListener('click', function () {
          var qty = this._getQty();
          this._change(qty + 1);
        }.bind(this));

        this.minus.addEventListener('click', function () {
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));

        this.input.addEventListener('change', function (evt) {
          this._change(this._getQty());
        }.bind(this));
      },

      _getQty: function () {
        var qty = this.input.value;
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });

    return QtySelector;
  })();

  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
      product.addEventListener('focusin', productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        el.removeEventListener('focusin', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');

        if (!holder) {
          return;
        }

        holder.innerHTML = '';
        holder.append(div);

        // Setup quick view modal
        var modalId = 'QuickShopModal-' + productId;
        var name = 'quick-modal-' + productId;
        new theme.Modals(modalId, name);

        // Register product template inside quick view
        theme.sections.register('product', theme.Product, holder);

        // Register collapsible elements
        theme.collapsibles.init();

        // Register potential video modal links (when video has sound)
        theme.videoModal();

        if (btn) {
          btn.classList.remove('quick-product__btn--not-ready');
        }
      });
  };

  /* Product card quick add start */
  (function () {
    const QUICK_ADD_MOBILE_MEDIA_QUERY = '(max-width: 768px)';
    const selectors = {
      open: '[data-quick-add-open]',
      modal: '[data-quick-add-modal]',
      template: '[data-quick-add-template]',
      shell: '[data-quick-add-shell]',
      close: '[data-quick-add-close]',
      optionState: '[data-quick-add-option-state]',
      optionLabel: '[data-quick-add-option-label]',
      quickAddVariants: '[data-quick-add-variants]',
      lengthOption: '[data-quick-add-length-option]',
      sizeOption: '[data-quick-add-size-option]',
      lengthBlock: '[data-quick-add-size-block="length"]',
      sizeBlock: '[data-quick-add-size-block="size"]',
      form: '[data-quick-add-form]',
      variantInput: '[data-quick-add-variant-id]',
      submit: '[data-quick-add-submit]',
      error: '[data-quick-add-error]',
      selectStep: '[data-quick-add-step="select"]',
      addedStep: '[data-quick-add-step="added"]',
      cartItems: '[data-quick-add-cart-items]',
      summaryTitle: '[data-quick-add-summary-title]',
      summaryMeta: '[data-quick-add-summary-meta]',
      summarySubtotal: '[data-quick-add-summary-subtotal]',
      remove: '[data-quick-add-remove]',
      matchingWrap: '.product-card-quick-add__matching-wrap',
      matchingTrack: '[data-quick-add-matching-track]',
      matchingCard: '[data-quick-add-matching-card]',
      matchingCount: '[data-quick-add-matching-count]',
      matchingPanel: '[data-quick-add-matching-panel]',
      matchingOption: '[data-quick-add-matching-option]',
      matchingOptionLabel: '[data-quick-add-matching-option-label]',
      matchingAdd: '[data-quick-add-matching-add]',
      matchingError: '[data-quick-add-matching-error]',
      matchingResetStep: '[data-quick-add-matching-reset-step]',
      matchingVariants: '[data-quick-add-matching-variants]',
      matchingPrice: '[data-quick-add-matching-price]'
    };

    let quickAddScrollY = 0;
    const quickAddMarkupCache = new Map();
    const quickAddMarkupRequests = new Map();
    let quickAddShell = null;
    let activeModal = null;
    let activeOpenToken = 0;
    let quickAddCartRefreshQueue = Promise.resolve();
    let quickAddTouchBlocker = null;
    let quickAddBodyStyles = null;

    function isQuickAddMobileViewport() {
      return typeof window.matchMedia !== 'function' || window.matchMedia(QUICK_ADD_MOBILE_MEDIA_QUERY).matches;
    }

    function ensureQuickAddShell() {
      if (quickAddShell && document.body.contains(quickAddShell)) {
        return quickAddShell;
      }

      quickAddShell = document.querySelector(selectors.shell);
      return quickAddShell;
    }

    function shouldPrefetchQuickAdd() {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

      if (!connection) {
        return true;
      }

      if (connection.saveData) {
        return false;
      }

      return !['slow-2g', '2g'].includes(connection.effectiveType);
    }

    function getQuickAddRequestUrl(productHandle) {
      const basePath = (theme.routes && theme.routes.home ? theme.routes.home : '/').replace(/\/$/, '');
      const handle = String(productHandle || '').replace(/^\/+/, '');

      return `${basePath}/products/${handle}?view=quick-add` || `/products/${handle}?view=quick-add`;
    }

    function cloneQuickAddTemplate(productId) {
      const template = document.querySelector(`${selectors.template}[data-product-id="${productId}"]`);

      if (!template || !template.content) {
        return null;
      }

      const fragment = template.content.cloneNode(true);
      return fragment.querySelector(selectors.modal);
    }

    function injectQuickAddMarkup(markup) {
      const shell = ensureQuickAddShell();

      if (!shell || !markup) {
        return null;
      }

      const wrapper = document.createElement('div');
      wrapper.innerHTML = markup.trim();

      const modal = wrapper.querySelector(selectors.modal);
      if (!modal) {
        return null;
      }

      shell.innerHTML = '';
      shell.appendChild(modal);
      initModal(modal);

      return modal;
    }

    function mountQuickAddModal(productId) {
      const shell = ensureQuickAddShell();
      const modal = cloneQuickAddTemplate(productId);

      if (!shell || !modal) {
        return null;
      }

      shell.innerHTML = '';
      shell.appendChild(modal);
      initModal(modal);

      return modal;
    }

    function fetchQuickAddMarkup(productHandle) {
      if (!productHandle) {
        return Promise.resolve('');
      }

      if (quickAddMarkupCache.has(productHandle)) {
        return Promise.resolve(quickAddMarkupCache.get(productHandle));
      }

      if (quickAddMarkupRequests.has(productHandle)) {
        return quickAddMarkupRequests.get(productHandle);
      }

      const request = fetch(getQuickAddRequestUrl(productHandle), {
        credentials: 'same-origin',
        method: 'GET'
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Quick add request failed: ${response.status}`);
          }

          return response.text();
        })
        .then((markup) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = markup;
          const modal = wrapper.querySelector(selectors.modal);
          const modalMarkup = modal ? modal.outerHTML : '';

          if (modalMarkup) {
            quickAddMarkupCache.set(productHandle, modalMarkup);
          }

          return modalMarkup;
        })
        .finally(() => {
          quickAddMarkupRequests.delete(productHandle);
        });

      quickAddMarkupRequests.set(productHandle, request);
      return request;
    }

    function warmQuickAddMarkup(productHandle) {
      if (!productHandle || !shouldPrefetchQuickAdd()) {
        return Promise.resolve('');
      }

      return fetchQuickAddMarkup(productHandle).catch(() => '');
    }

    function loadQuickAddModal(productId, productHandle, trigger) {
      const openToken = ++activeOpenToken;

      if (productHandle && quickAddMarkupCache.has(productHandle)) {
        const cachedModal = injectQuickAddMarkup(quickAddMarkupCache.get(productHandle));
        if (cachedModal) {
          openModal(cachedModal, trigger);
          return Promise.resolve(cachedModal);
        }
      }

      const templateModal = mountQuickAddModal(productId);
      if (templateModal) {
        openModal(templateModal, trigger);

        if (productHandle) {
          warmQuickAddMarkup(productHandle);
        }

        return Promise.resolve(templateModal);
      }

      if (!productHandle) {
        return Promise.resolve(null);
      }

      return fetchQuickAddMarkup(productHandle)
        .then((markup) => {
          if (!markup || openToken !== activeOpenToken) {
            return null;
          }

          const remoteModal = injectQuickAddMarkup(markup);
          if (remoteModal) {
            openModal(remoteModal, trigger);
          }

          return remoteModal;
        })
        .catch(() => null);
    }

    function lockPageScroll() {
      if (document.body.classList.contains('quick-add-open')) {
        return;
      }

      quickAddScrollY = window.scrollY || window.pageYOffset || 0;
      quickAddBodyStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width
      };
      document.documentElement.classList.add('quick-add-open');
      document.body.classList.add('quick-add-open');

      document.body.style.position = 'fixed';
      document.body.style.top = `-${quickAddScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      if (!isQuickAddMobileViewport()) {
        return;
      }

      quickAddTouchBlocker = function (event) {
        if (!event.target.closest('.product-card-quick-add-modal__dialog')) {
          event.preventDefault();
        }
      };

      document.addEventListener('touchmove', quickAddTouchBlocker, { passive: false });
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('quick-add-open');
      document.body.classList.remove('quick-add-open');

      if (quickAddTouchBlocker) {
        document.removeEventListener('touchmove', quickAddTouchBlocker, { passive: false });
        quickAddTouchBlocker = null;
      }

      const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10)) || quickAddScrollY;
      document.body.style.position = quickAddBodyStyles ? quickAddBodyStyles.position : '';
      document.body.style.top = quickAddBodyStyles ? quickAddBodyStyles.top : '';
      document.body.style.left = quickAddBodyStyles ? quickAddBodyStyles.left : '';
      document.body.style.right = quickAddBodyStyles ? quickAddBodyStyles.right : '';
      document.body.style.width = quickAddBodyStyles ? quickAddBodyStyles.width : '';
      quickAddBodyStyles = null;
      quickAddScrollY = 0;

      window.requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });
    }

    function parseOptionalIndex(value) {
      if (value === '' || value === undefined || value === null) {
        return null;
      }

      const parsedValue = Number(value);
      return Number.isNaN(parsedValue) ? null : parsedValue;
    }

    function formatMoney(cents) {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }

      return `$${(cents / 100).toFixed(2)}`;
    }

    function setMoneyContent(element, cents) {
      if (!element) {
        return;
      }

      element.innerHTML = formatMoney(cents);
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeCssString(value) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(String(value || ''));
      }

      return String(value || '').replace(/[^a-zA-Z0-9_-]/g, '\\$&');
    }

    function updateCartBubble(count) {
      document.querySelectorAll('.cart-link__bubble-num').forEach((el) => {
        el.textContent = count > 0 ? count : '';
      });

      document.querySelectorAll('.cart-link__bubble').forEach((el) => {
        el.classList.toggle('cart-link__bubble--visible', count > 0);
      });
    }

    function isLengthOptionMeta(optionName, optionValue) {
      const normalizedName = String(optionName || '').toLowerCase();
      const normalizedValue = String(optionValue || '').toLowerCase();

      if (normalizedName.includes('length') || normalizedName.includes('leg') || normalizedName.includes('inseam')) {
        return true;
      }

      return ['short', 'regular', 'tall'].includes(normalizedValue);
    }

    function isDefaultTitleOptionMeta(optionName, optionValue) {
      return String(optionName || '').trim().toLowerCase() === 'title'
        && String(optionValue || '').trim().toLowerCase() === 'default title';
    }

    function getOptionMeta(item) {
      const propertyColor = item && item.properties && typeof item.properties._quick_add_color === 'string'
        ? item.properties._quick_add_color.trim()
        : '';

      if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
        const colorOption = item.options_with_values.find((option) => /colou?r/i.test(option.name || ''));
        const colorValue = colorOption && colorOption.value ? colorOption.value : propertyColor;
        const details = [];
        let sizeDetail = null;
        let lengthDetail = null;

        item.options_with_values.forEach((option) => {
          const optionName = option && option.name ? option.name : '';
          const optionValue = option && option.value ? option.value : '';

          if (/colou?r/i.test(optionName)) {
            return;
          }

          if (isDefaultTitleOptionMeta(optionName, optionValue)) {
            return;
          }

          if (!sizeDetail && /size/i.test(optionName)) {
            sizeDetail = {
              label: optionName,
              value: optionValue
            };
            return;
          }

          if (!lengthDetail && isLengthOptionMeta(optionName, optionValue)) {
            lengthDetail = {
              label: optionName,
              value: optionValue
            };
            return;
          }

          details.push({
            label: escapeHtml(optionName),
            value: escapeHtml(optionValue)
          });
        });

        if (sizeDetail && lengthDetail) {
          details.unshift({
            label: escapeHtml(sizeDetail.label),
            value: `${escapeHtml(sizeDetail.value)} (${escapeHtml(lengthDetail.value)})`
          });
        } else if (sizeDetail) {
          details.unshift({
            label: escapeHtml(sizeDetail.label),
            value: escapeHtml(sizeDetail.value)
          });
        } else if (lengthDetail) {
          details.unshift({
            label: escapeHtml(lengthDetail.label),
            value: escapeHtml(lengthDetail.value)
          });
        }

        return {
          color: colorValue ? escapeHtml(colorValue) : '',
          details
        };
      }

      if (item.variant_title && item.variant_title !== 'Default Title') {
        return {
          color: propertyColor ? escapeHtml(propertyColor) : '',
          details: item.variant_title.split(' / ').map((value) => ({
            label: '',
            value: escapeHtml(value)
          }))
        };
      }

      return {
        color: propertyColor ? escapeHtml(propertyColor) : '',
        details: []
      };
    }

    function renderOptionMeta(item) {
      const optionMeta = getOptionMeta(item);
      const metaLines = [];

      if (optionMeta.color) {
        metaLines.push(`<div class="product-card-quick-add__cart-item-meta-color">Color: ${optionMeta.color}</div>`);
      }

      optionMeta.details.forEach((detail) => {
        const label = detail.label ? `${detail.label}: ` : '';
        metaLines.push(`<div class="product-card-quick-add__cart-item-meta-detail">${label}${detail.value}</div>`);
      });

      return metaLines.join('');
    }

    function cartItemImage(item) {
      if (item.featured_image && item.featured_image.url) {
        return item.featured_image.url;
      }

      if (item.image) {
        return item.image;
      }

      return '';
    }

    function getQuickAddItemUnitPrice(item) {
      if (!item) {
        return 0;
      }

      if (typeof item.final_price === 'number') {
        return item.final_price;
      }

      if (typeof item.price === 'number') {
        return item.price;
      }

      if (typeof item.final_line_price === 'number' && typeof item.quantity === 'number' && item.quantity > 0) {
        return Math.round(item.final_line_price / item.quantity);
      }

      return 0;
    }

    function createQuickAddSessionEntry(item, quantityAdded) {
      const addedQuantity = Math.max(1, Number(quantityAdded) || 1);

      return {
        sessionEntryId: `qa-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        key: item && item.key ? String(item.key) : '',
        quantityAdded: addedQuantity,
        product_title: item && item.product_title ? item.product_title : '',
        featured_image: item && item.featured_image ? item.featured_image : null,
        image: item && item.image ? item.image : '',
        options_with_values: Array.isArray(item && item.options_with_values) ? item.options_with_values : [],
        variant_title: item && item.variant_title ? item.variant_title : '',
        properties: item && item.properties ? item.properties : null,
        final_price: getQuickAddItemUnitPrice(item)
      };
    }

    function resetQuickAddSession(modal) {
      modal.__quickAddSessionEntries = [];
    }

    function rememberQuickAddItems(modal, data, quantityAdded) {
      if (!modal) {
        return;
      }

      if (!Array.isArray(modal.__quickAddSessionEntries)) {
        resetQuickAddSession(modal);
      }

      if (Array.isArray(data && data.items)) {
        data.items.forEach((item) => {
          if (item) {
            modal.__quickAddSessionEntries.push(createQuickAddSessionEntry(item, quantityAdded));
          }
        });
        return;
      }

      if (data) {
        modal.__quickAddSessionEntries.push(createQuickAddSessionEntry(data, quantityAdded));
      }
    }

    function forgetQuickAddItem(modal, sessionEntryId) {
      if (!modal || !Array.isArray(modal.__quickAddSessionEntries) || !sessionEntryId) {
        return;
      }

      modal.__quickAddSessionEntries = modal.__quickAddSessionEntries.filter((entry) => entry.sessionEntryId !== String(sessionEntryId));
    }

    function getQuickAddSessionItems(modal) {
      if (!modal || !Array.isArray(modal.__quickAddSessionEntries) || !modal.__quickAddSessionEntries.length) {
        return [];
      }

      return modal.__quickAddSessionEntries.slice();
    }

    function renderCartItems(modal, cart) {
      const itemsContainer = modal.querySelector(selectors.cartItems);
      const title = modal.querySelector(selectors.summaryTitle);
      const meta = modal.querySelector(selectors.summaryMeta);
      const subtotal = modal.querySelector(selectors.summarySubtotal);

      if (!itemsContainer || !title || !meta || !subtotal) {
        return;
      }

      const sessionItems = getQuickAddSessionItems(modal);
      const sessionItemCount = sessionItems.reduce((total, item) => total + (Number(item.quantityAdded) || 0), 0);
      const sessionSubtotal = sessionItems.reduce((total, item) => total + ((Number(item.final_price) || 0) * (Number(item.quantityAdded) || 0)), 0);

      itemsContainer.innerHTML = sessionItems.map((item) => {
        const image = cartItemImage(item);
        const metaHtml = renderOptionMeta(item);
        const linePrice = (Number(item.final_price) || 0) * (Number(item.quantityAdded) || 0);

        return `<div class="product-card-quick-add__cart-item">
                <div class="product-card-quick-add__cart-item-image">${image ? `<img src="${image}" alt="${escapeHtml(item.product_title)}">` : ''}</div>
                <div class="product-card-quick-add__cart-item-copy">
                    <div class="product-card-quick-add__cart-item-title">${escapeHtml(item.product_title)}</div>
                    <div class="product-card-quick-add__cart-item-meta">${metaHtml}</div>
                    <div class="product-card-quick-add__cart-item-price">${formatMoney(linePrice)}</div>
                </div>
                <button type="button" class="product-card-quick-add__cart-item-remove" id="QuickAddRemoveButton-${item.key}" data-quick-add-remove data-key="${item.key}" data-session-entry-id="${item.sessionEntryId}">Remove</button>
            </div>`;
      }).join('');

      const label = sessionItemCount === 1 ? '1 Item Added' : `${sessionItemCount} Items Added`;
      title.textContent = label;
      meta.textContent = `${sessionItemCount} item${sessionItemCount === 1 ? '' : 's'} added`;
      subtotal.innerHTML = `Subtotal: ${formatMoney(sessionSubtotal)}`;
    }

    function switchStep(modal, step) {
      const selectStep = modal.querySelector(selectors.selectStep);
      const addedStep = modal.querySelector(selectors.addedStep);

      if (!selectStep || !addedStep) {
        return;
      }

      const isAdded = step === 'added';
      selectStep.hidden = isAdded;
      addedStep.hidden = !isAdded;

      [selectStep, addedStep].forEach((stepElement) => {
        if (!stepElement) {
          return;
        }

        stepElement.scrollTop = 0;

        const body = stepElement.querySelector('.product-card-quick-add__body');
        if (body) {
          body.scrollTop = 0;
        }
      });
    }

    function scrollQuickAddBodyToTop(stepElement) {
      if (!stepElement) {
        return;
      }

      stepElement.scrollTop = 0;

      const body = stepElement.querySelector('.product-card-quick-add__body');
      if (!body) {
        return;
      }

      body.scrollTop = 0;

      if (typeof body.scrollTo === 'function') {
        body.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }

      window.requestAnimationFrame(() => {
        body.scrollTop = 0;
      });
    }

    function refreshCartUi() {
      if (document.dispatchEvent) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }

    function fetchCart() {
      return fetch(theme.routes.cart, {
        credentials: 'same-origin',
        method: 'GET'
      }).then((response) => response.json());
    }

    function queueCartRefresh() {
      quickAddCartRefreshQueue = quickAddCartRefreshQueue
        .catch(() => null)
        .then(() => fetchCart());

      return quickAddCartRefreshQueue;
    }

    function addLineItem(variantId, quantity) {
      const params = new URLSearchParams();
      params.set('id', variantId);
      params.set('quantity', quantity || 1);

      return fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: params.toString(),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      }).then((response) => {
        // 422 bodies are JSON and handled by callers via data.status; only a
        // non-JSON failure (5xx/HTML) needs converting into a readable error.
        return response.json().catch(() => {
          throw new Error(theme.strings.cartUpdateError || 'Cart request failed (' + response.status + ')');
        });
      });
    }

    function ensureMatchingSetLoaded(modal) {
      // HEAVY-PAGE RENDER FIX: the "Complete your look" matching set is no
      // longer server-rendered inside every card's quick-add template (it
      // dereferenced ~4 full products + variants|json per card, ~140
      // product loads per collection page — a Liquid-budget blowout on
      // big catalogs). It's fetched once per modal from the
      // quick-add-matching-set section, prefetched on modal open so it's
      // ready before the shopper reaches the added step.
      const lazy = modal.querySelector('[data-quick-add-matching-lazy]');

      if (!lazy) {
        return Promise.resolve();
      }

      if (lazy.__quickAddMatchingPromise) {
        return lazy.__quickAddMatchingPromise;
      }

      const productUrl = lazy.dataset.productUrl || '';

      if (!productUrl) {
        return Promise.resolve();
      }

      const joiner = productUrl.indexOf('?') === -1 ? '?' : '&';

      lazy.__quickAddMatchingPromise = fetch(productUrl + joiner + 'section_id=quick-add-matching-set')
        .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const wrap = doc.querySelector('.product-card-quick-add__matching-wrap');

          if (!lazy.parentNode) {
            return;
          }

          if (wrap) {
            lazy.parentNode.replaceChild(wrap, lazy);
            wrap.querySelectorAll(selectors.matchingCard).forEach((card) => bindMatchingCard(modal, card));
          } else {
            lazy.remove();
          }
        })
        .catch(() => {
          // allow a retry on the next call
          lazy.__quickAddMatchingPromise = null;
        });

      return lazy.__quickAddMatchingPromise;
    }

    function syncMatchingSetWithCart(modal, cart) {
      const wrap = modal.querySelector(selectors.matchingWrap);
      const track = modal.querySelector(selectors.matchingTrack);

      if (!wrap || !track || !cart || !Array.isArray(cart.items)) {
        return;
      }

      const cartProductIds = new Set(
        cart.items
          .map((item) => item && item.product_id)
          .filter((productId) => productId !== undefined && productId !== null)
          .map((productId) => String(productId))
      );

      let visibleCardsCount = 0;

      track.querySelectorAll(selectors.matchingCard).forEach((card) => {
        const productId = card.dataset.productId || '';
        const isInCart = productId && cartProductIds.has(productId);

        card.hidden = Boolean(isInCart);
        card.classList.remove('is-last-visible');

        if (!card.hidden) {
          visibleCardsCount += 1;
        }
      });

      const visibleCards = Array.from(track.querySelectorAll(selectors.matchingCard)).filter((card) => !card.hidden);

      if (visibleCards.length > 1) {
        visibleCards[visibleCards.length - 1].classList.add('is-last-visible');
      }

      wrap.hidden = visibleCardsCount === 0;

      if (visibleCardsCount > 0) {
        track.scrollLeft = 0;
      }

      updateMatchingCount(modal);
    }

    function getQuickAddOptionState(modal) {
      const container = modal.querySelector(selectors.optionState);

      if (!container) {
        return null;
      }

      if (container.__quickAddOptionState) {
        return container.__quickAddOptionState;
      }

      let variants = [];
      let defaultSelections = [];

      try {
        const variantsJson = container.querySelector(selectors.quickAddVariants);
        variants = JSON.parse(variantsJson ? variantsJson.textContent : '[]');
      } catch (error) {
        variants = [];
      }

      try {
        defaultSelections = JSON.parse(container.dataset.defaultSelections || '[]');
      } catch (error) {
        defaultSelections = [];
      }

      container.__quickAddOptionState = {
        variants,
        defaultSelections,
        primaryOptionIndex: parseOptionalIndex(container.dataset.primaryOptionIndex),
        secondaryOptionIndex: parseOptionalIndex(container.dataset.secondaryOptionIndex),
        primaryOptionLabel: container.dataset.primaryOptionLabel || 'Length',
        secondaryOptionLabel: container.dataset.secondaryOptionLabel || 'Size',
        selections: defaultSelections.slice()
      };

      return container.__quickAddOptionState;
    }

    function resetQuickAddSelections(state) {
      if (!state) {
        return;
      }

      state.selections = state.defaultSelections.slice();

      if (state.primaryOptionIndex !== null) {
        state.selections[state.primaryOptionIndex] = '';
      }

      if (state.secondaryOptionIndex !== null) {
        state.selections[state.secondaryOptionIndex] = '';
      }
    }

    function resolveQuickAddVariant(state) {
      if (!state) {
        return null;
      }

      return state.variants.find((variant) => {
        if (!variant.available) {
          return false;
        }

        return variant.options.every((optionValue, index) => {
          const selectedValue = state.selections[index];
          return !selectedValue || selectedValue === optionValue;
        });
      }) || null;
    }

    function variantMatchesSelections(variant, state, nextIndex, nextValue) {
      if (!variant.available) {
        return false;
      }

      return variant.options.every((optionValue, index) => {
        if (index === nextIndex) {
          return optionValue === nextValue;
        }

        const selectedValue = state.selections[index];
        return !selectedValue || selectedValue === optionValue;
      });
    }

    function getQuickAddSelectionPrompt(type) {
      return type === 'length' ? 'Select Length' : 'Select Size';
    }

    function updateQuickAddOptionLabel(modal, primarySelected, secondarySelected) {
      const label = modal.querySelector(selectors.optionLabel);
      const lengthBlock = modal.querySelector(selectors.lengthBlock);
      const sizeBlock = modal.querySelector(selectors.sizeBlock);
      const hasLengthStep = Boolean(lengthBlock);
      const hasSizeStep = Boolean(sizeBlock);
      const isSequentialFlow = hasLengthStep && hasSizeStep;

      if (lengthBlock) {
        lengthBlock.hidden = isSequentialFlow && Boolean(primarySelected);
      }

      if (sizeBlock) {
        sizeBlock.hidden = isSequentialFlow ? !primarySelected : false;
      }

      if (!label) {
        return;
      }

      if (isSequentialFlow) {
        if (!primarySelected) {
          label.textContent = 'Select Length:';
          return;
        }

        if (!secondarySelected) {
          label.innerHTML = `<span class="product-card-quick-add__option-label-copy"><span class="product-card-quick-add__option-label-value">${escapeHtml(primarySelected)}</span> - Select Size:</span><button type="button" class="product-card-quick-add__option-reset" data-quick-add-reset-primary aria-label="Change length"><svg aria-hidden="true" focusable="false" role="presentation" class="product-card-quick-add__option-reset-icon icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg></button>`;
          return;
        }

        label.innerHTML = `<span class="product-card-quick-add__option-label-copy"><span class="product-card-quick-add__option-label-value">${escapeHtml(primarySelected)}</span> - ${escapeHtml(secondarySelected)}</span><button type="button" class="product-card-quick-add__option-reset" data-quick-add-reset-primary aria-label="Change length"><svg aria-hidden="true" focusable="false" role="presentation" class="product-card-quick-add__option-reset-icon icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg></button>`;
        return;
      }

      if (hasLengthStep) {
        label.innerHTML = primarySelected
          ? `<span class="product-card-quick-add__option-label-copy">Select Length: <span class="product-card-quick-add__option-label-value">${escapeHtml(primarySelected)}</span></span>`
          : 'Select Length:';
        return;
      }

      if (hasSizeStep) {
        label.innerHTML = secondarySelected || primarySelected
          ? `<span class="product-card-quick-add__option-label-copy">Select Size: <span class="product-card-quick-add__option-label-value">${escapeHtml(secondarySelected || primarySelected)}</span></span>`
          : 'Select Size:';
      }
    }

    function updateQuickAddOptions(modal) {
      const form = modal.querySelector(selectors.form);
      const submit = modal.querySelector(selectors.submit);
      const variantInput = modal.querySelector(selectors.variantInput);
      const state = getQuickAddOptionState(modal);
      const lengthOptions = Array.from(modal.querySelectorAll(selectors.lengthOption));
      const sizeOptions = Array.from(modal.querySelectorAll(selectors.sizeOption));

      if (!form || !submit || !variantInput) {
        return;
      }

      if (!state) {
        if (sizeOptions.length) {
          variantInput.value = '';
          submit.disabled = true;
          submit.textContent = getQuickAddSelectionPrompt('size');
        } else if (variantInput.value) {
          submit.disabled = false;
          submit.textContent = 'Add to Cart';
        }
        return;
      }

      const hasLengthStep = lengthOptions.length > 0;
      const primarySelected = state.primaryOptionIndex !== null ? state.selections[state.primaryOptionIndex] : '';
      const secondarySelected = state.secondaryOptionIndex !== null ? state.selections[state.secondaryOptionIndex] : '';

      updateQuickAddOptionLabel(modal, primarySelected, secondarySelected);

      lengthOptions.forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const optionValue = button.dataset.optionValue || '';
        const selected = state.selections[optionIndex] === optionValue;
        button.classList.toggle('is-selected', selected);
      });

      sizeOptions.forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const optionValue = button.dataset.optionValue || '';
        const selected = state.selections[optionIndex] === optionValue;
        let isAvailable = state.variants.some((variant) => variantMatchesSelections(variant, state, optionIndex, optionValue));

        if (hasLengthStep && state.secondaryOptionIndex !== null && !primarySelected) {
          isAvailable = false;
        }

        button.classList.toggle('is-selected', selected);
        button.classList.toggle('is-disabled', !isAvailable);
        button.disabled = !isAvailable;
      });

      const variant = resolveQuickAddVariant(state);
      const needsSecondarySelection = state.secondaryOptionIndex !== null;
      const isComplete = hasLengthStep ? Boolean(primarySelected) && (!needsSecondarySelection || Boolean(secondarySelected)) : Boolean(primarySelected || variantInput.defaultValue);

      variantInput.value = isComplete && variant ? String(variant.id) : '';

      if (hasLengthStep && !primarySelected) {
        submit.disabled = true;
        submit.textContent = getQuickAddSelectionPrompt('length');
      } else if (needsSecondarySelection && !secondarySelected) {
        submit.disabled = true;
        submit.textContent = getQuickAddSelectionPrompt('size');
      } else if (variantInput.value) {
        submit.disabled = false;
        submit.textContent = 'Add to Cart';
      } else {
        submit.disabled = true;
        submit.textContent = needsSecondarySelection
          ? getQuickAddSelectionPrompt('size')
          : getQuickAddSelectionPrompt(hasLengthStep ? 'length' : 'size');
      }
    }

    function getMatchingState(card) {
      if (card.__quickAddMatchingState) {
        return card.__quickAddMatchingState;
      }

      let variants = [];
      let requiredOptionIndexes = [];
      let defaultSelections = [];

      try {
        const variantsJson = card.querySelector(selectors.matchingVariants);
        variants = JSON.parse(variantsJson ? variantsJson.textContent : '[]');
      } catch (error) {
        variants = [];
      }

      try {
        requiredOptionIndexes = JSON.parse(card.dataset.requiredOptions || '[]');
      } catch (error) {
        requiredOptionIndexes = [];
      }

      try {
        defaultSelections = JSON.parse(card.dataset.defaultSelections || '[]');
      } catch (error) {
        defaultSelections = [];
      }

      card.__quickAddMatchingState = {
        variants,
        requiredOptionIndexes,
        defaultSelections,
        primaryOptionIndex: parseOptionalIndex(card.dataset.primaryOptionIndex),
        primaryOptionLabel: card.dataset.primaryOptionLabel || '',
        secondaryOptionIndex: parseOptionalIndex(card.dataset.secondaryOptionIndex),
        secondaryOptionLabel: card.dataset.secondaryOptionLabel || '',
        currentStep: 'summary',
        selections: defaultSelections.slice()
      };

      return card.__quickAddMatchingState;
    }

    function isMatchingSelectionComplete(state) {
      return state.requiredOptionIndexes.every((index) => Boolean(state.selections[index]));
    }

    function resetDependentMatchingSelections(state, preservedIndexes) {
      state.requiredOptionIndexes.forEach((index) => {
        if (preservedIndexes.indexOf(index) === -1) {
          state.selections[index] = '';
        }
      });
    }

    function resolveMatchingVariant(state) {
      return state.variants.find((variant) => {
        if (!variant.available) {
          return false;
        }

        return variant.options.every((optionValue, index) => {
          const selectedValue = state.selections[index];
          return !selectedValue || selectedValue === optionValue;
        });
      }) || null;
    }

    function setMatchingStep(card, step) {
      const state = getMatchingState(card);
      state.currentStep = step;
      updateMatchingCard(card);
    }

    function updateMatchingCard(card) {
      const state = getMatchingState(card);
      const addButton = card.querySelector(selectors.matchingAdd);
      const error = card.querySelector(selectors.matchingError);
      const price = card.querySelector(selectors.matchingPrice);
      const hasSecondaryStep = state.secondaryOptionIndex !== null && state.secondaryOptionIndex !== state.primaryOptionIndex;
      const hasPrimaryStep = state.primaryOptionIndex !== null;
      const primarySelectedValue = state.primaryOptionIndex !== null ? state.selections[state.primaryOptionIndex] : '';
      const selectionComplete = state.requiredOptionIndexes.length === 0 || isMatchingSelectionComplete(state);
      const matchedVariant = selectionComplete ? resolveMatchingVariant(state) : null;

      card.querySelectorAll(selectors.matchingPanel).forEach((panel) => {
        const step = panel.dataset.step || 'summary';
        const label = panel.querySelector(selectors.matchingOptionLabel);
        const resetButton = panel.querySelector(selectors.matchingResetStep);
        panel.hidden = step !== state.currentStep;

        if (label) {
          const defaultLabel = label.dataset.defaultLabel || label.textContent;
          label.textContent = step === 'secondary' && primarySelectedValue ? `${primarySelectedValue} - ${defaultLabel}` : defaultLabel;
        }

        if (resetButton) {
          resetButton.hidden = step === 'summary' || (step === 'secondary' && !primarySelectedValue);
        }
      });

      card.querySelectorAll(selectors.matchingOption).forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const optionValue = button.dataset.optionValue || '';
        button.classList.toggle('is-selected', state.selections[optionIndex] === optionValue);
      });

      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      if (price) {
        if (matchedVariant && typeof matchedVariant.price === 'number') {
          setMoneyContent(price, matchedVariant.price);
        } else if (state.variants[0] && typeof state.variants[0].price === 'number') {
          setMoneyContent(price, state.variants[0].price);
        }
      }

      if (!addButton) {
        return;
      }

      addButton.disabled = false;
      addButton.textContent = addButton.dataset.defaultLabel || 'ADD';

      if (!hasPrimaryStep && matchedVariant) {
        addButton.dataset.quickAddMatchingVariantId = matchedVariant.id;
      } else {
        addButton.dataset.quickAddMatchingVariantId = '';
      }
    }

    function collapseOtherMatchingCards(modal, activeCard) {
      if (!modal) {
        return;
      }

      modal.querySelectorAll(selectors.matchingCard).forEach((card) => {
        if (card === activeCard) {
          return;
        }

        const state = getMatchingState(card);

        if (state.currentStep === 'summary') {
          return;
        }

        state.selections = state.defaultSelections.slice();
        state.currentStep = 'summary';
        updateMatchingCard(card);
      });
    }

    function resetMatchingSet(modal) {
      const track = modal.querySelector(selectors.matchingTrack);

      modal.querySelectorAll(selectors.matchingCard).forEach((card) => {
        const state = getMatchingState(card);
        state.selections = state.defaultSelections.slice();
        state.currentStep = 'summary';
        updateMatchingCard(card);
      });

      resetMatchingTrackPosition(modal);

      updateMatchingCount(modal);
    }

    function resetMatchingTrackPosition(modal) {
      const track = modal.querySelector(selectors.matchingTrack);

      if (!track) {
        return;
      }

      track.scrollLeft = 0;

      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: 0, top: 0, behavior: 'auto' });
      }

      window.requestAnimationFrame(() => {
        track.scrollLeft = 0;
        updateMatchingCount(modal);

        window.requestAnimationFrame(() => {
          track.scrollLeft = 0;
          updateMatchingCount(modal);
        });
      });
    }

    function closeModal(modal, options) {
      if (!modal) {
        return;
      }

      const settings = options || {};
      const dialog = modal.querySelector('.product-card-quick-add-modal__dialog');
      const shell = ensureQuickAddShell();
      const activeElement = document.activeElement;

      if (modal.dataset.quickAddClosing === 'true') {
        return;
      }

      modal.dataset.quickAddClosing = 'true';

      if (dialog && theme.a11y && typeof theme.a11y.removeTrapFocus === 'function') {
        theme.a11y.removeTrapFocus({
          container: dialog,
          namespace: 'quick-add'
        });
      }

      if (activeElement instanceof HTMLElement && modal.contains(activeElement)) {
        if (settings.restoreFocus !== false && modal.__quickAddTrigger && typeof modal.__quickAddTrigger.focus === 'function') {
          modal.__quickAddTrigger.focus({ preventScroll: true });
        } else if (typeof activeElement.blur === 'function') {
          activeElement.blur();
        }
      }

      modal.classList.remove('is-open');
      modal.classList.add('is-closing');
      modal.setAttribute('aria-hidden', 'true');
      modal.inert = true;

      const form = modal.querySelector(selectors.form);
      const submit = modal.querySelector(selectors.submit);
      const error = modal.querySelector(selectors.error);
      const sizeOptions = modal.querySelectorAll(selectors.sizeOption);
      const optionState = getQuickAddOptionState(modal);

      const finishClose = function () {
        if (modal.dataset.quickAddClosing !== 'true') {
          return;
        }

        delete modal.dataset.quickAddClosing;
        modal.classList.remove('is-closing');
        unlockPageScroll();
        switchStep(modal, 'select');
        resetQuickAddSession(modal);

        if (form) {
          form.reset();
          const variantInput = form.querySelector(selectors.variantInput);
          if (variantInput) {
            variantInput.value = sizeOptions.length || optionState ? '' : (variantInput.defaultValue || '');
          }
        }

        if (optionState) {
          resetQuickAddSelections(optionState);
        }

        modal.querySelectorAll(`${selectors.lengthOption}, ${selectors.sizeOption}`).forEach((button) => button.classList.remove('is-selected'));

        if (submit) {
          if (optionState) {
            updateQuickAddOptions(modal);
          } else if (sizeOptions.length) {
            submit.disabled = true;
            submit.textContent = getQuickAddSelectionPrompt('size');
          } else {
            submit.disabled = false;
            submit.textContent = 'Add to Cart';
          }
        }

        if (error) {
          error.hidden = true;
          error.textContent = '';
        }

        resetMatchingSet(modal);

        if (shell) {
          shell.hidden = true;
        }

        if (activeModal === modal) {
          activeModal = null;
        }

        if (settings.restoreFocus !== false && modal.__quickAddTrigger && typeof modal.__quickAddTrigger.focus === 'function') {
          modal.__quickAddTrigger.focus({ preventScroll: true });
        }
      };

      if (modal.__quickAddCloseTimer) {
        window.clearTimeout(modal.__quickAddCloseTimer);
      }

      const handleTransitionEnd = function (event) {
        if (event.target === dialog && event.propertyName === 'transform') {
          finishClose();
        }
      };

      if (dialog) {
        dialog.addEventListener('transitionend', handleTransitionEnd, { once: true });
      }

      modal.__quickAddCloseTimer = window.setTimeout(finishClose, 480);
    }

    function openModal(modal, trigger) {
      const shell = ensureQuickAddShell();
      const dialog = modal.querySelector('.product-card-quick-add-modal__dialog');
      const focusTarget = modal.querySelector('.product-card-quick-add__close') || dialog;

      if (activeModal && activeModal !== modal) {
        closeModal(activeModal, { restoreFocus: false });
      }

      modal.__quickAddTrigger = trigger || modal.__quickAddTrigger || null;
      resetQuickAddSession(modal);
      resetMatchingSet(modal);
      modal.classList.remove('is-closing');
      delete modal.dataset.quickAddClosing;

      if (modal.__quickAddCloseTimer) {
        window.clearTimeout(modal.__quickAddCloseTimer);
        modal.__quickAddCloseTimer = null;
      }

      if (shell) {
        shell.hidden = false;
      }

      modal.inert = false;
      modal.setAttribute('aria-hidden', 'false');
      activeModal = modal;
      lockPageScroll();
      switchStep(modal, 'select');
      ensureMatchingSetLoaded(modal);

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          modal.classList.add('is-open');
          updateMatchingCount(modal);

          if (dialog && theme.a11y && typeof theme.a11y.trapFocus === 'function') {
            theme.a11y.trapFocus({
              container: dialog,
              elementToFocus: focusTarget,
              namespace: 'quick-add'
            });
          }
        });
      });
    }

    function bindSizeOptions(modal) {
      const form = modal.querySelector(selectors.form);
      const submit = modal.querySelector(selectors.submit);
      const variantInput = modal.querySelector(selectors.variantInput);
      const optionLabel = modal.querySelector(selectors.optionLabel);
      const state = getQuickAddOptionState(modal);

      if (!form || !submit || !variantInput) {
        return;
      }

      if (state) {
        resetQuickAddSelections(state);
      }

      if (optionLabel) {
        optionLabel.addEventListener('click', (event) => {
          const resetButton = event.target.closest('[data-quick-add-reset-primary]');

          if (!resetButton || !state || state.primaryOptionIndex === null) {
            return;
          }

          event.preventDefault();
          state.selections[state.primaryOptionIndex] = '';

          if (state.secondaryOptionIndex !== null) {
            state.selections[state.secondaryOptionIndex] = '';
          }

          variantInput.value = '';
          updateQuickAddOptions(modal);

          const firstLengthOption = modal.querySelector(`${selectors.lengthOption}:not(:disabled)`);
          if (firstLengthOption && typeof firstLengthOption.focus === 'function') {
            firstLengthOption.focus();
          }
        });
      }

      modal.querySelectorAll(selectors.lengthOption).forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) {
            return;
          }

          const optionIndex = Number(button.dataset.optionIndex);
          const optionValue = button.dataset.optionValue || '';

          state.selections[optionIndex] = optionValue;

          if (state.secondaryOptionIndex !== null) {
            state.selections[state.secondaryOptionIndex] = '';
          }

          updateQuickAddOptions(modal);
        });
      });

      const sizeOptions = modal.querySelectorAll(selectors.sizeOption);

      if (!sizeOptions.length && variantInput.value) {
        submit.disabled = false;
        submit.textContent = 'Add to Cart';
        return;
      }

      sizeOptions.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) {
            return;
          }

          if (state) {
            const optionIndex = Number(button.dataset.optionIndex);
            const optionValue = button.dataset.optionValue || '';
            state.selections[optionIndex] = optionValue;
            updateQuickAddOptions(modal);
            return;
          }

          sizeOptions.forEach((item) => item.classList.remove('is-selected'));
          button.classList.add('is-selected');
          variantInput.value = button.dataset.variantId || '';
          submit.disabled = !variantInput.value;
          submit.textContent = variantInput.value ? 'Add to Cart' : getQuickAddSelectionPrompt('size');
        });
      });

      if (state) {
        updateQuickAddOptions(modal);
      }
    }

    function handleCartRefresh(modal, cart) {
      modal.__quickAddLastCart = cart;

      const activeElement = document.activeElement;

      if (activeElement && modal.contains(activeElement) && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }

      updateCartBubble(cart.item_count);
      refreshCartUi();
      renderCartItems(modal, cart);
      switchStep(modal, 'added');

      const addedStep = modal.querySelector(selectors.addedStep);
      scrollQuickAddBodyToTop(addedStep);

      // matching set is lazy-loaded (usually already prefetched on open);
      // sync it against the cart once its markup exists
      ensureMatchingSetLoaded(modal).then(() => {
        syncMatchingSetWithCart(modal, cart);
        resetMatchingTrackPosition(modal);
      });
    }

    function addToCart(modal, form) {
      const submit = modal.querySelector(selectors.submit);
      const error = modal.querySelector(selectors.error);
      const formData = new URLSearchParams(new FormData(form)).toString();

      if (modal.__quickAddSubmitting) {
        return;
      }

      modal.__quickAddSubmitting = true;
      submit.classList.add('btn--loading');

      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 422) {
            throw new Error(data.description || data.message || 'Unable to add item');
          }

          rememberQuickAddItems(modal, data, 1);

          return queueCartRefresh();
        })
        .then((cart) => {
          handleCartRefresh(modal, cart);
        })
        .catch((err) => {
          if (error) {
            error.hidden = false;
            error.textContent = err.message;
          }
        })
        .finally(() => {
          modal.__quickAddSubmitting = false;
          submit.classList.remove('btn--loading');
        });
    }

    function bindForm(modal) {
      const form = modal.querySelector(selectors.form);

      if (!form) {
        return;
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        addToCart(modal, form);
      });
    }

    function addMatchingProduct(modal, card, variantId, trigger) {
      const error = card.querySelector(selectors.matchingError);

      if (!variantId || card.__quickAddMatchingSubmitting) {
        return;
      }

      card.__quickAddMatchingSubmitting = true;

      if (trigger) {
        trigger.classList.add('btn--loading');
      }

      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      addLineItem(variantId, 1)
        .then((data) => {
          if (data.status === 422) {
            throw new Error(data.description || data.message || 'Unable to add item');
          }

          rememberQuickAddItems(modal, data, 1);

          return queueCartRefresh();
        })
        .then((cart) => {
          handleCartRefresh(modal, cart);
        })
        .catch((err) => {
          if (error) {
            error.hidden = false;
            error.textContent = err.message;
          }
        })
        .finally(() => {
          card.__quickAddMatchingSubmitting = false;
          if (trigger) {
            trigger.classList.remove('btn--loading');
          }
        });
    }

    function bindMatchingCard(modal, card) {
      if (card.dataset.quickAddMatchingBound === 'true') {
        return;
      }

      card.dataset.quickAddMatchingBound = 'true';

      card.querySelectorAll(selectors.matchingOption).forEach((button) => {
        button.addEventListener('click', () => {
          const state = getMatchingState(card);
          const optionIndex = Number(button.dataset.optionIndex);
          const optionValue = button.dataset.optionValue || '';
          const isPrimarySelection = state.primaryOptionIndex !== null && optionIndex === state.primaryOptionIndex;
          const isSecondarySelection = state.secondaryOptionIndex !== null && optionIndex === state.secondaryOptionIndex;

          if (isPrimarySelection) {
            resetDependentMatchingSelections(state, [optionIndex]);
          }

          state.selections[optionIndex] = optionValue;

          if (isPrimarySelection && state.secondaryOptionIndex !== null && state.secondaryOptionIndex !== state.primaryOptionIndex) {
            collapseOtherMatchingCards(modal, card);
            state.currentStep = 'secondary';
            updateMatchingCard(card);
            return;
          }

          if (isSecondarySelection || !state.secondaryOptionIndex) {
            updateMatchingCard(card);
            const variant = resolveMatchingVariant(state);
            if (variant) {
              addMatchingProduct(modal, card, variant.id, button);
            }
            return;
          }

          updateMatchingCard(card);
        });
      });

      card.querySelectorAll(selectors.matchingResetStep).forEach((button) => {
        button.addEventListener('click', () => {
          const state = getMatchingState(card);
          const targetStep = button.dataset.targetStep || 'summary';

          if (targetStep === 'primary' && state.primaryOptionIndex !== null) {
            resetDependentMatchingSelections(state, [state.primaryOptionIndex]);
            state.currentStep = 'primary';
          } else {
            resetDependentMatchingSelections(state, []);
            state.currentStep = 'summary';
          }

          updateMatchingCard(card);
        });
      });

      const addButton = card.querySelector(selectors.matchingAdd);
      if (addButton) {
        addButton.addEventListener('click', () => {
          const state = getMatchingState(card);

          if (!state.requiredOptionIndexes.length) {
            const variant = resolveMatchingVariant(state);
            if (variant) {
              addMatchingProduct(modal, card, variant.id, addButton);
            }
            return;
          }

          if (state.primaryOptionIndex !== null) {
            collapseOtherMatchingCards(modal, card);
            state.currentStep = 'primary';
            updateMatchingCard(card);
          }
        });
      }

      updateMatchingCard(card);
    }

    function updateMatchingCount(modal) {
      const track = modal.querySelector(selectors.matchingTrack);
      const count = modal.querySelector(selectors.matchingCount);

      if (!track || !count) {
        return;
      }

      const cards = Array.from(track.querySelectorAll(selectors.matchingCard)).filter((card) => !card.hidden);

      if (!cards.length) {
        count.textContent = '0/0';
        return;
      }

      let currentIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          currentIndex = index;
        }
      });

      count.textContent = `${currentIndex + 1}/${cards.length}`;
    }

    function bindMatchingSet(modal) {
      const track = modal.querySelector(selectors.matchingTrack);

      modal.querySelectorAll(selectors.matchingCard).forEach((card) => bindMatchingCard(modal, card));

      if (track) {
        const visibleCards = Array.from(track.querySelectorAll(selectors.matchingCard)).filter((card) => !card.hidden);
        visibleCards.forEach((card) => card.classList.remove('is-last-visible'));

        if (visibleCards.length > 1) {
          visibleCards[visibleCards.length - 1].classList.add('is-last-visible');
        }
      }

      if (!track || track.dataset.quickAddMatchingTrackBound === 'true') {
        updateMatchingCount(modal);
        return;
      }

      track.dataset.quickAddMatchingTrackBound = 'true';
      track.addEventListener('scroll', () => updateMatchingCount(modal), { passive: true });
      updateMatchingCount(modal);
    }

    function bindRemove(modal) {
      modal.addEventListener('click', (event) => {
        const button = event.target.closest(selectors.remove);

        if (!button) {
          return;
        }

        const sessionEntryId = button.dataset.sessionEntryId;
        const currentCart = modal.__quickAddLastCart;
        const currentCartItem = currentCart && Array.isArray(currentCart.items)
          ? currentCart.items.find((item) => item && String(item.key) === String(button.dataset.key))
          : null;
        const sessionEntry = getQuickAddSessionItems(modal).find((item) => item.sessionEntryId === sessionEntryId);
        const quantityToRemove = sessionEntry ? (Number(sessionEntry.quantityAdded) || 1) : 1;
        const nextQuantity = currentCartItem
          ? Math.max((Number(currentCartItem.quantity) || 0) - quantityToRemove, 0)
          : 0;

        fetch(theme.routes.cartChange, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: button.dataset.key, quantity: nextQuantity })
        })
          .then((response) => response.json())
          .then((cart) => {
            modal.__quickAddLastCart = cart;
            forgetQuickAddItem(modal, sessionEntryId);
            updateCartBubble(cart.item_count);
            refreshCartUi();

            const sessionItems = getQuickAddSessionItems(modal);

            if (sessionItems.length > 0) {
              renderCartItems(modal, cart);
              syncMatchingSetWithCart(modal, cart);
            } else {
              switchStep(modal, 'select');
            }
          });
      });
    }

    function initModal(modal) {
      if (!modal || modal.dataset.quickAddBound === 'true') {
        return;
      }

      modal.dataset.quickAddBound = 'true';
      bindSizeOptions(modal);
      bindForm(modal);
      bindMatchingSet(modal);
      bindRemove(modal);
      modal.querySelectorAll(selectors.close).forEach((button) => {
        button.addEventListener('click', () => closeModal(modal));
      });
    }

    // Guarded init: on product pages theme.js is injected AFTER
    // DOMContentLoaded (hero-gated loader in layout/theme.liquid), so a bare
    // DCL listener would never fire there.
    function initQuickAddOnReady() {
      const shell = ensureQuickAddShell();
      if (shell) {
        shell.querySelectorAll(selectors.modal).forEach(initModal);
      }

      const quickAddViewport = typeof window.matchMedia === 'function'
        ? window.matchMedia(QUICK_ADD_MOBILE_MEDIA_QUERY)
        : null;

      if (quickAddViewport) {
        const handleViewportChange = function (event) {
          if (event.matches) {
            return;
          }

          document.querySelectorAll(`${selectors.modal}.is-open`).forEach((modal) => closeModal(modal, { restoreFocus: false }));
        };

        if (typeof quickAddViewport.addEventListener === 'function') {
          quickAddViewport.addEventListener('change', handleViewportChange);
        } else if (typeof quickAddViewport.addListener === 'function') {
          quickAddViewport.addListener(handleViewportChange);
        }
      }

      const prefetchQuickAdd = function (event) {
        const openButton = event.target.closest(selectors.open);
        if (!openButton || !isQuickAddMobileViewport()) {
          return;
        }

        warmQuickAddMarkup(openButton.dataset.productHandle);
      };

      document.addEventListener('pointerdown', prefetchQuickAdd, { passive: true });
      document.addEventListener('touchstart', prefetchQuickAdd, { passive: true });
      document.addEventListener('focusin', prefetchQuickAdd);

      // Viewport prewarm: mobile has no hover, so warm the quick-add markup for
      // cards in/near the viewport ahead of the first tap (making the tap an
      // instant cache hit). Each card is warmed once, on idle, then unobserved
      // to cap origin load; gated by the same mobile + shouldPrefetchQuickAdd
      // checks as the pointer/touch prewarm above.
      if ('IntersectionObserver' in window) {
        const idleWarm = window.requestIdleCallback || function (cb) { return window.setTimeout(cb, 200); };
        const quickAddPrewarmObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            if (!isQuickAddMobileViewport() || !shouldPrefetchQuickAdd()) {
              return;
            }

            const button = entry.target;
            observer.unobserve(button);
            idleWarm(function () {
              warmQuickAddMarkup(button.dataset.productHandle);
            });
          });
        }, { rootMargin: '200px 0px' });

        document.querySelectorAll(selectors.open).forEach(function (button) {
          quickAddPrewarmObserver.observe(button);
        });
      }

      document.addEventListener('click', function (event) {
        const openButton = event.target.closest(selectors.open);
        if (!openButton || !isQuickAddMobileViewport()) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        loadQuickAddModal(openButton.dataset.productId, openButton.dataset.productHandle, openButton);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        document.querySelectorAll(`${selectors.modal}.is-open`).forEach((modal) => closeModal(modal));
      });
    }
    if (document.readyState !== 'loading') {
      initQuickAddOnReady();
    } else {
      document.addEventListener('DOMContentLoaded', initQuickAddOnReady);
    }
  })();
  /* Product card quick add end */

  /* PDP Complete the Look start */
  (function () {
    const DESKTOP_MEDIA_QUERY = '(min-width: 769px)';
    const selectors = {
      open: '[data-complete-look-open]',
      modal: '[data-complete-look-modal]',
      carousel: '[data-complete-look-carousel]',
      reviewBadge: '[data-complete-look-review-badge]',
      close: '[data-complete-look-close]',
      dialog: '.complete-look-modal__dialog',
      card: '[data-complete-look-card]',
      variants: '[data-complete-look-variants]',
      option: '[data-complete-look-option]',
      optionGroup: '[data-complete-look-option-group]',
      add: '[data-complete-look-card-add]',
      remove: '[data-complete-look-remove]',
      edit: '[data-complete-look-edit]',
      pill: '[data-complete-look-selection-pill]',
      label: '[data-complete-look-selection-label]',
      price: '[data-complete-look-card-price]',
      thumbs: '[data-complete-look-thumbs]',
      selectedCount: '[data-complete-look-selected-count]',
      subtotal: '[data-complete-look-subtotal]',
      submit: '[data-complete-look-submit]',
      error: '[data-complete-look-error]'
    };

    let activeModal = null;
    let scrollY = 0;
    let bodyStyles = null;

    function parseOptionalIndex(value) {
      if (value === '' || value === undefined || value === null) {
        return null;
      }

      const parsedValue = Number(value);
      return Number.isNaN(parsedValue) ? null : parsedValue;
    }

    function isDesktopViewport() {
      if (typeof window.matchMedia === 'function') {
        return window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
      }

      return window.innerWidth >= 769;
    }

    function formatMoney(cents) {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }

      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function lockPageScroll() {
      if (document.body.classList.contains('complete-look-open')) {
        return;
      }

      scrollY = window.scrollY || window.pageYOffset || 0;
      bodyStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width
      };

      document.documentElement.classList.add('complete-look-open');
      document.body.classList.add('complete-look-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('complete-look-open');
      document.body.classList.remove('complete-look-open');

      const nextScrollY = Math.abs(parseInt(document.body.style.top || '0', 10)) || scrollY;
      document.body.style.position = bodyStyles ? bodyStyles.position : '';
      document.body.style.top = bodyStyles ? bodyStyles.top : '';
      document.body.style.left = bodyStyles ? bodyStyles.left : '';
      document.body.style.right = bodyStyles ? bodyStyles.right : '';
      document.body.style.width = bodyStyles ? bodyStyles.width : '';
      bodyStyles = null;
      scrollY = 0;

      window.requestAnimationFrame(() => window.scrollTo(0, nextScrollY));
    }

    function getState(card) {
      if (card.__completeLookState) {
        return card.__completeLookState;
      }

      let variants = [];
      let requiredOptionIndexes = [];
      let defaultSelections = [];

      try {
        const json = card.querySelector(selectors.variants);
        variants = JSON.parse(json ? json.textContent : '[]');
      } catch (error) {
        variants = [];
      }

      try {
        requiredOptionIndexes = JSON.parse(card.dataset.requiredOptions || '[]');
      } catch (error) {
        requiredOptionIndexes = [];
      }

      try {
        defaultSelections = JSON.parse(card.dataset.defaultSelections || '[]');
      } catch (error) {
        defaultSelections = [];
      }

      card.__completeLookState = {
        variants,
        requiredOptionIndexes,
        defaultSelections,
        primaryOptionIndex: parseOptionalIndex(card.dataset.primaryOptionIndex),
        secondaryOptionIndex: parseOptionalIndex(card.dataset.secondaryOptionIndex),
        selections: defaultSelections.slice(),
        editing: false,
        selected: card.dataset.current === 'true'
      };

      return card.__completeLookState;
    }

    function selectionComplete(state) {
      return state.requiredOptionIndexes.every((index) => Boolean(state.selections[index]));
    }

    function resolveVariant(state) {
      return state.variants.find((variant) => {
        if (!variant.available) {
          return false;
        }

        return variant.options.every((optionValue, index) => {
          const selectedValue = state.selections[index];
          return !selectedValue || selectedValue === optionValue;
        });
      }) || null;
    }

    function variantMatchesSelections(variant, state, optionIndex, optionValue) {
      if (!variant.available) {
        return false;
      }

      return variant.options.every((variantOptionValue, index) => {
        if (index === optionIndex) {
          return variantOptionValue === optionValue;
        }

        const selectedValue = state.selections[index];
        return !selectedValue || selectedValue === variantOptionValue;
      });
    }

    function selectedLabel(state) {
      return state.requiredOptionIndexes
        .map((index) => state.selections[index])
        .filter(Boolean)
        .join(' / ');
    }

    function getDefaultExpandedState(card, state) {
      if (card.dataset.current === 'true') {
        return true;
      }

      return !isMobileViewport() && state.requiredOptionIndexes.length > 0;
    }

    function updateCard(card) {
      const state = getState(card);
      const complete = selectionComplete(state);
      const variant = complete ? resolveVariant(state) : null;
      const addButton = card.querySelector(selectors.add);
      const removeButton = card.querySelector(selectors.remove);
      const pill = card.querySelector(selectors.pill);
      const label = card.querySelector(selectors.label);
      const edit = card.querySelector(selectors.edit);
      const price = card.querySelector(selectors.price);
      const hasRequiredOptions = state.requiredOptionIndexes.length > 0;
      const shouldShowOptions = card.classList.contains('is-expanded') && (state.editing || !state.selected || !complete);
      const primarySelected = state.primaryOptionIndex !== null ? Boolean(state.selections[state.primaryOptionIndex]) : false;
      const hasSecondaryStep = state.secondaryOptionIndex !== null && state.secondaryOptionIndex !== state.primaryOptionIndex;

      card.classList.toggle('is-selected', state.selected);
      card.classList.toggle('is-complete', complete);

      card.querySelectorAll(selectors.optionGroup).forEach((group) => {
        const optionIndex = Number(group.dataset.optionIndex);
        let hidden = !shouldShowOptions;

        if (!hidden && hasSecondaryStep) {
          if (optionIndex === state.primaryOptionIndex && primarySelected && state.selected) {
            hidden = true;
          } else if (optionIndex === state.secondaryOptionIndex && !(primarySelected && state.selected)) {
            hidden = true;
          }
        }

        group.hidden = hidden;

        // Update secondary option label with selected primary value
        const optionLabel = group.querySelector('.complete-look-modal__option-label');
        if (optionLabel && hasSecondaryStep && optionIndex === state.secondaryOptionIndex && optionLabel.dataset.completeLookOptionLabel) {
          const valueEl = optionLabel.querySelector('[data-complete-look-option-label-value]');
          const suffixEl = optionLabel.querySelector('[data-complete-look-option-label-suffix]');
          const backButton = optionLabel.querySelector('[data-complete-look-secondary-back]');
          const primaryValue = state.selections[state.primaryOptionIndex] || '';

          if (primarySelected && state.selected) {
            if (valueEl) valueEl.textContent = primaryValue + ' - ';
            if (suffixEl) suffixEl.textContent = 'Select ' + optionLabel.dataset.completeLookOptionLabel + ':';
            if (backButton) backButton.hidden = false;
          } else {
            if (valueEl) valueEl.textContent = '';
            if (suffixEl) suffixEl.textContent = 'Select ' + optionLabel.dataset.completeLookOptionLabel + ':';
            if (backButton) backButton.hidden = true;
          }
        }
      });

      card.querySelectorAll(selectors.option).forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const optionValue = button.dataset.optionValue || '';
        const selected = state.selections[optionIndex] === optionValue;
        const available = state.variants.some((variantItem) => variantMatchesSelections(variantItem, state, optionIndex, optionValue));
        button.classList.toggle('is-selected', selected);
        button.classList.toggle('is-disabled', !available);
        button.disabled = !available;
      });

      if (price) {
        if (variant && typeof variant.price === 'number') {
          price.innerHTML = formatMoney(variant.price);
        } else if (state.variants[0] && typeof state.variants[0].price === 'number') {
          price.innerHTML = formatMoney(state.variants[0].price);
        }
      }

      if (addButton) {
        addButton.hidden = state.selected || shouldShowOptions;
      }

      if (removeButton) {
        removeButton.hidden = !state.selected;
      }

      if (pill && label) {
        const labelText = selectedLabel(state);
        pill.hidden = !state.selected || !complete || !labelText || shouldShowOptions;
        label.textContent = labelText;
      }

      if (edit) {
        edit.hidden = !state.selected || !primarySelected || !hasRequiredOptions || shouldShowOptions;
      }
    }

    function updateModal(modal) {
      const cards = Array.from(modal.querySelectorAll(selectors.card));
      const selectedCards = cards.filter((card) => {
        const state = getState(card);
        return state.selected && selectionComplete(state);
      });
      const thumbs = modal.querySelector(selectors.thumbs);
      const selectedCount = modal.querySelector(selectors.selectedCount);
      const subtotal = modal.querySelector(selectors.subtotal);
      const submit = modal.querySelector(selectors.submit);
      let subtotalCents = 0;
      let allSelectedComplete = selectedCards.length > 0;
      const hasIncompleteSelection = cards.some((card) => {
        const state = getState(card);
        return state.selected && !selectionComplete(state);
      });

      selectedCards.forEach((card) => {
        const state = getState(card);
        const variant = selectionComplete(state) ? resolveVariant(state) : null;
        if (!variant) {
          allSelectedComplete = false;
          return;
        }
        subtotalCents += Number(variant.price || 0);
      });

      if (thumbs) {
        thumbs.innerHTML = selectedCards.map((card) => {
          const productTitle = escapeHtml(card.dataset.productTitle || 'Selected product');
          const image = card.dataset.productImage || '';
          return `<button type="button" class="complete-look-modal__thumb" data-complete-look-thumb-remove data-product-id="${escapeHtml(card.dataset.productId || '')}" aria-label="Remove ${productTitle}">${image ? `<img src="${escapeHtml(image)}" alt="${productTitle}">` : ''}<span aria-hidden="true"><svg width="6" height="6" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13M13 1L1 13" stroke="#0a0a0a" stroke-width="1.4" stroke-linecap="round"></path></svg></span></button>`;
        }).join('');
      }

      if (selectedCount) {
        selectedCount.textContent = `${selectedCards.length} item${selectedCards.length === 1 ? '' : 's'} selected`;
      }

      if (subtotal) {
        if (selectedCards.length > 0 && allSelectedComplete) {
          subtotal.innerHTML = `Subtotal: ${formatMoney(subtotalCents)}`;
        } else {
          subtotal.textContent = 'Subtotal:';
        }
      }

      if (submit) {
        submit.disabled = !selectedCards.length || !allSelectedComplete || hasIncompleteSelection;
        submit.textContent = !selectedCards.length || !allSelectedComplete || hasIncompleteSelection ? 'Select sizes' : 'Add selected items to cart';
      }
    }

    function resetModal(modal) {
      modal.querySelectorAll(selectors.card).forEach((card) => {
        const state = getState(card);
        const shouldExpand = getDefaultExpandedState(card, state);
        state.selections = state.defaultSelections.slice();
        state.editing = shouldExpand;
        state.selected = false;
        card.classList.toggle('is-expanded', shouldExpand);
        updateCard(card);
      });
      updateModal(modal);
    }

    function closeModal(modal) {
      if (!modal || !modal.classList.contains('is-open')) {
        return;
      }

      const dialog = modal.querySelector(selectors.dialog);
      modal.classList.remove('is-open');
      modal.classList.add('is-closing');
      modal.setAttribute('aria-hidden', 'true');
      modal.inert = true;

      if (theme.a11y && typeof theme.a11y.removeTrapFocus === 'function') {
        theme.a11y.removeTrapFocus({ container: dialog || modal, namespace: 'complete-look' });
      }

      // Return focus to the opener (same pattern as the quick-add modal).
      if (modal.__completeLookTrigger && typeof modal.__completeLookTrigger.focus === 'function') {
        modal.__completeLookTrigger.focus({ preventScroll: true });
      }

      const finish = function () {
        if (!modal.classList.contains('is-closing')) {
          return;
        }

        modal.hidden = true;
        modal.classList.remove('is-closing');
        unlockPageScroll();
        if (activeModal === modal) {
          activeModal = null;
        }
      };

      if (dialog) {
        dialog.addEventListener('transitionend', finish, { once: true });
      }
      window.setTimeout(finish, 360);
    }

    function openModal(modal, trigger) {
      if (!modal) {
        return;
      }

      if (activeModal && activeModal !== modal) {
        closeModal(activeModal);
      }

      const dialog = modal.querySelector(selectors.dialog);
      const focusTarget = modal.querySelector(selectors.close) || dialog;
      modal.__completeLookTrigger = trigger || null;
      modal.hidden = false;
      modal.inert = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.remove('is-closing');
      activeModal = modal;
      lockPageScroll();
      resetModal(modal);

      window.requestAnimationFrame(() => {
        modal.classList.add('is-open');
        if (dialog && theme.a11y && typeof theme.a11y.trapFocus === 'function') {
          theme.a11y.trapFocus({ container: dialog, elementToFocus: focusTarget, namespace: 'complete-look' });
        }
      });
    }

    function refreshCartUi(cart) {
      document.querySelectorAll('.cart-link__bubble-num').forEach((el) => {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
      });
      document.querySelectorAll('.cart-link__bubble').forEach((el) => {
        el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      });
      if (document.dispatchEvent) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }

    function formatReviewCount(count) {
      const numericCount = Number(count || 0);
      if (!numericCount) {
        return '0';
      }

      return numericCount.toLocaleString ? numericCount.toLocaleString() : String(numericCount);
    }

    function normalizeRating(rating) {
      const numericRating = Number(rating || 0);
      if (!numericRating) {
        return '';
      }

      return numericRating.toFixed(1);
    }

    function renderCarouselReview(badge) {
      if (!badge) {
        return;
      }

      const reviewRow = badge.closest('.complete-look-carousel__reviews');
      const previewBadge = badge.querySelector('.jdgm-prev-badge');
      const rating = normalizeRating(previewBadge ? previewBadge.dataset.averageRating : '');
      const reviewCount = previewBadge ? previewBadge.dataset.numberOfReviews : '';

      if (!reviewRow || !rating || !reviewCount) {
        return;
      }

      const outputHtml = `<span class="complete-look-carousel__star" aria-hidden="true">&starf;</span><span>${rating}</span><span>(${formatReviewCount(reviewCount)})</span>`;
      if (badge.dataset.completeLookReviewRendered === outputHtml) {
        return;
      }

      let output = reviewRow.querySelector('.complete-look-carousel__review-output');
      if (!output) {
        output = document.createElement('span');
        output.className = 'complete-look-carousel__review-output';
        reviewRow.appendChild(output);
      }

      output.innerHTML = outputHtml;
      badge.dataset.completeLookReviewRendered = outputHtml;
    }

    function refreshCarouselReviews(root) {
      const scope = root || document;
      scope.querySelectorAll(selectors.reviewBadge).forEach(renderCarouselReview);
    }

    function submitSelected(modal) {
      const submit = modal.querySelector(selectors.submit);
      const error = modal.querySelector(selectors.error);
      const cards = Array.from(modal.querySelectorAll(selectors.card));
      const hasIncompleteSelection = cards.some((card) => {
        const state = getState(card);
        return state.selected && !selectionComplete(state);
      });
      const selectedCards = cards.filter((card) => {
        const state = getState(card);
        return state.selected && selectionComplete(state);
      });
      const items = selectedCards.map((card) => {
        const state = getState(card);
        const variant = resolveVariant(state);
        return variant ? { id: variant.id, quantity: 1 } : null;
      }).filter(Boolean);

      if (!items.length || hasIncompleteSelection || modal.__completeLookSubmitting) {
        return;
      }

      modal.__completeLookSubmitting = true;
      if (submit) {
        submit.classList.add('btn--loading');
        submit.disabled = true;
      }
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      })
        .then((response) => response.json().then((data) => ({ response, data })))
        .then(({ response, data }) => {
          if (!response.ok || data.status === 422) {
            throw new Error(data.description || data.message || 'Unable to add selected items');
          }
          return fetch(theme.routes.cart, { credentials: 'same-origin', method: 'GET' });
        })
        .then((response) => response.json())
        .then((cart) => {
          refreshCartUi(cart);
          closeModal(modal);
        })
        .catch((err) => {
          if (error) {
            error.hidden = false;
            error.textContent = err.message;
          }
        })
        .finally(() => {
          modal.__completeLookSubmitting = false;
          if (submit) {
            submit.classList.remove('btn--loading');
          }
          updateModal(modal);
        });
    }

    function portalModal(modal) {
      if (!modal || modal.__completeLookPortaled) {
        return;
      }

      const productSection = modal.closest('.product-section');
      if (productSection) {
        productSection.__completeLookModal = modal;
      }

      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }

      modal.__completeLookPortaled = true;
    }

    function initModal(modal) {
      if (!modal || modal.dataset.completeLookBound === 'true') {
        return;
      }

      portalModal(modal);
      modal.dataset.completeLookBound = 'true';
      modal.inert = true;

      modal.querySelectorAll(selectors.card).forEach((card) => {
        updateCard(card);
      });
      updateModal(modal);

      modal.addEventListener('click', (event) => {
        const closeButton = event.target.closest(selectors.close);
        if (closeButton) {
          event.preventDefault();
          closeModal(modal);
          return;
        }

        const thumbRemove = event.target.closest('[data-complete-look-thumb-remove]');
        if (thumbRemove) {
          const card = Array.from(modal.querySelectorAll(selectors.card)).find((item) => item.dataset.productId === (thumbRemove.dataset.productId || ''));
          if (card) {
            const state = getState(card);
            const shouldExpand = getDefaultExpandedState(card, state);
            state.selections = state.defaultSelections.slice();
            state.editing = shouldExpand;
            state.selected = false;
            card.classList.toggle('is-expanded', shouldExpand);
            updateCard(card);
            updateModal(modal);
          }
          return;
        }

        const removeButton = event.target.closest(selectors.remove);
        if (removeButton) {
          const card = removeButton.closest(selectors.card);
          if (card) {
            const state = getState(card);
            const shouldExpand = getDefaultExpandedState(card, state);
            state.selections = state.defaultSelections.slice();
            state.selected = false;
            state.editing = shouldExpand;
            card.classList.toggle('is-expanded', shouldExpand);
            updateCard(card);
            updateModal(modal);
          }
          return;
        }

        const backButton = event.target.closest('[data-complete-look-secondary-back]');
        if (backButton) {
          event.preventDefault();
          const card = backButton.closest(selectors.card);
          if (card) {
            const state = getState(card);
            state.selections[state.primaryOptionIndex] = '';
            state.selections[state.secondaryOptionIndex] = '';
            // Stepping back to the length step is still part of the add flow, so
            // keep the card selected — the price stays top-right (doesn't snap
            // back to the stacked add-state position).
            state.selected = true;
            state.editing = true;
            card.classList.add('is-expanded');
            updateCard(card);
            updateModal(modal);
          }
          return;
        }

        const optionButton = event.target.closest(selectors.option);
        if (optionButton) {
          const card = optionButton.closest(selectors.card);
          const state = getState(card);
          const optionIndex = Number(optionButton.dataset.optionIndex);
          const optionValue = optionButton.dataset.optionValue || '';

          state.selections[optionIndex] = optionValue;
          if (state.primaryOptionIndex !== null && optionIndex === state.primaryOptionIndex && state.secondaryOptionIndex !== null && state.secondaryOptionIndex !== state.primaryOptionIndex) {
            state.selections[state.secondaryOptionIndex] = '';
          }
          state.selected = true;

          if (selectionComplete(state)) {
            state.editing = false;
            card.classList.remove('is-expanded');
          }
          updateCard(card);
          updateModal(modal);
          return;
        }

        const addButton = event.target.closest(selectors.add);
        if (addButton) {
          const card = addButton.closest(selectors.card);
          const state = getState(card);
          state.selected = true;
          if (state.requiredOptionIndexes.length && !selectionComplete(state)) {
            state.editing = true;
            card.classList.add('is-expanded');
          }
          updateCard(card);
          updateModal(modal);
          return;
        }

        const editButton = event.target.closest(`${selectors.edit}, ${selectors.pill}`);
        if (editButton) {
          const card = editButton.closest(selectors.card);
          const state = getState(card);
          state.editing = true;
          card.classList.add('is-expanded');
          updateCard(card);
          updateModal(modal);
          return;
        }
      });

      const submit = modal.querySelector(selectors.submit);
      if (submit) {
        submit.addEventListener('click', () => submitSelected(modal));
      }
    }

    // Guarded init: on product pages theme.js is injected AFTER
    // DOMContentLoaded (hero-gated loader in layout/theme.liquid), so a bare
    // DCL listener would never fire there.
    function initCompleteLookOnReady() {
      document.querySelectorAll(selectors.modal).forEach(initModal);
      refreshCarouselReviews(document);

      window.setTimeout(() => refreshCarouselReviews(document), 300);
      window.setTimeout(() => refreshCarouselReviews(document), 1200);

      document.addEventListener('click', function (event) {
        const openButton = event.target.closest(selectors.open);
        if (!openButton) {
          return;
        }

        const productSection = openButton.closest('.product-section');
        const modal = (productSection && productSection.__completeLookModal)
          || (productSection ? productSection.querySelector(selectors.modal) : null)
          || document.querySelector(selectors.modal);
        if (!modal) {
          return;
        }

        event.preventDefault();
        initModal(modal);
        openModal(modal, openButton);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && activeModal) {
          closeModal(activeModal);
        }
      });
    }
    if (document.readyState !== 'loading') {
      initCompleteLookOnReady();
    } else {
      document.addEventListener('DOMContentLoaded', initCompleteLookOnReady);
    }

    /* ── Carousel arrow navigation ── */
    function initCarouselNav(carousel) {
      if (!carousel || carousel.dataset.carouselNavInit === 'true') return;
      carousel.dataset.carouselNavInit = 'true';

      const track = carousel.querySelector('.complete-look-carousel__track');
      const nav = carousel.querySelector('.complete-look-carousel__nav');
      const leftBtn = nav ? nav.querySelector('.complete-look-carousel__arrow--left') : null;
      const rightBtn = nav ? nav.querySelector('.complete-look-carousel__arrow--right') : null;

      if (!track || !nav || !leftBtn || !rightBtn) return;

      function getScrollStep() {
        const card = track.querySelector('.complete-look-carousel__card');
        if (!card) return track.clientWidth;
        const cardWidth = card.getBoundingClientRect().width;
        const gapStr = getComputedStyle(track).columnGap || getComputedStyle(track).gap;
        const gap = parseFloat(gapStr) || 4;
        return cardWidth + gap;
      }

      function updateArrows() {
        const max = track.scrollWidth - track.clientWidth;
        leftBtn.disabled = track.scrollLeft <= 2;
        rightBtn.disabled = max <= 0 || track.scrollLeft >= max - 2;
      }

      function syncNav() {
        if (!isDesktopViewport()) {
          nav.classList.remove('is-active');
          return;
        }
        const hasOverflow = track.scrollWidth > track.clientWidth + 1;
        nav.classList.toggle('is-active', hasOverflow);
        if (hasOverflow) updateArrows();
      }

      leftBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });

      window.addEventListener('resize', syncNav);

      // Initial sync
      requestAnimationFrame(syncNav);
    }

    // Initialize carousel nav on existing carousels
    document.querySelectorAll(selectors.carousel).forEach(initCarouselNav);

    // Also observe for dynamically added carousels (e.g. AJAX-loaded sections)
    if (typeof MutationObserver !== 'undefined') {
      var carouselObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches(selectors.carousel)) {
                initCarouselNav(node);
              }
              if (node.querySelectorAll) {
                node.querySelectorAll(selectors.carousel).forEach(initCarouselNav);
              }
            }
          });
        });
      });
      carouselObserver.observe(document.documentElement, { childList: true, subtree: true });
    }

    // After a sibling colourway swap, drop the previous modal that was portaled
    // to <body>, and re-render the carousel review badges for the new section
    // (refreshCarouselReviews otherwise only runs on initial page load).
    document.addEventListener('dfyne:sibling-product:loaded', function (event) {
      var scope = (event.detail && event.detail.productSection) || document;
      Array.prototype.slice.call(document.querySelectorAll(selectors.modal)).forEach(function (modal) {
        if (modal.parentNode === document.body && (!scope.contains || !scope.contains(modal))) {
          modal.remove();
        }
      });
      if (scope.querySelectorAll) {
        refreshCarouselReviews(scope);
      }
    });
  })();
  /* PDP Complete the Look end */

  /* Mobile PDP panels start */
  (function () {
    const MOBILE_PDP_MEDIA_QUERY = '(max-width: 768px)';
    const selectors = {
      root: '[data-pdp-mobile-root]',
      panel: '[data-pdp-panel]',
      panelDialog: '[data-pdp-panel-dialog]',
      panelOpen: '[data-pdp-panel-open]',
      panelClose: '[data-pdp-panel-close]',
      panelDrag: '[data-pdp-panel-drag]',
      detailsTabButton: '[data-pdp-details-tab-button]',
      detailsTabPanel: '[data-pdp-details-tab-panel]',
      detailsPanelsTrack: '[data-pdp-details-panels-track]',
      mobilePrice: '[data-pdp-mobile-price]',
      mobileComparePrice: '[data-pdp-mobile-compare-price]',
      paymentInstallment: '[data-pdp-payment-installment]',
      paymentTotal: '[data-pdp-payment-total]',
      paymentThreshold: '[data-pdp-payment-threshold]'
    };

    let activePanel = null;
    let activePanelTimer = null;
    let pageScrollY = 0;

    function isMobileViewport() {
      return window.matchMedia(MOBILE_PDP_MEDIA_QUERY).matches;
    }

    function lockPageScroll(useFixedBody) {
      if (document.documentElement.classList.contains('lock-scroll')) {
        return;
      }

      pageScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('lock-scroll');

      if (useFixedBody) {
        document.body.style.top = `-${pageScrollY}px`;
        document.body.classList.add('pdp-mobile-lock-scroll');
      }
    }

    function unlockPageScroll() {
      if (!document.documentElement.classList.contains('lock-scroll')) {
        return;
      }

      const shouldRestoreScroll = document.body.classList.contains('pdp-mobile-lock-scroll');
      document.documentElement.classList.remove('lock-scroll');
      document.body.classList.remove('pdp-mobile-lock-scroll');
      document.body.style.top = '';

      if (shouldRestoreScroll) {
        window.scrollTo(0, pageScrollY);
      }
    }

    function getPanelById(id) {
      if (!id) {
        return null;
      }

      return document.getElementById(id);
    }

    function portalPanels(root) {
      if (!root) {
        return;
      }

      root.__pdpPanels = Array.from(root.querySelectorAll(selectors.panel));
      root.__pdpPanels.forEach((panel) => {
        if (panel.parentNode !== document.body) {
          document.body.appendChild(panel);
        }
      });
    }

    function setActiveDetailsTab(panel, tabName, instant) {
      if (!panel) {
        return;
      }

      const buttons = panel.querySelectorAll(selectors.detailsTabButton);
      const panels = panel.querySelectorAll(selectors.detailsTabPanel);
      const activeButton = panel.querySelector(`${selectors.detailsTabButton}[data-pdp-details-tab-button="${tabName}"]`);
      const activePanelEl = panel.querySelector(`${selectors.detailsTabPanel}[data-pdp-details-tab-panel="${tabName}"]`);
      const track = panel.querySelector(selectors.detailsPanelsTrack);

      if (!activeButton || !activePanelEl) {
        return;
      }

      /* Determine target index for slide transition */
      var targetIndex = 0;
      var tabPanelsArr = Array.from(panels);
      for (var i = 0; i < tabPanelsArr.length; i++) {
        if (tabPanelsArr[i] === activePanelEl) {
          targetIndex = i;
          break;
        }
      }

      buttons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((tabPanel) => {
        const isActive = tabPanel === activePanelEl;
        tabPanel.classList.toggle('is-active', isActive);
        tabPanel.hidden = !isActive;
      });

      /* Slide the track to the target tab panel. On open (instant) jump straight
         to the target with no slide, then restore the transition for later taps. */
      if (track) {
        if (instant) {
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (targetIndex * 100) + '%)';
          void track.offsetWidth; /* flush so the next change animates */
          track.style.transition = '';
        } else {
          track.style.transform = 'translateX(-' + (targetIndex * 100) + '%)';
        }
      }

      if (isMobileViewport()) {
        /* Ensure the active tab button is visible in the scrollable mobile tab bar */
        activeButton.scrollIntoView({ behavior: instant ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    /* Let the user drag the panels horizontally to move between tabs, mirroring
       the slide the tab buttons trigger. Vertical scrolling of the tab content
       is left to the browser — we only hijack a gesture once it's clearly horizontal. */
    function enableDetailsSwipe(panel) {
      if (!panel || panel.__pdpSwipeBound) {
        return;
      }

      const track = panel.querySelector(selectors.detailsPanelsTrack);
      if (!track) {
        return;
      }

      panel.__pdpSwipeBound = true;

      const AXIS_LOCK = 10; /* px to travel before we commit to an axis */
      const SWIPE_THRESHOLD = 0.2; /* fraction of panel width needed to change tab */

      let startX = 0;
      let startY = 0;
      let startIndex = 0;
      let panelWidth = 0;
      let decided = false; /* axis has been determined */
      let dragging = false; /* committed to a horizontal drag */

      function tabPanels() {
        return Array.from(track.querySelectorAll(selectors.detailsTabPanel));
      }

      function activeIndex(tabs) {
        for (let i = 0; i < tabs.length; i++) {
          if (tabs[i].classList.contains('is-active')) {
            return i;
          }
        }
        return 0;
      }

      track.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) {
          return;
        }

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        decided = false;
        dragging = false;
        panelWidth = track.offsetWidth || window.innerWidth;
        startIndex = activeIndex(tabPanels());
      }, { passive: true });

      track.addEventListener('touchmove', function (event) {
        if (event.touches.length !== 1) {
          return;
        }

        const dx = event.touches[0].clientX - startX;
        const dy = event.touches[0].clientY - startY;

        if (!decided) {
          if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) {
            return;
          }
          decided = true;
          dragging = Math.abs(dx) > Math.abs(dy);
          if (dragging) {
            track.style.transition = 'none';
          }
        }

        if (!dragging) {
          return;
        }

        /* Following the finger horizontally — stop the page/body from scrolling. */
        event.preventDefault();

        const tabs = tabPanels();
        let offset = dx;
        /* Resist dragging past the first/last tab. */
        if ((startIndex === 0 && dx > 0) || (startIndex === tabs.length - 1 && dx < 0)) {
          offset = dx * 0.3;
        }

        const pct = -(startIndex * 100) + (offset / panelWidth) * 100;
        track.style.transform = 'translateX(' + pct + '%)';
      }, { passive: false });

      function endDrag(event) {
        if (!dragging) {
          decided = false;
          return;
        }

        decided = false;
        dragging = false;
        track.style.transition = '';

        const tabs = tabPanels();
        const dx = (event.changedTouches && event.changedTouches.length)
          ? event.changedTouches[0].clientX - startX
          : 0;

        let targetIndex = startIndex;
        if (Math.abs(dx) > panelWidth * SWIPE_THRESHOLD) {
          targetIndex = dx < 0 ? startIndex + 1 : startIndex - 1;
        }
        targetIndex = Math.max(0, Math.min(tabs.length - 1, targetIndex));

        const targetTab = tabs[targetIndex];
        if (targetTab) {
          /* Reuses the tab-button path so buttons/aria stay in sync and the
             snap animation runs off the now-restored CSS transition. */
          setActiveDetailsTab(panel, targetTab.dataset.pdpDetailsTabPanel);
        } else {
          track.style.transform = 'translateX(-' + (startIndex * 100) + '%)';
        }
      }

      track.addEventListener('touchend', endDrag);
      track.addEventListener('touchcancel', endDrag);
    }

    /* Drag-to-dismiss via the grey grabber. Only the handle is draggable — it
       captures the pointer, and we translate the sheet down with the finger.
       Release past ~25% of the sheet height closes it; otherwise it snaps back. */
    function enablePanelDrag(panel) {
      if (!panel || panel.__pdpDragBound) {
        return;
      }

      const handle = panel.querySelector(selectors.panelDrag);
      const dialog = panel.querySelector(selectors.panelDialog);
      if (!handle || !dialog) {
        return;
      }

      panel.__pdpDragBound = true;

      let startY = 0;
      let dragY = 0;
      let height = 0;
      let dragging = false;

      function onDown(event) {
        if (!isMobileViewport()) {
          return;
        }
        dragging = true;
        dragY = 0;
        startY = event.clientY;
        height = dialog.getBoundingClientRect().height || window.innerHeight;
        panel.classList.add('is-dragging');
        if (event.pointerId != null && handle.setPointerCapture) {
          try { handle.setPointerCapture(event.pointerId); } catch (e) {}
        }
      }

      function onMove(event) {
        if (!dragging) {
          return;
        }
        /* Only downward travel moves the sheet; upward is clamped to 0. */
        dragY = Math.max(0, event.clientY - startY);
        dialog.style.transform = 'translate3d(0, ' + dragY + 'px, 0)';
      }

      function onUp() {
        if (!dragging) {
          return;
        }
        dragging = false;
        panel.classList.remove('is-dragging');
        const shouldClose = dragY > height * 0.25;
        /* Clear the inline transform so the CSS transition takes over — either
           back to the open position (0) or, on close, to the off-screen state. */
        dialog.style.transform = '';
        if (shouldClose) {
          closePanel(panel);
        }
      }

      handle.addEventListener('pointerdown', onDown);
      handle.addEventListener('pointermove', onMove);
      handle.addEventListener('pointerup', onUp);
      handle.addEventListener('pointercancel', onUp);
    }

    function finishClose(panel) {
      if (!panel) {
        return;
      }

      panel.classList.remove('is-closing', 'is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;

      if (panel.__pdpRestoreTrigger && panel.__pdpRestoreTrigger.getAttribute('aria-expanded') !== null) {
        panel.__pdpRestoreTrigger.setAttribute('aria-expanded', 'false');
      }

      if (panel.__pdpRestoreTrigger && typeof panel.__pdpRestoreTrigger.focus === 'function') {
        panel.__pdpRestoreTrigger.focus({ preventScroll: true });
      }

      if (activePanel === panel) {
        activePanel = null;
        if (panel.__pdpLockPageScroll) {
          unlockPageScroll();
        }
        panel.__pdpLockPageScroll = false;
      }
    }

    function closePanel(panel) {
      if (!panel || !panel.classList.contains('is-open')) {
        return;
      }

      if (activePanelTimer) {
        window.clearTimeout(activePanelTimer);
        activePanelTimer = null;
      }

      panel.classList.remove('is-open');
      panel.classList.add('is-closing');

      if (theme.a11y && typeof theme.a11y.removeTrapFocus === 'function') {
        theme.a11y.removeTrapFocus({
          container: panel,
          namespace: 'pdp_mobile_panel'
        });
      }

      const dialog = panel.querySelector(selectors.panelDialog);
      const onTransitionEnd = function (event) {
        if (!dialog || event.target === dialog) {
          finishClose(panel);
        }
      };

      if (dialog) {
        dialog.addEventListener('transitionend', onTransitionEnd, { once: true });
      }

      activePanelTimer = window.setTimeout(function () {
        finishClose(panel);
      }, 420);
    }

    function openPanel(panel, trigger, tabName) {
      if (!panel) {
        return;
      }

      if (activePanel && activePanel !== panel) {
        closePanel(activePanel);
      }

      if (activePanelTimer) {
        window.clearTimeout(activePanelTimer);
        activePanelTimer = null;
      }

      panel.__pdpRestoreTrigger = trigger || null;
      if (panel.__pdpRestoreTrigger && panel.__pdpRestoreTrigger.getAttribute('aria-expanded') !== null) {
        panel.__pdpRestoreTrigger.setAttribute('aria-expanded', 'true');
      }
      panel.inert = false;
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.remove('is-closing');

      if (tabName) {
        /* instant: land on the target tab with no horizontal slide as it opens */
        setActiveDetailsTab(panel, tabName, true);
      }

      activePanel = panel;
      panel.__pdpLockPageScroll = true;
      lockPageScroll(isMobileViewport());

      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');

        var activeTabBtn = panel.querySelector('.pdp-mobile-details-tabs__button.is-active');
        if (activeTabBtn && isMobileViewport()) {
          /* Scroll the active tab button into view so it's not clipped (instant
             on open — no post-open slide) */
          activeTabBtn.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
        }
        const dialog = panel.querySelector(selectors.panelDialog);
        const focusTarget = panel.querySelector(selectors.panelClose) || dialog;

        if (dialog && theme.a11y && typeof theme.a11y.trapFocus === 'function') {
          theme.a11y.trapFocus({
            container: panel,
            elementToFocus: focusTarget,
            namespace: 'pdp_mobile_panel'
          });
        }
      });
    }

    function updatePaymentCards(root, cents) {
      if (!root || cents == null || Number.isNaN(Number(cents))) {
        return;
      }

      root.querySelectorAll(selectors.paymentInstallment).forEach((node) => {
        const installments = Number(node.dataset.installments || 1);
        if (!installments) {
          return;
        }

        node.innerHTML = theme.Currency.formatMoney(Math.round(Number(cents) / installments), theme.settings.moneyFormat);
      });

      root.querySelectorAll(selectors.paymentTotal).forEach((node) => {
        const installments = Number(node.dataset.installments || 1);
        node.innerHTML = theme.Currency.formatMoney(Math.round(Number(cents) / installments), theme.settings.moneyFormat);
      });

      root.querySelectorAll(selectors.paymentThreshold).forEach((node) => {
        node.innerHTML = theme.Currency.formatMoney(5000, theme.settings.moneyFormat);
      });
    }

    function updateMobileHeaderPrice(root, variant) {
      if (!root || !variant) {
        return;
      }

      root.querySelectorAll(selectors.mobilePrice).forEach((node) => {
        node.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
        node.classList.toggle('is-on-sale', variant.compare_at_price > variant.price);
      });

      root.querySelectorAll(selectors.mobileComparePrice).forEach((node) => {
        if (variant.compare_at_price > variant.price) {
          node.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
          node.classList.remove('hide');
        } else {
          node.innerHTML = '';
          node.classList.add('hide');
        }
      });
    }

    function bindRoot(root) {
      if (!root || root.dataset.pdpMobileBound === 'true') {
        return;
      }

      root.dataset.pdpMobileBound = 'true';
      updatePaymentCards(root, Number(root.dataset.pdpInitialPrice || 0));

      const initialVariantJson = root.querySelector('[data-current-variant-json]');
      if (initialVariantJson) {
        try {
          updateMobileHeaderPrice(root, JSON.parse(initialVariantJson.textContent));
        } catch (error) {
          console.error(error);
        }
      }

      portalPanels(root);
      (root.__pdpPanels || []).forEach(enableDetailsSwipe);
      (root.__pdpPanels || []).forEach(enablePanelDrag);

      root.querySelectorAll(selectors.panelOpen).forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      root.addEventListener('variantChange', function (event) {
        if (!event.detail || !event.detail.variant) {
          return;
        }

        updatePaymentCards(root, Number(event.detail.variant.price || 0));
        (root.__pdpPanels || []).forEach((panel) => {
          updatePaymentCards(panel, Number(event.detail.variant.price || 0));
        });
        updateMobileHeaderPrice(root, event.detail.variant);
      });

      root.addEventListener('click', function (event) {
        const openButton = event.target.closest(selectors.panelOpen);
        if (openButton) {
          const panel = getPanelById(openButton.dataset.pdpPanelId);
          if (panel) {
            event.preventDefault();
            openPanel(panel, openButton, openButton.dataset.pdpTab || null);
            return;
          }
        }

        const closeButton = event.target.closest(selectors.panelClose);
        if (closeButton) {
          const panel = closeButton.closest(selectors.panel);
          if (panel) {
            event.preventDefault();
            closePanel(panel);
            return;
          }
        }

        const tabButton = event.target.closest(selectors.detailsTabButton);
        if (tabButton) {
          const panel = tabButton.closest(selectors.panel);
          if (panel) {
            event.preventDefault();
            setActiveDetailsTab(panel, tabButton.dataset.pdpDetailsTabButton);
          }
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !activePanel) {
        return;
      }

      closePanel(activePanel);
    });

    document.addEventListener('click', function (event) {
      const closeButton = event.target.closest(selectors.panelClose);
      if (closeButton) {
        const panel = closeButton.closest(selectors.panel);
        if (panel) {
          event.preventDefault();
          closePanel(panel);
          return;
        }
      }

      const tabButton = event.target.closest(selectors.detailsTabButton);
      if (tabButton) {
        const panel = tabButton.closest(selectors.panel);
        if (panel) {
          event.preventDefault();
          setActiveDetailsTab(panel, tabButton.dataset.pdpDetailsTabButton);
        }
      }
    });

    function preventBackgroundPanelScroll(event) {
      if (!activePanel) {
        return;
      }

      const dialog = activePanel.querySelector(selectors.panelDialog);
      if (dialog && dialog.contains(event.target)) {
        return;
      }

      event.preventDefault();
    }

    document.addEventListener('wheel', preventBackgroundPanelScroll, { passive: false });
    document.addEventListener('touchmove', preventBackgroundPanelScroll, { passive: false });

    document.addEventListener('matchSmall', function () {
      document.querySelectorAll(selectors.root).forEach(bindRoot);
    });

    document.addEventListener('unmatchSmall', function () {
      if (activePanel) {
        finishClose(activePanel);
      }
    });

    DOMready(function () {
      document.querySelectorAll(selectors.root).forEach(bindRoot);
    });

    // When a sibling colourway is swapped in via AJAX the previous section
    // (and its DOMready binding) is gone. Its panels were portaled to <body>,
    // so they linger as orphans with duplicate ids — getPanelById() would then
    // resolve to the stale panel and open the wrong content. Remove those
    // orphans, then bind the freshly swapped-in root.
    document.addEventListener('dfyne:sibling-product:loaded', function (event) {
      var scope = (event.detail && event.detail.productSection) || document;
      var newRoot = (scope.matches && scope.matches(selectors.root))
        ? scope
        : (scope.querySelector ? scope.querySelector(selectors.root) : null);
      if (!newRoot) return;

      var freshIds = Array.prototype.map.call(
        newRoot.querySelectorAll(selectors.panel),
        function (panel) { return panel.id; }
      );

      Array.prototype.slice.call(document.querySelectorAll(selectors.panel)).forEach(function (panel) {
        if (panel.parentNode === document.body && !newRoot.contains(panel) && freshIds.indexOf(panel.id) !== -1) {
          panel.remove();
        }
      });

      bindRoot(newRoot);
    });
  })();
  /* Mobile PDP panels end */

  /* PDP fit badge popover start */
  (function () {
    function closeCard(card) {
      card.hidden = true;
      var wrap = card.closest('[data-fit-badge]');
      var toggle = wrap && wrap.querySelector('[data-fit-badge-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    function closeAllCards() {
      document.querySelectorAll('[data-fit-badge-card]:not([hidden])').forEach(closeCard);
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-fit-badge-toggle]');

      if (toggle) {
        var wrap = toggle.closest('[data-fit-badge]');
        var card = wrap && wrap.querySelector('[data-fit-badge-card]');
        if (!card) {
          return;
        }

        var willOpen = card.hidden;
        closeAllCards();
        if (willOpen) {
          card.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // Any click outside the card closes it; a click on the card's size-guide
      // link also closes it (the details panel is opening on top).
      var insideCard = event.target.closest('[data-fit-badge-card]');
      if (!insideCard || event.target.closest('[data-pdp-panel-open]')) {
        closeAllCards();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllCards();
      }
    });
  })();
  /* PDP fit badge popover end */

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };

    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function () {
        this.resize();
      }.bind(this)));

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) { // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) { AOS.refresh() }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function () {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }

        this.slideshow.destroy();
      },
      reposition: function () {
        this.slideshow.reposition();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);

          link.addEventListener('click', function (evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function (evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function (evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: 'disabled'
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));

        // Set default state based on current selected variant
        this.setInitialAvailability();
      },

      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {

          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {

            if (variant[index] === null) return;

            let entry = options[index].find(option => option.value === variant[index]);

            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = { value: variant[index], soldOut: true }
              options[index].push(entry);
            }

            const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })

          return options;
        }, { option1: [], option2: [], option3: [] })
      },

      setInitialAvailability: function () {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });

        const currentlySelectedValues = this.currentVariantObject.options.map((value, index) => { return { value, index: `option${index + 1}` } })
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);

        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },

      setAvailability: function (evt) {

        const { value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant } = evt.detail;

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="' + option + '"]');

        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      },

      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

        if (this.type === 'dropdown') {
          if (obj.soldOut) {
            group.querySelector('option[value="' + value + '"]').disabled = true;
          } else {
            group.querySelector('option[value="' + value + '"]').disabled = false;
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="' + value + '"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },

      disableVariantGroup: function (group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }

    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;
    var vimeoPlayer;

    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }

    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });

    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });

    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });

    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });

    document.addEventListener('modalClose.VideoModal', closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }

    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match && match[7].length == 11) ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };


  /*============================================================================
    ToolTip
  ==============================================================================*/

  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');

      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');

      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }

    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;

      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }

      this._lockScrolling();

      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }

      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });

      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });

      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }

    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';

      this._unlockScrolling();

      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }

    _lockScrolling() {
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }

    _unlockScrolling() {
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }

  customElements.define('tool-tip', ToolTip);

  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/

  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }

    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });

      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }

  customElements.define('tool-tip-trigger', ToolTipTrigger);

  /*============================================================================
    NewsletterReminder
  ==============================================================================*/

  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');

      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${this.id}`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');

      this.init();
    }

    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true)
        }
      });

      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });

      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));

      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
      });

      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
        this.dispatchEvent(reminderOpen);

        this.hide();
      });
    }

    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');

      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          sessionStorage.setItem('reminderAppeared', true);
        }, time * 1000);
      }
    }

    hide() {
      this.dataset.enabled = 'false';
    }
  }

  customElements.define('newsletter-reminder', NewsletterReminder);

  /*============================================================================
    ImageElement
  ==============================================================================*/

  class ImageElement extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        this.removeAnimations();

        observer.unobserve(this);
      }

      // Set an IntersectionObserver to check if the image is nearly in the viewport
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }

    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest('.image-wrap');
      const skrimWrap = this.closest('.skrim__link');

      if (imageWrap) {
        imageWrap.classList.add('loaded');
      }

      if (skrimWrap) {
        skrimWrap.classList.add('loaded');
      }
    }
  }

  customElements.define('image-element', ImageElement);

  /*============================================================================
    PredictiveSearch
  ==============================================================================*/

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-results]');
      this.predictiveSearchFooter = this.querySelector('[data-predictive-footer]');
      this.closeBtn = this.querySelector('[data-predictive-close]');
      this.clearBtn = this.querySelector('[data-predictive-clear]');
      this.screen = this.querySelector('[data-screen]');
      this.headerContainer = this.closest('.site-header__search-container') || null;
      this.SearchModal = this.closest('#SearchModal') || null;

      if (!this.input || !this.predictiveSearchResults) return;

      this.updateActionVisibility();

      // Recently viewed grid in search
      this.recentlyViewedGrid = this.querySelector('[data-recently-viewed-grid]');
      this.recentlyViewedSection = this.querySelector('[data-recently-viewed-search]');
      this._recentlyViewedLoaded = false;
      this._recentlyViewedPromise = null;
      this._bestSellersPromise = null;
      this._promotedStockProducts = null;
      this._promotedStockHandleMap = null;
      this._promotedStockHandlePromise = null;
      this._fallbackFetchKey = '';
      this._fallbackRenderPromise = null;

      try {
        this._searchDebug = /[?&]searchdebug=1\b/.test(window.location.search);
      } catch (e) {
        this._searchDebug = false;
      }
      this._savedScrollY = 0;
      this._bodyLockStyles = null;
      this._touchMoveBlocker = null;
      this._viewportResizeHandler = null;
      this._shellTouchStartX = 0;
      this._shellTouchStartY = 0;
      this._shellTouchLastY = 0;
      this._shellTouchStartHandler = null;
      this._shellTouchMoveHandler = null;
      this._shellTouchEndHandler = null;

      // Catalogue-word dictionary, loaded lazily by _ensureSearchDict().
      // Used by _correctSuggestionText to skip typo-correction when the user
      // typed a real catalogue word (e.g. "light" must not become "tight").
      this._searchDict = null;
      this._searchDictPromise = null;

      // Warm recently-viewed / dictionary / promoted-stock on first search
      // INTENT (hover/focus/touch on a search opener, or the open event)
      // rather than on page load. The dictionary + promoted-stock warmups
      // fetch several hundred KB of products.json — every fresh page view
      // paid that even when search was never touched. Intent warming keeps
      // the first keystroke fast (hover→click gives the fetches a head
      // start; sessionStorage caches persist across pages) without taxing
      // every landing.
      if (this.context === 'header') {
        var preloadSelf = this;
        var preload = function() {
          if (!preloadSelf.recentlyViewedGrid) preloadSelf.recentlyViewedGrid = preloadSelf.querySelector('[data-recently-viewed-grid]');
          if (!preloadSelf.recentlyViewedSection) preloadSelf.recentlyViewedSection = preloadSelf.querySelector('[data-recently-viewed-search]');
          if (!preloadSelf.emptyState) preloadSelf.emptyState = preloadSelf.querySelector('[data-predictive-empty]');
          preloadSelf.syncRecentlyViewedStorage();
          if (preloadSelf.recentlyViewedGrid && !preloadSelf._recentlyViewedLoaded) {
            preloadSelf.loadRecentlyViewed();
          }
          preloadSelf._ensureSearchDict();
          // Warm the promoted-stock fetch (paginated 1-4 pages) so the first
          // keystroke doesn't pay its 500-2000ms cold cost.
          preloadSelf._prefetchPromotedStockHandles();
        };
        var warmed = false;
        var warm = function() {
          if (warmed) return;
          warmed = true;
          preload();
        };
        var bindIntent = function() {
          document.querySelectorAll('.js-search-header').forEach(function(el) {
            ['pointerover', 'focusin', 'touchstart'].forEach(function(evt) {
              el.addEventListener(evt, warm, { once: true, passive: true });
            });
          });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', bindIntent, { once: true });
        } else {
          bindIntent();
        }
        document.addEventListener('predictive-search:open', warm, { once: true });
      }

      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;

        // Re-query elements in case they weren't ready at construction
        if (!this.recentlyViewedGrid) this.recentlyViewedGrid = this.querySelector('[data-recently-viewed-grid]');
        if (!this.recentlyViewedSection) this.recentlyViewedSection = this.querySelector('[data-recently-viewed-search]');
        if (!this.emptyState) this.emptyState = this.querySelector('[data-predictive-empty]');
        if (!this.predictiveSearchFooter) this.predictiveSearchFooter = this.querySelector('[data-predictive-footer]');

        this.input.value = '';
        this.resetResults();
        this.classList.add('is-active');
        this.bindMobileViewport();
        this.bindShellEdgeGuard();
        this.updateActionVisibility();

        // Load recently viewed on every open if not yet loaded successfully
        if (!this._recentlyViewedLoaded && this.recentlyViewedGrid) {
          // Re-read localStorage in case it was updated after page init
          this.syncRecentlyViewedStorage();
          this.loadRecentlyViewed();
        }

        this.lockPageScroll();

        // Wait for opening events to finish then apply focus
        setTimeout(() => { this.input.focus(); }, 100);
      });

      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { this.input.focus(); }, 100);
              }
            }
          });
        });

        observer.observe(this.SearchModal, {
          attributes: true
        });
      }

      if (this.enabled === 'false') return;

      // Prevent empty search submission
      var form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          if (!this.input.value.trim()) {
            e.preventDefault();
          }
        });
      }

      // On typing
      this._isComposing = false;
      this._searchAbortController = null;
      this._debounceTimer = null;
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });
      this.input.addEventListener('input', () => {
        this.updateActionVisibility();
        this.showInstantFooter();
        this.prefetchColourFallbackFromInput();
      });
      this.input.addEventListener('search', () => { this.onChange(); });

      // Guard against Android Chrome IME composition events.
      // Android fires input events DURING composition with intermediate values.
      // compositionend triggers the search once the input settles, then clears
      // the debounce timer to prevent a duplicate fetch 200ms later.
      this.input.addEventListener('compositionstart', () => { this._isComposing = true; });
      this.input.addEventListener('compositionend', () => {
        this._isComposing = false;
        clearTimeout(this._debounceTimer);
        this.onChange();
      });

      this.input.addEventListener('input', ((event) => {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          if (this._isComposing) return;
          this.onChange(event);
        }, 200);
      }));

      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
      }
      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', e => {
          e.preventDefault();
          this.clearQuery({ focus: true });
        });
      }
      if (this.screen) {
        this.screen.addEventListener('click', () => { this.close(); });
      }
      if (this.headerContainer) {
        this.headerContainer.addEventListener('click', (event) => {
          if (!this.isMobileHeaderSearch()) return;
          if (!this.classList.contains('is-active')) return;
          if (this.headerContainer.classList.contains('search-mode-full')) return;
          if (this.isEventInsideSearch(event)) return;
          this.close();
        });
      }

      // Close on outside click — skip the click that opened the search
      var _justOpened = false;
      document.addEventListener('predictive-search:open', () => {
        _justOpened = true;
        requestAnimationFrame(() => { _justOpened = false; });
      });
      document.addEventListener('click', (e) => {
        if (_justOpened) return;
        if (!this.classList.contains('is-active')) return;
        if (this.isMobileHeaderSearch()) return;
        if (this.isEventInsideSearch(e)) return;
        this.close();
      });

      // Popular search pills are all <a> tags — navigate natively
      this.emptyState = this.querySelector('[data-predictive-empty]');
    }

    syncRecentlyViewedStorage() {
      if (!theme.config.hasLocalStorage) return;

      var stored = window.localStorage.getItem('theme-recent');
      if (!stored) {
        theme.recentlyViewed.recent = {};
        return;
      }

      try { theme.recentlyViewed.recent = JSON.parse(stored); } catch(e) {}
    }

    isMobileHeaderSearch() {
      return this.context === 'header' && theme.config.bpSmall && !!this.headerContainer;
    }

    isEventInsideSearch(event) {
      if (typeof event.composedPath === 'function') {
        var path = event.composedPath();
        if (path && path.indexOf(this) !== -1) {
          return true;
        }
      }

      return !!(event.target && this.contains(event.target));
    }

    updateHeaderSearchState() {
      if (!this.headerContainer) return;

      this.headerContainer.classList.remove('search-mode-compact', 'search-mode-full');

      if (!this.isMobileHeaderSearch() || !this.classList.contains('is-active')) {
        return;
      }

      if (this.input.value.trim().length > 0) {
        this.headerContainer.classList.add('search-mode-full');
      } else {
        this.headerContainer.classList.add('search-mode-compact');
      }
    }

    setMobileViewportHeight() {
      if (!this.isMobileHeaderSearch()) return;

      var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      this.headerContainer.style.setProperty('--predictive-mobile-height', Math.round(viewportHeight) + 'px');
    }

    getSearchShell() {
      return this.querySelector('.predictive-search__shell');
    }

    bindMobileViewport() {
      if (!this.isMobileHeaderSearch()) return;

      if (!this._viewportResizeHandler) {
        this._viewportResizeHandler = this.setMobileViewportHeight.bind(this);
      }

      this.setMobileViewportHeight();

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this._viewportResizeHandler);
      } else {
        window.addEventListener('resize', this._viewportResizeHandler);
      }
    }

    unbindMobileViewport() {
      if (this._viewportResizeHandler) {
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', this._viewportResizeHandler);
        } else {
          window.removeEventListener('resize', this._viewportResizeHandler);
        }
      }

      if (this.headerContainer) {
        this.headerContainer.style.removeProperty('--predictive-mobile-height');
      }
    }

    bindShellEdgeGuard() {
      if (!this.isMobileHeaderSearch() || this._shellTouchMoveHandler) {
        return;
      }

      var shell = this.getSearchShell();
      if (!shell) {
        return;
      }

      this._shellTouchStartHandler = (event) => {
        if (!this.headerContainer || !this.headerContainer.classList.contains('search-mode-full')) return;
        if (!event.touches || event.touches.length !== 1) return;

        var touch = event.touches[0];
        this._shellTouchStartX = touch.clientX;
        this._shellTouchStartY = touch.clientY;
        this._shellTouchLastY = touch.clientY;
      };

      this._shellTouchMoveHandler = (event) => {
        if (!this.headerContainer || !this.headerContainer.classList.contains('search-mode-full')) return;
        if (!event.touches || event.touches.length !== 1) return;

        var activeShell = this.getSearchShell();
        if (!activeShell) return;

        var touch = event.touches[0];
        var deltaX = Math.abs(touch.clientX - this._shellTouchStartX);
        var deltaY = Math.abs(touch.clientY - this._shellTouchStartY);
        var directionY = touch.clientY - this._shellTouchLastY;

        this._shellTouchLastY = touch.clientY;

        // Preserve horizontal swipes inside result carousels.
        if (deltaX > deltaY) {
          return;
        }

        var maxScrollTop = activeShell.scrollHeight - activeShell.clientHeight;
        if (maxScrollTop <= 0) {
          event.preventDefault();
          return;
        }

        var atTop = activeShell.scrollTop <= 0;
        var atBottom = activeShell.scrollTop >= maxScrollTop - 1;

        if ((atTop && directionY > 0) || (atBottom && directionY < 0)) {
          event.preventDefault();
        }
      };

      this._shellTouchEndHandler = () => {
        this._shellTouchLastY = 0;
      };

      shell.addEventListener('touchstart', this._shellTouchStartHandler, { passive: true });
      shell.addEventListener('touchmove', this._shellTouchMoveHandler, { passive: false });
      shell.addEventListener('touchend', this._shellTouchEndHandler);
      shell.addEventListener('touchcancel', this._shellTouchEndHandler);
    }

    unbindShellEdgeGuard() {
      var shell = this.getSearchShell();

      if (shell && this._shellTouchStartHandler) {
        shell.removeEventListener('touchstart', this._shellTouchStartHandler);
      }

      if (shell && this._shellTouchMoveHandler) {
        shell.removeEventListener('touchmove', this._shellTouchMoveHandler);
      }

      if (shell && this._shellTouchEndHandler) {
        shell.removeEventListener('touchend', this._shellTouchEndHandler);
        shell.removeEventListener('touchcancel', this._shellTouchEndHandler);
      }

      this._shellTouchStartX = 0;
      this._shellTouchStartY = 0;
      this._shellTouchLastY = 0;
      this._shellTouchStartHandler = null;
      this._shellTouchMoveHandler = null;
      this._shellTouchEndHandler = null;
    }

    lockPageScroll() {
      document.documentElement.classList.add('predictive-overflow-hidden');
      document.body.classList.add('predictive-overflow-hidden');

      if (!this.isMobileHeaderSearch() || this._bodyLockStyles) {
        return;
      }

      this._savedScrollY = window.scrollY || window.pageYOffset || 0;
      this._bodyLockStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width
      };

      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this._savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      if (!this._touchMoveBlocker) {
        this._touchMoveBlocker = (event) => {
          var shell = this.querySelector('.predictive-search__shell');
          if (shell && shell.contains(event.target)) return;
          event.preventDefault();
        };

        document.addEventListener('touchmove', this._touchMoveBlocker, { passive: false });
      }
    }

    unlockPageScroll() {
      document.documentElement.classList.remove('predictive-overflow-hidden');
      document.body.classList.remove('predictive-overflow-hidden');

      if (this._touchMoveBlocker) {
        document.removeEventListener('touchmove', this._touchMoveBlocker);
        this._touchMoveBlocker = null;
      }

      if (!this._bodyLockStyles) {
        return;
      }

      var scrollY = this._savedScrollY || Math.abs(parseInt(document.body.style.top || '0', 10)) || 0;
      document.body.style.position = this._bodyLockStyles.position;
      document.body.style.top = this._bodyLockStyles.top;
      document.body.style.left = this._bodyLockStyles.left;
      document.body.style.right = this._bodyLockStyles.right;
      document.body.style.width = this._bodyLockStyles.width;

      this._bodyLockStyles = null;
      this._savedScrollY = 0;

      window.requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });
    }

    updateActionVisibility() {
      const hasQuery = this.input.value.trim().length > 0;

      if (this.clearBtn) {
        this.clearBtn.classList.toggle('hide', !hasQuery);
      }

      if (this.emptyState) {
        this.emptyState.style.display = hasQuery ? 'none' : '';
      }

      this.classList.toggle('has-query', hasQuery);
      this.updateHeaderSearchState();
    }

    clearQuery(options = {}) {
      this.input.value = '';
      this.resetResults();
      this.updateActionVisibility();

      if (options.focus) {
        this.input.focus();
      }
    }

    resetResults() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      // Only clear footer if input is empty — keep it visible while typing
      if (this.predictiveSearchFooter && !this.input.value.trim()) {
        this.predictiveSearchFooter.innerHTML = '';
        this.predictiveSearchFooter.classList.remove('footer--instant');
      }
      this.input.setAttribute('aria-expanded', 'false');
    }

    /* Lazily resolve the SearchCorrector dictionary into a Set so we can
     * cheaply check whether a user-typed word is a real catalogue term.
     * Called from preload() and from getSearchResults() to keep the cache
     * warm without blocking the predictive request. */
    _ensureSearchDict() {
      if (this._searchDict || this._searchDictPromise) return this._searchDictPromise;
      if (!theme.searchDictionary || typeof theme.searchDictionary.get !== 'function') return null;
      var self = this;
      this._searchDictPromise = theme.searchDictionary.get().then(function(dict) {
        var set = new Set();
        (dict || []).forEach(function(entry) {
          if (typeof entry !== 'string') return;
          set.add(entry.toLowerCase());
          entry.toLowerCase().split(/\s+/).forEach(function(w) {
            if (w.length > 1) set.add(w);
          });
        });
        self._searchDict = set;
        return set;
      }).catch(function() { return null; });
      return this._searchDictPromise;
    }

    /* Correct misspelled clothing terms in suggestion text.
     * Shopify's predictive API parrots the user's input in query suggestions,
     * so a typo like "ahorts" yields "impact ahorts", "defy ahorts", etc.
     * This scans each suggestion word and replaces it if it's within
     * Levenshtein distance 1 of a known clothing type.
     *
     * Two guards keep this safe:
     *   1. Only rewrite words the user actually typed — catalogue-added words
     *      (e.g. "light" in a "pink"-query suggestion) are left alone.
     *   2. Even for user-typed words, skip rewrite when the word exists in
     *      the SearchCorrector dictionary — i.e. it's a real catalogue term
     *      (e.g. "light" → must NOT become "tight"). If the dict hasn't
     *      finished loading, we skip correction entirely (wrong rewrite is
     *      worse than no rewrite). */
    _correctSuggestionText(searchTerm) {
      // Make sure the dict load is in flight — first overlay open may hit
      // _correctSuggestionText before preload() has had a chance to run.
      this._ensureSearchDict();

      var userWords = {};
      (searchTerm || '').trim().toLowerCase().split(/\s+/).forEach(function(word) {
        if (word) userWords[word] = true;
      });

      var dict = this._searchDict;

      var knownTerms = [
        'short', 'shorts', 'tops', 'top', 'leggings', 'legging',
        'flares', 'flare', 'joggers', 'jogger',
        'hoodies', 'hoodie', 'bras', 'bra', 'jackets', 'jacket',
        'sports', 'sport', 'trousers', 'trouser',
        'shirts', 'shirt', 'tank', 'tanks', 'tights', 'tight',
        'bottoms', 'bottom', 'pants', 'pant', 'vests', 'vest',
        'crop', 'crops', 'impact', 'defy', 'power', 'seamless', 'ribbed'
      ];

      function editDistance(a, b) {
        var m = a.length, n = b.length;
        if (Math.abs(m - n) > 1) return 2; // fast reject
        var dp = [];
        for (var i = 0; i <= m; i++) dp[i] = [i];
        for (var j = 0; j <= n; j++) dp[0][j] = j;
        for (var i = 1; i <= m; i++) {
          for (var j = 1; j <= n; j++) {
            if (a[i - 1] === b[j - 1]) dp[i][j] = dp[i - 1][j - 1];
            else dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
          }
        }
        return dp[m][n];
      }

      var suggestions = this.predictiveSearchResults.querySelectorAll('.ps-suggestion-item span');
      suggestions.forEach(function(span) {
        var text = span.textContent;
        var words = text.split(/\s+/);
        var changed = false;
        var corrected = words.map(function(word) {
          var lower = word.toLowerCase();
          // Only rewrite words the user actually typed — leave catalogue words alone
          if (!userWords[lower]) return word;
          // Skip if it's already a known term
          if (knownTerms.indexOf(lower) !== -1) return word;
          // Skip if the user's word is itself a real catalogue term
          // (e.g. "light" appears in product titles — must not rewrite to "tight").
          // If the dictionary hasn't loaded yet, skip correction entirely:
          // a wrong rewrite is worse than no rewrite.
          if (!dict) return word;
          if (dict.has(lower)) return word;
          // Check if within distance 1 of any known term
          for (var k = 0; k < knownTerms.length; k++) {
            if (editDistance(lower, knownTerms[k]) === 1) {
              changed = true;
              return knownTerms[k];
            }
          }
          return word;
        });
        if (changed) {
          // Deduplicate: if correction creates a duplicate suggestion, hide it
          var correctedText = corrected.join(' ');
          span.textContent = correctedText;
          // Update parent link href to use corrected term
          var link = span.closest('a');
          if (link) {
            link.href = '/search?q=' + encodeURIComponent(correctedText) + '&type=product';
          }
        }
      });

      // Remove duplicate suggestions after correction
      var seen = {};
      suggestions.forEach(function(span) {
        var key = span.textContent.toLowerCase().trim();
        if (seen[key]) {
          var li = span.closest('li');
          if (li) li.remove();
        } else {
          seen[key] = true;
        }
      });
    }

    _highlightSuggestionKeywords(searchTerm) {
      var rawTerm = (searchTerm || '').trim();
      if (!rawTerm) return;

      function escapeRegExp(value) {
        return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }

      var tokenMap = {};
      rawTerm.split(/\s+/).forEach(function(token) {
        var trimmedToken = token.trim();
        if (trimmedToken) {
          tokenMap[trimmedToken.toLowerCase()] = trimmedToken;
        }
      });

      var tokens = Object.keys(tokenMap)
        .map(function(key) { return tokenMap[key]; })
        .sort(function(a, b) { return b.length - a.length; });

      if (!tokens.length) return;

      var highlightRegex = new RegExp('(' + tokens.map(escapeRegExp).join('|') + ')', 'ig');
      var self = this;
      var suggestions = this.predictiveSearchResults.querySelectorAll('.ps-suggestion-item span');

      suggestions.forEach(function(span) {
        var text = span.textContent || '';
        if (!text) return;

        span.innerHTML = self._escapeHtml(text).replace(highlightRegex, '<strong class="ps-suggestion-item__match">$1</strong>');
      });
    }

    showInstantFooter() {
      var term = this.input.value.trim();
      if (!term || !this.predictiveSearchFooter) return;

      // Predictive responses can remove this class when they provide their own
      // footer markup, so always restore it for instant-footer state updates.
      this.predictiveSearchFooter.classList.add('footer--instant');

      var url = '/search?q=' + encodeURIComponent(term) + '&type=product';
      var existingLink = this.predictiveSearchFooter.querySelector('.results__search-btn');

      if (existingLink) {
        // Just update text and href — don't rebuild HTML
        existingLink.href = url;
        existingLink.querySelector('span').textContent = 'Show all results for \u201c' + term + '\u201d';
      } else {
        // First keystroke — build the footer
        this.predictiveSearchFooter.classList.add('footer--instant');
        this.predictiveSearchFooter.innerHTML =
          '<div class="results__search-bar">' +
            '<div class="results__search-bar-inner">' +
              '<a class="results__search-btn" href="' + url + '">' +
                '<span>Show all results for \u201c' + term.replace(/</g, '&lt;') + '\u201d</span>' +
                '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 5H9M9 5L5.5 1.5M9 5L5.5 8.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '</a>' +
            '</div>' +
          '</div>';
      }
    }
    // recently viewed products from localStorage, fetch their data, and render them in the search dropdown.
    loadRecentlyViewed() {
      if (this._recentlyViewedLoaded) {
        return Promise.resolve();
      }

      if (this._recentlyViewedPromise) {
        return this._recentlyViewedPromise;
      }

      this.syncRecentlyViewedStorage();

      var hasRecent = theme.recentlyViewed && theme.recentlyViewed.recent && Object.keys(theme.recentlyViewed.recent).length > 0;

      if (!hasRecent) {
        // No recently viewed — load best sellers instead
        return this.loadBestSellers();
      }

      var handles = Object.keys(theme.recentlyViewed.recent);

      var limit = 5;
      var recentHandles = handles.slice(-limit).reverse();
      var promises = recentHandles.map(handle => {
        if (theme.recentlyViewed.productInfo && theme.recentlyViewed.productInfo[handle]) {
          var cached = theme.recentlyViewed.productInfo[handle];
          // Ensure cached data is an object, not a raw JSON string
          if (typeof cached === 'string') {
            try { cached = JSON.parse(cached); } catch(e) { cached = null; }
          }
          if (cached && cached.featured_image) return Promise.resolve(cached);
        }
        return theme.fetchProductJson(handle)
          .then(product => {
            if (!product) {
              // Deleted product still lingering in recently-viewed storage —
              // drop it so it isn't retried on the next open. The shared cache
              // already prevents a second network hit this page.
              theme.removeRecentlyViewedHandle(handle);
              return null;
            }
            if (theme.recentlyViewed.productInfo) {
              theme.recentlyViewed.productInfo[handle] = product;
            }
            return product;
          })
          .catch(() => null);
      });

      this._recentlyViewedPromise = Promise.all(promises).then(products => {
        var html = '';
        var label = this.querySelector('[data-rv-label]');
        products.forEach((product, index) => {
          if (!product || !product.featured_image) return;
          var price = theme.Currency ? theme.Currency.formatMoney(product.price, theme.moneyFormat) : '$' + (product.price / 100).toFixed(2);
          var imgUrl = product.featured_image.replace(/\.([^.]+)$/, '_360x.$1');

          var colorName = this._extractSapgColor(product.tags);

          html += '<a class="rv-search-card rv-search-card--reveal" style="animation-delay:' + (index * 0.08) + 's" href="' + product.url + '">' +
            '<div class="rv-search-card__image">' +
              '<img src="' + imgUrl + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="eager" />' +
            '</div>' +
            '<div class="rv-search-card__info">' +
              '<span class="rv-search-card__title">' + product.title + '</span>' +
              (colorName ? '<span class="rv-search-card__variant">' + colorName + '</span>' : '') +
              '<span class="rv-search-card__price">' + price + '</span>' +
            '</div>' +
          '</a>';
        });

        if (html && this.recentlyViewedGrid) {
          if (label) label.textContent = 'RECENTLY VIEWED';
          if (theme.config.hasSessionStorage) {
            sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
          }
          this.recentlyViewedGrid.innerHTML = html;
          this._recentlyViewedLoaded = true;
          if (this.recentlyViewedSection) this.recentlyViewedSection.style.display = 'block';
          if (this.emptyState) this.emptyState.classList.add('has-recently-viewed');
        } else {
          if (this.recentlyViewedSection) this.recentlyViewedSection.style.display = 'none';
          if (this.emptyState) this.emptyState.classList.remove('has-recently-viewed');
        }
      }).catch(() => {
        if (this.recentlyViewedSection) this.recentlyViewedSection.style.display = 'none';
        if (this.emptyState) this.emptyState.classList.remove('has-recently-viewed');
      }).finally(() => {
        this._recentlyViewedPromise = null;
      });

      return this._recentlyViewedPromise;
    }

    /* Load best sellers when no recently viewed products exist.
     * Fetches from /collections/all sorted by best-selling.
     * Uses the same card format and slider as recently viewed.
     * Cached in sessionStorage to avoid re-fetching. */
    loadBestSellers() {
      if (this._bestSellersPromise) {
        return this._bestSellersPromise;
      }

      var cached = theme.config.hasSessionStorage ? sessionStorage.getItem('search-best-sellers-v2') : null;
      if (cached) {
        try {
          this.renderBestSellers(JSON.parse(cached));
          return Promise.resolve();
        } catch(e) {}
      }

      // Fetch a larger candidate pool (25) so enough remain after filtering out sold-out products.
      this._bestSellersPromise = fetch('/collections/best-sellers-ranked/products.json?limit=25')
        .then(r => r.json())
        .then(data => {
          // Keep only products with at least one in-stock variant (available:true is present in the products.json payload).
          var products = (data && data.products) ? data.products.filter(function (p) {
            return p && p.variants && p.variants.some(function (v) { return v.available; });
          }) : [];
          if (products.length > 0) {
            if (theme.config.hasSessionStorage) {
              // Cache the filtered list under a versioned key so stale unfiltered caches invalidate on deploy.
              sessionStorage.setItem('search-best-sellers-v2', JSON.stringify(products));
            }
            this.renderBestSellers(products);
          } else {
            if (this.recentlyViewedSection) this.recentlyViewedSection.style.display = 'none';
            if (this.emptyState) this.emptyState.classList.remove('has-recently-viewed');
          }
        })
        .catch(() => {
          if (this.recentlyViewedSection) this.recentlyViewedSection.style.display = 'none';
          if (this.emptyState) this.emptyState.classList.remove('has-recently-viewed');
        })
        .finally(() => {
          this._bestSellersPromise = null;
        });

      return this._bestSellersPromise;
    }

    renderBestSellers(products) {
      var html = '';
      var count = 0;
      products.forEach(product => {
        if (!product || !product.images || !product.images.length) return;
        if (count >= 5) return;

        var price = theme.Currency ? theme.Currency.formatMoney(product.variants[0].price, theme.moneyFormat) : '$' + (product.variants[0].price / 100).toFixed(2);
        var imgUrl = product.images[0].src.replace(/\.([^.]+)$/, '_360x.$1');

        var colorName = this._extractSapgColor(product.tags);
        var productUrl = product.url || '/products/' + product.handle;

        html += '<a class="rv-search-card rv-search-card--reveal" style="animation-delay:' + (count * 0.05) + 's" href="' + productUrl + '">' +
          '<div class="rv-search-card__image">' +
            '<img src="' + imgUrl + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="eager" />' +
          '</div>' +
          '<div class="rv-search-card__info">' +
            '<span class="rv-search-card__title">' + product.title + '</span>' +
            (colorName ? '<span class="rv-search-card__variant">' + colorName + '</span>' : '') +
            '<span class="rv-search-card__price">' + price + '</span>' +
          '</div>' +
        '</a>';
        count++;
      });

      if (html && this.recentlyViewedGrid) {
        // Update the label to "BEST SELLERS"
        var label = this.querySelector('[data-rv-label]');
        if (label) label.textContent = 'BEST SELLERS';

        this.recentlyViewedGrid.innerHTML = html;
        this._recentlyViewedLoaded = true;
        if (this.recentlyViewedSection) this.recentlyViewedSection.style.display = 'block';
        if (this.emptyState) this.emptyState.classList.add('has-recently-viewed');
      } else {
        if (this.recentlyViewedSection) this.recentlyViewedSection.style.display = 'none';
        if (this.emptyState) this.emptyState.classList.remove('has-recently-viewed');
      }
    }

    /* Parse product cards from search HTML — collects up to 20 for randomisation */
    _parseProductsFromHTML(html) {
      return this._parseProductsFromDoc(new DOMParser().parseFromString(html, 'text/html'));
    }

    _parseProductsFromDoc(doc) {
      var gridItems = doc.querySelectorAll('.grid-product');
      var products = [];

      gridItems.forEach(function(item) {
        if (products.length >= 20) return;
        var link = item.querySelector('.grid-product__link');
        var img = item.querySelector('.grid-product__image-mask img');
        var titleEl = item.querySelector('.grid-product__title');
        // Get only the direct price text, not review stars or other nested elements
        var priceEl = item.querySelector('.grid-product__price');
        var price = '';
        if (priceEl) {
          // Clone and remove child elements to get only the price text
          var priceClone = priceEl.cloneNode(true);
          var children = priceClone.querySelectorAll('*');
          children.forEach(function(child) { child.remove(); });
          price = priceClone.textContent.trim();
          // If empty after stripping, try the original first text node
          if (!price) {
            for (var n = 0; n < priceEl.childNodes.length; n++) {
              if (priceEl.childNodes[n].nodeType === 3) {
                var t = priceEl.childNodes[n].textContent.trim();
                if (t) { price = t; break; }
              }
            }
          }
        }
        // Extract color: try active swatch label, then first swatch, then vendor
        var color = '';
        var activeSwatch = item.querySelector('.color-swatch--with-image.is-active, .grid-product__color-image.is-active');
        if (activeSwatch) {
          color = activeSwatch.getAttribute('aria-label') || activeSwatch.getAttribute('data-value') || '';
        }
        if (!color) {
          var firstSwatch = item.querySelector('.color-swatch--with-image, [data-swatch]');
          if (firstSwatch) {
            color = firstSwatch.getAttribute('aria-label') || firstSwatch.getAttribute('data-value') || '';
          }
        }
        if (!color) {
          var vendorEl = item.querySelector('.grid-product__vendor');
          if (vendorEl) color = vendorEl.textContent.trim();
        }
        // Capture every swatch label on the card so a colour search like "red"
        // can match a product even when its default variant isn't red. The
        // aria-label format from product-grid-item is "{title} - {value}",
        // so we also pull the trailing "{value}" segment out as a clean
        // colour token for the term filter.
        var allColors = [];
        item.querySelectorAll('.color-swatch[aria-label], .color-swatch[data-value], [data-swatch]').forEach(function(sw) {
          var label = sw.getAttribute('aria-label') || sw.getAttribute('data-value') || '';
          label = (label || '').trim();
          if (!label) return;
          if (allColors.indexOf(label) === -1) allColors.push(label);
          var dashIdx = label.lastIndexOf(' - ');
          if (dashIdx !== -1) {
            var tail = label.slice(dashIdx + 3).trim();
            if (tail && allColors.indexOf(tail) === -1) allColors.push(tail);
          }
        });
        if (!link || !titleEl) return;
        var handle = item.getAttribute('data-product-handle') || '';
        // Fallback: extract handle from product URL (/products/handle?...)
        if (!handle) {
          var href = link.getAttribute('href') || '';
          var match = href.match(/\/products\/([^?#/]+)/);
          if (match) handle = match[1];
        }
        products.push({
          url: link.getAttribute('href') || '',
          title: titleEl.textContent.trim(),
          image: img ? (img.getAttribute('src') || '') : '',
          price: price,
          color: color,
          allColors: allColors,
          handle: handle
        });
      });

      return products;
    }

    _setPromotedStockProducts(products) {
      var normalizedProducts = Array.isArray(products) ? products : [];
      var handleMap = {};

      normalizedProducts.forEach(function(product) {
        if (product && product.handle) {
          handleMap[product.handle.toLowerCase()] = true;
        }
      });

      this._promotedStockProducts = normalizedProducts;
      this._promotedStockHandleMap = handleMap;
    }
    // PROMOTED STOCK: Prefetch products from the "promoted stock" collection to exclude them from search suggestions.
    _prefetchPromotedStockHandles() {
      if (this._promotedStockProducts && this._promotedStockHandleMap) {
        return Promise.resolve(this._promotedStockProducts);
      }

      if (this._promotedStockHandlePromise) {
        return this._promotedStockHandlePromise;
      }

      var cacheKey = 'search-promoted-stock-products';
      var cacheVersion = 2;
      var cacheMaxAgeMs = 5 * 60 * 1000;
      var cached = theme.config.hasSessionStorage ? sessionStorage.getItem(cacheKey) : null;

      if (cached) {
        try {
          var parsedCache = JSON.parse(cached);
          var isVersionedCache = parsedCache && typeof parsedCache === 'object' && Array.isArray(parsedCache.products);

          if (isVersionedCache) {
            var cacheAge = Date.now() - (parsedCache.fetchedAt || 0);
            if (parsedCache.version === cacheVersion && cacheAge >= 0 && cacheAge < cacheMaxAgeMs) {
              this._setPromotedStockProducts(parsedCache.products);
              return Promise.resolve(this._promotedStockProducts);
            }
          }
        } catch (e) {}

        if (theme.config.hasSessionStorage) {
          sessionStorage.removeItem(cacheKey);
        }
      }

      var self = this;

      function fetchPage(page, collectedProducts) {
        return fetch('/collections/promoted-stock/products.json?limit=250&page=' + page)
          .then(function(response) { return response.json(); })
          .then(function(data) {
            var products = data && data.products ? data.products : [];
            var nextProducts = collectedProducts.concat(products);

            if (products.length === 250 && page < 4) {
              return fetchPage(page + 1, nextProducts);
            }

            return nextProducts;
          });
      }

      this._promotedStockHandlePromise = fetchPage(1, [])
        .then(function(products) {
          self._setPromotedStockProducts(products);

          if (theme.config.hasSessionStorage) {
            sessionStorage.setItem(cacheKey, JSON.stringify({
              version: cacheVersion,
              fetchedAt: Date.now(),
              products: self._promotedStockProducts
            }));
          }

          return self._promotedStockProducts;
        })
        .catch(function() {
          self._setPromotedStockProducts([]);
          return self._promotedStockProducts;
        })
        .finally(() => {
          this._promotedStockHandlePromise = null;
        });

      return this._promotedStockHandlePromise;
    }

    _extractCustomLabelFromTags(tags) {
      var normalizedTags = Array.isArray(tags) ? tags : [];

      for (var index = 0; index < normalizedTags.length; index++) {
        var tag = (normalizedTags[index] || '').trim();

        if (tag.indexOf('_label_') === 0) {
          return tag.replace('_label_', '');
        }
      }

      return '';
    }

    _escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    _getPredictiveProductHandles() {
      var handles = {};
      var cards = this.predictiveSearchResults.querySelectorAll('.ps-results__products-track .ps-product-card[data-product-handle]');

      cards.forEach(function(card) {
        var handle = (card.getAttribute('data-product-handle') || '').toLowerCase();
        if (handle) {
          handles[handle] = true;
        }
      });

      return handles;
    }

    _normalizeSearchText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    _expandSearchToken(token) {
      var variants = {};
      var normalizedToken = this._normalizeSearchText(token);

      if (!normalizedToken) return [];

      variants[normalizedToken] = true;

      if (normalizedToken.slice(-3) === 'ies' && normalizedToken.length > 3) {
        variants[normalizedToken.slice(0, -3) + 'y'] = true;
      }

      if (normalizedToken.slice(-1) === 's' && normalizedToken.length > 3) {
        variants[normalizedToken.slice(0, -1)] = true;
      } else if (normalizedToken.length > 2) {
        variants[normalizedToken + 's'] = true;
      }

      return Object.keys(variants);
    }

    _tokenizeSearchText(value) {
      var normalized = this._normalizeSearchText(value);
      return normalized ? normalized.split(/\s+/).filter(Boolean) : [];
    }

    _hasTokenMatch(text, token) {
      var expanded = this._expandSearchToken(token);
      var textTokens = this._tokenizeSearchText(text);

      for (var index = 0; index < expanded.length; index++) {
        if (textTokens.indexOf(expanded[index]) !== -1) {
          return true;
        }
      }

      return false;
    }

    // PROMOTED STOCK: Filter out internal marker tags so they don't contribute
    // spurious matches during scoring (SAPG::, JMR::, _label_, and the feature's
    // own promoted-stock* tags are not user-facing product attributes).
    _isUserFacingTag(tag) {
      var trimmed = (tag || '').trim();
      if (!trimmed) return false;
      var lower = trimmed.toLowerCase();
      if (lower === 'promoted-stock') return false;
      if (lower.indexOf('promoted-stock-search') === 0) return false;
      if (trimmed.indexOf('SAPG::') === 0) return false;
      if (trimmed.indexOf('JMR::') === 0) return false;
      if (trimmed.indexOf('_label_') === 0) return false;
      return true;
    }

    // PROMOTED STOCK: Gender filtering based on search term — if the search term strongly
    _getPromotedStockGenderFilter(searchTerm) {
      if (/\bmen\b|^mens$|^menswear$/i.test(searchTerm)) {
        return { include: ['mens', 'menswear'], exclude: ['womens', 'womenswear'] };
      }

      if (/\bwomen\b|^womens$|^womenswear$/i.test(searchTerm)) {
        return { include: ['womens', 'womenswear'], exclude: ['mens', 'menswear'] };
      }

      return null;
    }

    _getNormalizedProductTags(product) {
      var tags = product && product.tags ? product.tags : [];
      if (typeof tags === 'string') tags = tags.split(',');

      return tags.map((tag) => this._normalizeSearchText(tag)).filter(Boolean);
    }

    _matchesPromotedStockGender(product, genderFilter) {
      if (!genderFilter) return true;

      var tags = this._getNormalizedProductTags(product);
      var hasInclude = genderFilter.include.some(function(tag) { return tags.indexOf(tag) !== -1; });
      var hasExclude = genderFilter.exclude.some(function(tag) { return tags.indexOf(tag) !== -1; });

      if (hasExclude && !hasInclude) {
        return false;
      }

      return true;
    }

    _extractSapgColor(tags) {
      var list = tags || [];
      if (typeof list === 'string') list = list.split(',');
      for (var i = 0; i < list.length; i++) {
        var tag = (list[i] || '').trim();
        if (tag.indexOf('SAPG::') !== 0) continue;
        var parts = tag.split('::');
        if (parts.length >= 3 && parts[2]) return parts[2].trim();
      }
      return '';
    }

    _getPromotedStockColor(product) {
      return this._extractSapgColor(product && product.tags);
    }

    _buildPromotedStockCandidate(product) {
      if (!product || !product.handle) return null;

      var priceValue = product.price;
      if ((priceValue === undefined || priceValue === null) && product.variants && product.variants.length) {
        priceValue = product.variants[0].price;
      }

      var image = '';
      if (product.images && product.images.length) {
        image = product.images[0].src || product.images[0];
      } else if (product.image && product.image.src) {
        image = product.image.src;
      }

      return {
        handle: product.handle,
        title: product.title || '',
        url: product.url || '/products/' + product.handle,
        image: image,
        price: priceValue !== undefined && priceValue !== null
          ? (theme.Currency ? theme.Currency.formatMoney(priceValue, theme.moneyFormat) : '$' + (priceValue / 100).toFixed(2))
          : '',
        color: this._getPromotedStockColor(product)
      };
    }
    // PROMOTED STOCK: Field-weighted strict-AND scorer. Every query token must
    // match at least one searchable field on the product, otherwise score 0.
    // Scoring is per-token: each token picks the best field it hits and adds
    // that field's weight. Full-query substring matches in title/handle get
    // bonuses on top. Threshold is 30 — a single tag-only hit (+20) is not
    // enough on its own.
    _scorePromotedStockProduct(product, searchTerm) {
      var normalizedQuery = this._normalizeSearchText(searchTerm);
      if (!normalizedQuery) return 0;

      var tokens = normalizedQuery.split(/\s+/).filter(function(token) { return token.length > 1; });
      if (!tokens.length) return 0;

      var self = this;
      var title = this._normalizeSearchText(product.title || '');
      var handle = this._normalizeSearchText(product.handle || '');
      var productType = this._normalizeSearchText(product.product_type || '');
      var vendor = this._normalizeSearchText(product.vendor || '');
      var variantText = this._normalizeSearchText((product.variants || []).map(function(variant) {
        return variant && variant.title ? variant.title : '';
      }).join(' '));
      var color = this._normalizeSearchText(this._getPromotedStockColor(product) || '');

      var rawTags = product && product.tags ? product.tags : [];
      if (typeof rawTags === 'string') rawTags = rawTags.split(',');
      var userTags = rawTags.filter(function(t) { return self._isUserFacingTag(t); });
      var tagText = this._normalizeSearchText(userTags.join(' '));

      var score = 0;
      for (var i = 0; i < tokens.length; i++) {
        var expanded = this._expandSearchToken(tokens[i]);
        var bestFieldScore = 0;

        expanded.forEach(function(variant) {
          if (self._hasTokenMatch(title, variant)) bestFieldScore = Math.max(bestFieldScore, 40);
          if (self._hasTokenMatch(handle, variant)) bestFieldScore = Math.max(bestFieldScore, 30);
          if (color && self._hasTokenMatch(color, variant)) bestFieldScore = Math.max(bestFieldScore, 30);
          if (productType && self._hasTokenMatch(productType, variant)) bestFieldScore = Math.max(bestFieldScore, 25);
          if (tagText && self._hasTokenMatch(tagText, variant)) bestFieldScore = Math.max(bestFieldScore, 20);
          if (vendor && self._hasTokenMatch(vendor, variant)) bestFieldScore = Math.max(bestFieldScore, 15);
          if (variantText && self._hasTokenMatch(variantText, variant)) bestFieldScore = Math.max(bestFieldScore, 5);
        });

        if (bestFieldScore === 0) return 0; // strict-AND: any unmatched token disqualifies
        score += bestFieldScore;
      }

      if (title.indexOf(normalizedQuery) !== -1) score += 60;
      if (handle.indexOf(normalizedQuery) !== -1) score += 40;

      return score >= 30 ? score : 0;
    }

    // PROMOTED STOCK: Gather all qualifying candidates, take the top 5 by score,
    // pick one at random so the same query rotates across refreshes when multiple
    // promoted products are relevant. Fresh candidates (not already in the rendered
    // predictive list) are preferred; existing handles are only used as a fallback
    // when no fresh candidates exist.
    _findBestPromotedStockMatch(searchTerm, existingHandles) {
      if (!this._promotedStockProducts || !this._promotedStockProducts.length) return null;

      var self = this;
      var genderFilter = this._getPromotedStockGenderFilter(searchTerm);
      var freshCandidates = [];
      var existingCandidates = [];

      this._promotedStockProducts.forEach(function(product) {
        if (!self._matchesPromotedStockGender(product, genderFilter)) return;

        var score = self._scorePromotedStockProduct(product, searchTerm);
        if (score <= 0) return;

        var candidate = self._buildPromotedStockCandidate(product);
        if (!candidate) return;

        candidate.score = score;
        var handle = (candidate.handle || '').toLowerCase();

        if (handle && existingHandles[handle]) {
          existingCandidates.push(candidate);
        } else {
          freshCandidates.push(candidate);
        }
      });

      var pool = freshCandidates.length ? freshCandidates : existingCandidates;
      if (!pool.length) return null;

      pool.sort(function(a, b) { return b.score - a.score; });
      var topPool = pool.slice(0, 5);
      return topPool[Math.floor(Math.random() * topPool.length)];
    }

    _isPromotedStockProduct(product, promotedStockHandleMap) {
      if (!product) return false;

      var handle = (product.handle || '').toLowerCase();
      if (handle && promotedStockHandleMap && promotedStockHandleMap[handle]) {
        return true;
      }

      return Array.isArray(product.tags) && product.tags.indexOf('promoted-stock') !== -1;
    }

    _buildPredictiveCardHtml(product, animationIndex) {
      var title = product.title || '';
      var url = product.url || '';
      var imgUrl = product.image || product.featured_image || '';
      var price = product.price || '';
      var color = product.color || '';
      var handle = product.handle || '';

      if (!title || !url || !imgUrl) {
        return '';
      }

      imgUrl = imgUrl.replace(/\.([^.?#]+)(\?.*)?$/, '_360x.$1$2');

      return '<a class="ps-product-card rv-search-card--reveal" data-product-handle="' + this._escapeHtml(handle) + '" style="animation-delay:' + (animationIndex * 0.05) + 's" href="' + this._escapeHtml(url) + '">' +
        '<div class="ps-product-card__image">' +
          '<img src="' + this._escapeHtml(imgUrl) + '" alt="' + this._escapeHtml(title) + '" loading="eager" />' +
        '</div>' +
        '<div class="ps-product-card__info">' +
          '<span class="ps-product-card__title">' + this._escapeHtml(title) + '</span>' +
          (color ? '<span class="ps-product-card__variant">' + this._escapeHtml(color) + '</span>' : '') +
          (price ? '<span class="ps-product-card__price">' + price + '</span>' : '') +
        '</div>' +
      '</a>';
    }
    // PROMOTED STOCK: Main function to inject a "promoted stock" product into the predictive search results if it matches the search term better than existing suggestions, with caching and filtering to ensure relevance and avoid duplicates.
    _injectPromotedStock() {
      var self = this;
      var searchTerm = this.input && this.input.value ? this.input.value.trim() : '';

      return this._prefetchPromotedStockHandles()
        .then(function(results) {
          var products = results || [];
          var productTrack = self.predictiveSearchResults.querySelector('.ps-results__products-track');

          if (!productTrack || !products.length) return;

          var existingHandles = self._getPredictiveProductHandles();
          var matchedProduct = self._findBestPromotedStockMatch(searchTerm, existingHandles);

          // Remove promoted-stock products from predictive results — they should
          // only appear through the dedicated type-gated injection slot
          var cards = Array.prototype.slice.call(productTrack.querySelectorAll('.ps-product-card[data-product-handle]'));
          cards.forEach(function(card) {
            var cardHandle = (card.getAttribute('data-product-handle') || '').toLowerCase();
            var badge = card.querySelector('.ps-product-card__badge');
            if (badge) badge.remove();

            if (cardHandle && self._promotedStockHandleMap && self._promotedStockHandleMap[cardHandle]) {
              card.remove();
            }
          });

          if (!matchedProduct) return;

          // Re-count after removal
          var remainingCards = productTrack.querySelectorAll('.ps-product-card');
          var animationIndex = remainingCards.length >= 4 ? 3 : remainingCards.length;
          var cardHtml = self._buildPredictiveCardHtml(matchedProduct, animationIndex);
          if (!cardHtml) return;

          if (remainingCards.length >= 4 && productTrack.lastElementChild) {
            productTrack.removeChild(productTrack.lastElementChild);
          }

          productTrack.insertAdjacentHTML('beforeend', cardHtml);
        })
        .catch(function() {});
    }

    /* Predicate: does this parsed product genuinely match the user's term?
     * Word-prefix match against title, primary colour, and every swatch label
     * on the card. Used to drop Shopify's spurious fuzzy matches (e.g. "tight"
     * → Tote Bag) before they reach the dropdown. */
    _productMatchesTerm(product, termLower) {
      if (!product || !termLower) return false;
      function anyWordStartsWith(text) {
        if (!text) return false;
        var words = String(text).toLowerCase().split(/\s+/);
        for (var i = 0; i < words.length; i++) {
          if (words[i].indexOf(termLower) === 0) return true;
        }
        return false;
      }
      if (anyWordStartsWith(product.title)) return true;
      if (anyWordStartsWith(product.color)) return true;
      if (Array.isArray(product.allColors)) {
        for (var i = 0; i < product.allColors.length; i++) {
          if (anyWordStartsWith(product.allColors[i])) return true;
        }
      }
      if (Array.isArray(product.tags)) {
        for (var t = 0; t < product.tags.length; t++) {
          if (anyWordStartsWith(product.tags[t])) return true;
        }
      }
      return false;
    }

    _isCoreColourTerm(searchTerm) {
      var termLower = (searchTerm || '').trim().toLowerCase();
      var coreColourTerms = [
        'black', 'blue', 'brown', 'cream', 'green', 'grey', 'gray',
        'orange', 'pink', 'purple', 'red', 'white', 'yellow'
      ];

      return coreColourTerms.indexOf(termLower) !== -1;
    }

    prefetchColourFallbackFromInput() {
      var searchTerm = this.input ? this.input.value.trim() : '';
      if (!this._isCoreColourTerm(searchTerm)) {
        var normalizedTerm = searchTerm.toLowerCase();
        if (normalizedTerm === 're') {
          searchTerm = 'red';
        } else {
          return;
        }
      }

      this._prefetchFallback(searchTerm);
    }

    /* Prefetch fallback products in parallel with the main predictive call.
     * Only for terms 3+ chars to avoid broad partial matches like "me". */
    _prefetchFallback(searchTerm) {
      if (searchTerm.length < 3) {
        this._fallbackFetchKey = '';
        this._fallbackRenderPromise = null;
        this._fallbackPromise = null;
        return;
      }

      if (this._fallbackFetchKey === searchTerm && this._fallbackPromise) return;

      this._fallbackFetchKey = searchTerm;
      this._fallbackRenderPromise = null;

      // Bump version when filter logic changes to invalidate stale cached results.
      var cacheKey = 'search-fallback-v3-' + searchTerm.toLowerCase();
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        this._fallbackPromise = Promise.resolve(JSON.parse(cached));
        return;
      }

      var self = this;
      var termLower = searchTerm.toLowerCase();
      var isCoreColourTerm = this._isCoreColourTerm(searchTerm);

      // Skip fetch if term isn't in our dictionary — Shopify's loose matching
      // on metafields returns spurious unrelated products otherwise.
      if (this._searchDict) {
        var d = this._searchDict;
        var inDict = d.has(termLower)
          || d.has(termLower + 's')
          || d.has(termLower + 'es')
          || (termLower.length > 3 && termLower.endsWith('s') && d.has(termLower.slice(0, -1)))
          || (termLower.length > 4 && termLower.endsWith('es') && d.has(termLower.slice(0, -2)))
          || isCoreColourTerm;
        if (!inDict) {
          this._fallbackPromise = Promise.resolve([]);
          return;
        }
      }

      // Gender-sensitive terms that need filtering
      var genderFilter = null;
      if (/\bmen\b|^mens$|^menswear$/i.test(searchTerm)) {
        genderFilter = { include: ['mens', 'menswear'], exclude: ['womens', 'womenswear'] };
      } else if (/\bwomen\b|^womens$|^womenswear$/i.test(searchTerm)) {
        genderFilter = { include: ['womens', 'womenswear'], exclude: ['mens', 'menswear'] };
      }

      // Enrich a basic product list (built from the search-page HTML) with
      // tags, SAPG colour, and reliable price from each product's .js JSON.
      function enrichProducts(products) {
        var enrichPromises = products.map(function(p) {
          if (!p.handle) return Promise.resolve(p);
          return theme.fetchProductJson(p.handle)
            .then(function(data) {
              if (!data) return p;
              var tags = data.tags || [];
              if (typeof tags === 'string') tags = tags.split(',');
              var normalizedTags = tags.map(function(t) { return t.trim(); }).filter(Boolean);
              p.tags = normalizedTags.map(function(t) { return t.toLowerCase(); });
              p.customLabel = self._extractCustomLabelFromTags(normalizedTags);
              if (data.price) {
                p.price = theme.Currency ? theme.Currency.formatMoney(data.price, theme.moneyFormat) : '$' + (data.price / 100).toFixed(2);
              }
              var sapgColor = self._extractSapgColor(normalizedTags);
              if (sapgColor) p.color = sapgColor;
              return p;
            })
            .catch(function() { return p; });
        });
        return Promise.all(enrichPromises);
      }

      function applyGenderFilter(enriched) {
        if (!genderFilter) return enriched;
        var filtered = enriched.filter(function(p) {
          if (!p.tags) return true;
          var hasInclude = genderFilter.include.some(function(tag) { return p.tags.indexOf(tag) !== -1; });
          var hasExclude = genderFilter.exclude.some(function(tag) { return p.tags.indexOf(tag) !== -1; });
          return hasInclude && !hasExclude;
        });
        return filtered.length > 0 ? filtered : enriched;
      }

      this._fallbackPromise = fetch('/search?q=' + encodeURIComponent(searchTerm) + '&type=product')
        .then(function(r) {
          if (self._searchDebug) console.log('[searchdebug] fallback fetch', searchTerm, 'status:', r.status, 'url:', r.url);
          return r.text();
        })
        .then(function(html) {
          // The zero-results section uses new-product-card with .grid-product, so
          // _parseProductsFromDoc would pick those up as if they were real matches.
          var tempDoc = new DOMParser().parseFromString(html, 'text/html');
          if (tempDoc.querySelector('.search-zero-collection')) {
            if (self._searchDebug) {
              var countEl = tempDoc.querySelector('[data-search-count]');
              var headerEl = tempDoc.querySelector('.search-page-header__count');
              console.log('[searchdebug] fallback hit zero-results page for', searchTerm, {
                headerText: headerEl ? headerEl.textContent.trim() : null,
                resultCount: countEl ? countEl.getAttribute('data-result-count') : null,
                gridProductCount: tempDoc.querySelectorAll('.grid-product').length
              });
            }
            return [];
          }

          var products = self._parseProductsFromDoc(tempDoc);
          if (self._searchDebug) console.log('[searchdebug] fallback parsed', products.length, 'products for', searchTerm);

          // Core colour terms trust the server list (Shopify returns colour shades
          // like "Lava" or "Raspberry"); other terms get filtered to drop spurious
          // metafield fuzzy-matches that slip through the dict gate.
          function termFilter(list) {
            if (isCoreColourTerm) return list;
            return list.filter(function(p) { return self._productMatchesTerm(p, termLower); });
          }

          if (genderFilter) {
            return enrichProducts(products).then(function(enriched) {
              var filtered = applyGenderFilter(termFilter(enriched));
              sessionStorage.setItem(cacheKey, JSON.stringify(filtered));
              return filtered;
            });
          }

          var basicMatches = termFilter(products);

          // Colour queries only enrich the 4 rendered products; other terms
          // enrich the full list so SAPG-tag matches can rescue products.
          var enrichSource = isCoreColourTerm ? basicMatches.slice(0, 4) : products;
          enrichProducts(enrichSource).then(function(enriched) {
            try { sessionStorage.setItem(cacheKey, JSON.stringify(termFilter(enriched))); } catch (e) {}
          }).catch(function() {});

          return basicMatches;
        })
        .catch(function() { return []; });
    }

    /* Inject contextual products when predictive API returns none.
     * Only renders once the fallback fetch resolves with real products — no shimmer,
     * so there's no flash of loading skeletons on zero-results terms. */
    injectFallbackProducts(maxWaitMs) {
      var resultsContainer = this.predictiveSearchResults.querySelector('.ps-results');
      var searchTerm = this.input.value.trim();
      if (!searchTerm) return Promise.resolve();

      if (!resultsContainer) {
        resultsContainer = document.createElement('div');
        resultsContainer.className = 'ps-results';
        this.predictiveSearchResults.appendChild(resultsContainer);
      }

      var self = this;

      if (!this._fallbackPromise) return Promise.resolve();

      this._fallbackRenderPromise = this._fallbackPromise.then(function(products) {
        if (self.input.value.trim() !== searchTerm) return { rendered: false };
        if (resultsContainer.querySelector('.ps-results__products')) return { rendered: true };
        if (products && products.length > 0) {
          self._renderFallbackFromSuggest(resultsContainer, products.slice(0, 4));
          return { rendered: true };
        }
        return { rendered: false };
      }).catch(function() { return { rendered: false }; });

      if (typeof maxWaitMs === 'number' && maxWaitMs > 0) {
        return Promise.race([
          this._fallbackRenderPromise,
          new Promise(function(resolve) {
            setTimeout(function() { resolve({ rendered: false, timedOut: true }); }, maxWaitMs);
          })
        ]);
      }

      return this._fallbackRenderPromise;
    }

    /* Render fallback product cards, then fetch colors from SAPG tags */
    _renderFallbackFromSuggest(container, products) {
      var html = '<div class="ps-results__products"><div class="ps-results__label">PRODUCTS</div><div class="ps-results__products-track">';
      var count = 0;
      var self = this;

      products.forEach(function(product) {
        if (count >= 4) return;

        var cardHtml = self._buildPredictiveCardHtml(product, count);
        if (!cardHtml) return;

        html += cardHtml;
        count++;
      });

      html += '</div></div>';
      container.insertAdjacentHTML('beforeend', html);
    }

    _getPredictiveBodyState() {
      var suggestions = this.predictiveSearchResults.querySelectorAll('.ps-suggestions-list .ps-suggestion-item');
      var productCards = this.predictiveSearchResults.querySelectorAll('.ps-results__products-track .ps-product-card');

      return {
        suggestionCount: suggestions.length,
        productCount: productCards.length
      };
    }

    _hidePredictiveBody() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      this.updateActionVisibility();

      if (!searchTerm.length) {
        this.resetResults();
        return;
      }

      if (searchTerm.length > 0) {
        this.getSearchResults(searchTerm);
      }
    }

    getSearchResults(searchTerm) {
      // Abort in-flight request — Android Chrome can leave rapid duplicates that
      // race with the catch handler and intermittently hide results.
      if (this._searchAbortController) {
        this._searchAbortController.abort();
      }
      this._searchAbortController = new AbortController();
      var signal = this._searchAbortController.signal;

      this._prefetchPromotedStockHandles();
      this._ensureSearchDict();
      this._prefetchFallback(searchTerm);

      const searchObj = {
        'q': searchTerm,
        'resources[limit]': 6,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };

      const params = this.paramUrl(searchObj);

      fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`, { signal })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.text();
        })
        .then((text) => {
          if (this.input.value.trim() !== searchTerm) return;

          const responseMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results');
          if (!responseMarkup) {
            this.predictiveSearchResults.style.display = 'none';
            this.predictiveSearchResults.innerHTML = '';
            return;
          }

          const resultsMarkup = responseMarkup.innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;

          // Correct misspelled clothing terms in suggestion text.
          // Shopify's API parrots back the user's search term in query suggestions,
          // so a typo like "ahorts" produces suggestions like "impact ahorts".
          this._correctSuggestionText(searchTerm);
          this._highlightSuggestionKeywords(searchTerm);

          // Move "show all results" bar to footer slot (outside max-width body)
          if (this.predictiveSearchFooter) {
            var searchBar = this.predictiveSearchResults.querySelector('.results__search-bar');
            if (searchBar) {
              this.predictiveSearchFooter.classList.remove('footer--instant');
              this.predictiveSearchFooter.innerHTML = '';
              this.predictiveSearchFooter.appendChild(searchBar);
            } else {
              // No search bar in response — keep the instant footer as-is
            }
          }

          var hasProducts = this.predictiveSearchResults.querySelector('.ps-results__products');
          var hasSuggestions = this.predictiveSearchResults.querySelector('.ps-results__suggestions');

          if (this._searchDebug) {
            console.log('[searchdebug] predictive response for', searchTerm, {
              hasProducts: !!hasProducts,
              hasSuggestions: !!hasSuggestions,
              isCoreColour: this._isCoreColourTerm(searchTerm),
              productCardCount: this.predictiveSearchResults.querySelectorAll('.ps-product-card').length,
              suggestionCount: this.predictiveSearchResults.querySelectorAll('.ps-suggestion-item').length
            });
          }

          if (hasProducts) {
            // Open immediately — promoted-stock injection runs async and is
            // typically a no-op because the predictive Liquid already excludes
            // promoted-stock products. Waiting on its paginated fetch added
            // ~500-2000ms to cold-start first paint.
            this.open();
            if (window.AOS) AOS.refreshHard();
            this._injectPromotedStock().finally(() => {
              if (this.input.value.trim() !== searchTerm) return;
              if (this._getPredictiveBodyState().productCount === 0) {
                this._hidePredictiveBody();
                return;
              }
              if (window.AOS) AOS.refreshHard();
            });
          } else if (hasSuggestions) {
            // Tag-only colour matches (e.g. "red") need the /search fallback
            // for product cards. For exact colour terms, wait for that fallback
            // so the panel first opens with suggestions and products together.
            var colourFallbackWait = this._isCoreColourTerm(searchTerm) ? null : 140;
            this.injectFallbackProducts(colourFallbackWait)
              .then(() => {
                if (this.input.value.trim() !== searchTerm) return;
                this.open();
                if (window.AOS) AOS.refreshHard();
                if (!this._isCoreColourTerm(searchTerm)) {
                  return this._fallbackRenderPromise || Promise.resolve();
                }
              })
              .then(() => this._injectPromotedStock())
              .finally(() => {
                if (this.input.value.trim() !== searchTerm) return;
                if (window.AOS) AOS.refreshHard();
              });
          } else {
            // Some colour terms can return no predictive body even though the
            // full search page has matching products. Try the same fallback
            // before hiding the dropdown.
            this.injectFallbackProducts()
              .then(() => {
                if (this.input.value.trim() !== searchTerm) return;
                var bodyState = this._getPredictiveBodyState();
                if (bodyState.productCount === 0) {
                  this._hidePredictiveBody();
                  return;
                }
                this.open();
                if (window.AOS) AOS.refreshHard();
                return this._injectPromotedStock();
              })
              .finally(() => {
                if (this.input.value.trim() !== searchTerm) return;
                if (window.AOS) AOS.refreshHard();
              });
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          if (this.input.value.trim() !== searchTerm) return;
          this._hidePredictiveBody();
        });
    }

    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (document.activeElement === this.input) {
        this.input.blur();
      }

      this.input.value = '';
      this.resetResults();
      this.classList.remove('is-active');
      this.updateActionVisibility();
      this.unbindShellEdgeGuard();
      this.unbindMobileViewport();
      this.unlockPageScroll();

      if (this.headerContainer) {
        document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
        document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    paramUrl(obj) {
      return Object.keys(obj).map(function (key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }

  customElements.define('predictive-search', PredictiveSearch);

  /* ============================================================================
   * SearchCorrector — Smart fuzzy search correction for zero-results pages
   * ============================================================================
   *
   * PURPOSE:
   * When a user searches for a misspelled term (e.g. "trosers") and gets zero
   * results, this module attempts to find the closest correct term and offers
   * a suggestion link to re-search with the corrected spelling.
   *
   * HOW IT WORKS (two-step hybrid approach):
   *
   * Step 1 — Shopify Predictive Search API (primary):
   *   Calls /search/suggest.json with the misspelled term. If Shopify returns
   *   query suggestions, the first suggestion is used as the correction.
   *   This leverages Shopify's own fuzzy matching and stays in sync with the
   *   store's actual product catalogue automatically.
   *
   * Step 2 — Levenshtein distance fallback (secondary):
   *   If Shopify returns no suggestions, we build a dictionary dynamically from:
   *     - All collection titles (fetched from /collections.json)
   *     - Popular search pill labels (already in the DOM)
   *   The misspelled term is compared against every dictionary entry using
   *   Levenshtein edit distance. The closest match within a threshold of
   *   ≤ 3 edits is offered as a suggestion. The dictionary is cached in
   *   sessionStorage so it's only fetched once per browser session.
   *
   * OUTPUT:
   *   If a correction is found, the module shows a message like:
   *     "Did you mean <a>trousers</a>?"
   *   Clicking the link navigates to /search?q=trousers&type=product.
   *   If no correction is found, the standard "no results" message stays.
   *
   * ACTIVATION:
   *   Runs automatically on DOMContentLoaded when a [data-search-correction]
   *   element is present on the page (only on zero-results search pages).
   * ========================================================================= */

  (function() {
    // Building the catalogue dictionary crawls /collections/all/products.json
    // (up to 4 pages ≈ 3MB decoded, parsed on the main thread) + /collections.json.
    // Typo correction / zero-state detection only matter when a search barely
    // returned anything, so the callers below only trigger getDictionary() when
    // the result count is at or below this threshold. The sessionStorage cache
    // still makes it a once-per-session cost when it does run.
    var LAZY_DICT_MAX_RESULTS = 2;

    function levenshtein(a, b) {
      var m = a.length, n = b.length;
      var dp = [];
      for (var i = 0; i <= m; i++) {
        dp[i] = [i];
      }
      for (var j = 0; j <= n; j++) {
        dp[0][j] = j;
      }
      for (var i = 1; i <= m; i++) {
        for (var j = 1; j <= n; j++) {
          if (a[i - 1] === b[j - 1]) {
            dp[i][j] = dp[i - 1][j - 1];
          } else {
            dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
          }
        }
      }
      return dp[m][n];
    }

    function getDictionary() {
      return new Promise(function(resolve) {
        var cacheKey = 'search-corrector-dict-v3';
        var cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          var parsed = JSON.parse(cached);
          // Only use cache if it has a reasonable number of terms
          if (parsed && parsed.length > 20) {
            resolve(parsed);
            return;
          }
          // Cache too small — likely a failed fetch, rebuild
          sessionStorage.removeItem(cacheKey);
        }
        sessionStorage.removeItem('search-corrector-dict-v2');

        var dict = [];

        // Collect popular search pill labels from the DOM
        document.querySelectorAll('.popular-searches__pill').forEach(function(pill) {
          var text = pill.textContent.trim().toLowerCase();
          if (text && dict.indexOf(text) === -1) dict.push(text);
        });

        // Collect filter values from the page DOM
        document.querySelectorAll('.filter-form label, .collection-sidebar__group li').forEach(function(el) {
          var text = el.textContent.trim().toLowerCase();
          if (text.length > 2 && text.length < 30 && dict.indexOf(text) === -1) dict.push(text);
        });

        // Helper to add a term and its individual words to the dictionary
        function addTerm(text) {
          var lower = text.toLowerCase().trim();
          if (!lower || lower.length < 2) return;
          if (dict.indexOf(lower) === -1) dict.push(lower);
          lower.split(/\s+/).forEach(function(word) {
            if (word.length > 2 && dict.indexOf(word) === -1) dict.push(word);
          });
        }

        // Fetch all products via pagination (250 per page, max 10 pages = 2500 products)
        function fetchAllProducts(page, allProducts) {
          return fetch('/collections/all/products.json?limit=250&page=' + page)
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data && data.products && data.products.length > 0) {
                allProducts = allProducts.concat(data.products);
                // Fetch next page if this page was full and under 10 pages
                if (data.products.length === 250 && page < 10) {
                  return fetchAllProducts(page + 1, allProducts);
                }
              }
              return allProducts;
            })
            .catch(function() { return allProducts; });
        }

        // Fetch collections and all products in parallel
        Promise.all([
          fetch('/collections.json').then(function(r) { return r.json(); }).catch(function() { return null; }),
          fetchAllProducts(1, [])
        ]).then(function(results) {
          // Collection titles
          if (results[0] && results[0].collections) {
            results[0].collections.forEach(function(col) {
              addTerm(col.title);
            });
          }

          // Product titles, types, vendors, and tags
          results[1].forEach(function(product) {
            addTerm(product.title);
            if (product.product_type) addTerm(product.product_type);
            if (product.vendor) addTerm(product.vendor);
            if (product.tags) {
              product.tags.forEach(function(tag) {
                addTerm(tag);
                // SAPG::Product::Colour — surface the colour token so single-word
                // colour queries pass the dictionary gate in _prefetchFallback.
                var trimmed = (tag || '').trim();
                if (trimmed.indexOf('SAPG::') === 0) {
                  var parts = trimmed.split('::');
                  if (parts.length >= 3 && parts[2]) addTerm(parts[2]);
                }
              });
            }
          });

          // Only cache if dictionary has enough terms
          if (dict.length > 20) {
            sessionStorage.setItem(cacheKey, JSON.stringify(dict));
          }
          resolve(dict);
        }).catch(function() {
          resolve(dict);
        });
      });
    }

    // Expose so PredictiveSearch (defined above this IIFE) can reuse the same
    // catalogue dictionary as a "real word" guard against wrong typo rewrites
    // like "light" -> "tight".
    theme.searchDictionary = theme.searchDictionary || { get: getDictionary };

    // Collapse repeated characters: "shoooootttttttzzzz" → "shotz"
    function dedupeChars(str) {
      return str.replace(/(.)\1+/g, '$1');
    }

    function findClosestMatches(term, dictionary, maxResults) {
      var termLower = term.toLowerCase();

      // Normalize: collapse repeated chars to create a cleaner version
      var termDeduped = dedupeChars(termLower);

      // Use the shorter of original or deduped as the primary match term
      // For garbled input like "shoooootttttttzzzz" → "shotz" (5 chars)
      var primaryTerm = termDeduped.length < termLower.length ? termDeduped : termLower;

      // Scale threshold by primary term length
      var threshold = Math.max(2, Math.floor(primaryTerm.length * 0.4));
      var candidates = [];

      // Build variants from both original and deduped forms
      var termVariants = [termLower, termDeduped];
      // Remove duplicate if same
      if (termLower === termDeduped) termVariants = [termLower];

      var suffixes = ['s', 'es', 'r', 'rs', 'er', 'ers', 'ing', 'ed'];
      var baseTerms = termVariants.slice();
      baseTerms.forEach(function(base) {
        suffixes.forEach(function(s) {
          if (!base.endsWith(s)) {
            var variant = base + s;
            if (termVariants.indexOf(variant) === -1) termVariants.push(variant);
          }
        });
        // Also try removing last char
        if (base.length > 3) {
          var trimmed = base.slice(0, -1);
          if (termVariants.indexOf(trimmed) === -1) termVariants.push(trimmed);
        }
      });

      for (var i = 0; i < dictionary.length; i++) {
        var entry = dictionary[i];

        // Skip very short entries but use primaryTerm length for comparison
        if (entry.length < primaryTerm.length - 3) continue;

        var bestDist = Infinity;
        var bestVariant = termLower;

        // Check against all variants of the search term
        for (var v = 0; v < termVariants.length; v++) {
          var variant = termVariants[v];
          if (Math.abs(entry.length - variant.length) > threshold) continue;
          var d = levenshtein(variant, entry);
          if (d < bestDist) {
            bestDist = d;
            bestVariant = variant;
          }
        }

        if (bestDist <= threshold && bestDist > 0) {
          // Base score: edit distance (lower = better)
          var score = bestDist;

          // If a suffix variant matched with distance 1, this is very likely
          // the correct word — give it a strong bonus
          if (bestVariant !== termLower && bestDist <= 1) {
            score -= 2;
          }

          // Length difference penalty — use primaryTerm (deduped) for fairer comparison
          var lengthDiff = Math.abs(entry.length - primaryTerm.length);
          score += lengthDiff * 0.2;

          // Shared prefix bonus — compare against deduped term for better matching
          var prefixLen = 0;
          var prefixTerm = termDeduped || termLower;
          var minLen = Math.min(prefixTerm.length, entry.length);
          for (var p = 0; p < minLen; p++) {
            if (prefixTerm[p] === entry[p]) prefixLen++;
            else break;
          }
          // Exponential prefix reward: 3+ shared chars = very strong bonus
          if (prefixLen >= 3) {
            score -= prefixLen * 1.0;
          } else if (prefixLen >= 2) {
            score -= prefixLen * 0.5;
          }

          // Shared character ratio bonus — use deduped term for fairer ratio
          var sharedChars = 0;
          var entryCopy = entry.split('');
          for (var c = 0; c < primaryTerm.length; c++) {
            var idx = entryCopy.indexOf(primaryTerm[c]);
            if (idx !== -1) {
              sharedChars++;
              entryCopy.splice(idx, 1);
            }
          }
          var charRatio = sharedChars / Math.max(primaryTerm.length, entry.length);
          score -= charRatio * 2;

          candidates.push({ term: entry, distance: bestDist, score: score });
        }
      }

      // Sort by score (best first), then by distance, then alphabetically
      candidates.sort(function(a, b) {
        if (a.score !== b.score) return a.score - b.score;
        if (a.distance !== b.distance) return a.distance - b.distance;
        return a.term.localeCompare(b.term);
      });

      // Deduplicate and return top results
      var seen = {};
      var results = [];
      for (var j = 0; j < candidates.length; j++) {
        if (!seen[candidates[j].term]) {
          seen[candidates[j].term] = true;
          results.push(candidates[j].term);
          if (results.length >= (maxResults || 3)) break;
        }
      }

      return results;
    }

    function showSuggestion(msgEl, matches) {
      if (matches.length === 0) return;

      var links = matches.map(function(term) {
        var url = '/search?q=' + encodeURIComponent(term) + '&type=product';
        return '<a href="' + url + '">' + term + '</a>';
      });

      var html = 'Did you mean ';
      if (links.length === 1) {
        html += links[0];
      } else if (links.length === 2) {
        html += links[0] + ' or ' + links[1];
      } else {
        html += links.slice(0, -1).join(', ') + ' or ' + links[links.length - 1];
      }
      html += '?';
      msgEl.innerHTML = html;
      msgEl.style.display = '';
    }

    function initSearchCorrector() {
      var container = document.querySelector('[data-search-correction]');
      if (!container) return;

      var originalTerm = container.getAttribute('data-original-term');
      var msgEl = container.querySelector('[data-search-correction-msg]');
      if (!originalTerm || !msgEl) return;

      // Step 1: Try Shopify predictive search suggestions
      var shopifySuggestions = [];
      var suggestUrl = (theme.routes.predictiveSearch || '/search/suggest') +
        '?q=' + encodeURIComponent(originalTerm) +
        '&resources[type]=query&resources[limit]=4';

      fetch(suggestUrl)
        .then(function(r) { return r.text(); })
        .then(function(text) {
          try {
            var json = JSON.parse(text);
            if (json.resources && json.resources.results && json.resources.results.queries) {
              json.resources.results.queries.forEach(function(q) {
                if (q.text && q.text.toLowerCase() !== originalTerm.toLowerCase()) {
                  shopifySuggestions.push(q.text);
                }
              });
            }
          } catch(e) {
            // Not JSON — ignore Shopify suggestions
          }
        })
        .catch(function() {})
        .finally(function() {
          // Step 2: Always run Levenshtein and combine with any Shopify suggestions
          getDictionary().then(function(dict) {
            var levenshteinMatches = findClosestMatches(originalTerm, dict, 3);

            // Merge: Shopify suggestions first, then Levenshtein, deduplicated
            var seen = {};
            var combined = [];
            var all = shopifySuggestions.concat(levenshteinMatches);
            for (var k = 0; k < all.length; k++) {
              var lower = all[k].toLowerCase();
              if (!seen[lower]) {
                seen[lower] = true;
                combined.push(all[k]);
                if (combined.length >= 3) break;
              }
            }

            if (combined.length > 0) {
              showSuggestion(msgEl, combined);
            }
          });
        });
    }

    /* Check if the search term is misspelled even when results exist.
     * If the term isn't in the dictionary but a close match is,
     * update the header to: "You searched for 'X' — showing Y results for 'Z'" */
    function initMisspellingDetection() {
      var countEl = document.querySelector('[data-search-count]');
      if (!countEl) return;

      var originalTerm = countEl.getAttribute('data-original-term');
      var resultCount = countEl.getAttribute('data-result-count');
      if (!originalTerm) return;

      // Lazy dictionary: a search with a healthy result set doesn't need typo
      // correction, so don't pay the catalogue crawl for it.
      var parsedResultCount = parseInt(resultCount, 10);
      if (!isNaN(parsedResultCount) && parsedResultCount > LAZY_DICT_MAX_RESULTS) return;

      getDictionary().then(function(dict) {
        var termLower = originalTerm.toLowerCase();

        // Check if ALL individual words exist in the dictionary
        // "impact shorts" → both "impact" and "shorts" found → not misspelled
        var words = termLower.split(/\s+/).filter(function(w) { return w.length > 1; });
        var allWordsFound = true;
        var misspelledWords = [];

        for (var w = 0; w < words.length; w++) {
          var wordFound = false;
          for (var i = 0; i < dict.length; i++) {
            if (dict[i] === words[w]) {
              wordFound = true;
              break;
            }
          }
          if (!wordFound) {
            allWordsFound = false;
            misspelledWords.push(words[w]);
          }
        }

        // Also check full phrase as exact match
        var exactMatch = false;
        for (var i = 0; i < dict.length; i++) {
          if (dict[i] === termLower) {
            exactMatch = true;
            break;
          }
        }

        if (exactMatch || allWordsFound) {
          // All words are valid — no correction needed
          return;
        }

        // Only correct the misspelled words, keep correct ones
        // For words not in dictionary, only correct if Levenshtein distance is 1
        // (single char typo). Distance 2+ is too ambiguous — "shirt" vs "shorts"
        if (misspelledWords.length > 0 && misspelledWords.length < words.length) {
          var correctedWords = words.slice();
          var anyCorrected = false;
          for (var m = 0; m < misspelledWords.length; m++) {
            var word = misspelledWords[m];
            var deduped = dedupeChars(word);
            // Find best match and check distance
            var bestMatch = null;
            var bestDist = Infinity;
            for (var d = 0; d < dict.length; d++) {
              if (Math.abs(dict[d].length - deduped.length) > 1) continue;
              var dist = levenshtein(deduped, dict[d]);
              if (dist < bestDist && dist > 0) {
                bestDist = dist;
                bestMatch = dict[d];
              }
            }
            // Only correct if distance is 1 (confident single-char typo)
            if (bestMatch && bestDist <= 1) {
              var idx = correctedWords.indexOf(word);
              if (idx !== -1) {
                correctedWords[idx] = bestMatch;
                anyCorrected = true;
              }
            }
          }
          if (!anyCorrected) return;
          var corrected = correctedWords.join(' ');
          if (corrected.toLowerCase() !== termLower) {
            var url = '/search?q=' + encodeURIComponent(corrected) + '&type=product';
            countEl.innerHTML = 'You searched for &ldquo;' + originalTerm + '&rdquo; &mdash; showing ' + resultCount + ' results for <a href="' + url + '">&ldquo;' + corrected + '&rdquo;</a>';
          }
        } else {
          // All words misspelled or single word — correct the whole term
          var matches = findClosestMatches(originalTerm, dict, 1);
          if (matches.length > 0 && matches[0].toLowerCase() !== termLower) {
            var corrected = matches[0];
            var url = '/search?q=' + encodeURIComponent(corrected) + '&type=product';
            countEl.innerHTML = 'You searched for &ldquo;' + originalTerm + '&rdquo; &mdash; showing ' + resultCount + ' results for <a href="' + url + '">&ldquo;' + corrected + '&rdquo;</a>';
          }
        }
      });
    }

    /* Relevance filter for the server-rendered results grid.
     * Shopify's native storefront search is semantic (AI) and can't be disabled
     * in admin, so it returns products that don't lexically match the query
     * (e.g. "towels" surfaces a Water Bottle, Seamless Thong, Defy Leggings).
     * When the query is a known catalogue word, hide result cards whose
     * title / handle / vendor don't actually contain the term (singular/plural
     * aware) so precise queries return precise results. Conservative by design:
     * it only runs for in-dictionary, non-colour terms, never blanks the page,
     * and leaves Shopify's results untouched for unknown/colour queries.
     * To disable: remove the initResultsRelevanceFilter() calls below. */
    var CORE_COLOURS = {
      black: 1, blue: 1, brown: 1, cream: 1, green: 1, grey: 1, gray: 1,
      orange: 1, pink: 1, purple: 1, red: 1, white: 1, yellow: 1
    };

    function relevanceVariants(word) {
      var v = [word, word + 's', word + 'es'];
      if (word.length > 3 && word.charAt(word.length - 1) === 's') v.push(word.slice(0, -1));
      if (word.length > 4 && word.slice(-2) === 'es') v.push(word.slice(0, -2));
      return v;
    }

    // True if any token in haystackTokens starts with the word (or a singular/
    // plural variant of it) — mirrors _productMatchesTerm's prefix matching.
    function tokensMatchWord(haystackTokens, word) {
      var variants = relevanceVariants(word);
      for (var i = 0; i < haystackTokens.length; i++) {
        for (var v = 0; v < variants.length; v++) {
          if (variants[v].length > 1 && haystackTokens[i].indexOf(variants[v]) === 0) return true;
        }
      }
      return false;
    }

    // Hide the semantic results grid and reveal the best-sellers fallback,
    // mirroring the true zero-results state. Uses a class (not inline style)
    // because the reveal script does removeAttribute('style') on the grid.
    function showSearchZeroState(term) {
      var grid = document.querySelector('#CollectionAjaxContent');
      var fallback = document.querySelector('[data-search-zero-fallback]');
      if (!grid || !fallback) return;
      grid.classList.add('search-results-suppressed');
      grid.setAttribute('data-relevance-hidden', '1');
      fallback.style.display = '';
      var countEl = document.querySelector('[data-search-count]');
      if (countEl) countEl.textContent = 'No results for “' + term + '”';
      // The slider computes card widths lazily; nudge it now that it's visible.
      if (window.dispatchEvent) window.dispatchEvent(new Event('resize'));
    }

    function initResultsRelevanceFilter() {
      var countEl = document.querySelector('[data-search-count]');
      if (!countEl) return; // only on results pages that have results

      var originalTerm = countEl.getAttribute('data-original-term');
      if (!originalTerm) return;
      var termLower = originalTerm.trim().toLowerCase();
      if (termLower.length < 2) return;

      var words = termLower.split(/\s+/).filter(function(w) { return w.length > 1; });
      if (!words.length) return;

      // Colour searches are legitimately broad — leave Shopify's results alone.
      for (var c = 0; c < words.length; c++) {
        if (CORE_COLOURS[words[c]]) return;
      }

      var cards = document.querySelectorAll('#CollectionAjaxContent .grid-product, .search-content .grid-product');
      if (!cards.length) return;

      // Match every card lexically (title + vendor + handle, plural/prefix
      // aware) — the same signal _productMatchesTerm uses in the overlay. This
      // uses only the DOM, so it runs WITHOUT building the catalogue dictionary.
      var matched = 0;
      var toHide = [];
      for (var k = 0; k < cards.length; k++) {
        var card = cards[k];
        var hay = '';
        var titleEl = card.querySelector('.grid-product__title');
        if (titleEl) hay += ' ' + titleEl.textContent;
        var vendorEl = card.querySelector('.grid-product__vendor');
        if (vendorEl) hay += ' ' + vendorEl.textContent;
        var handle = card.getAttribute('data-product-handle') || '';
        hay += ' ' + handle.replace(/-/g, ' ');

        var tokens = hay.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
        // AND across query words: every word must match some token.
        var isMatch = true;
        for (var x = 0; x < words.length; x++) {
          if (!tokensMatchWord(tokens, words[x])) { isMatch = false; break; }
        }
        if (isMatch) { matched++; } else { toHide.push(card); }
      }

      if (matched > 0) {
        // Precision filter: at least one product genuinely matches, so hide the
        // semantic extras. Runs regardless of the dictionary — covers brand-new
        // products not yet in the cached dictionary. No crawl needed.
        if (toHide.length === 0) return; // everything matched, nothing to do
        for (var h = 0; h < toHide.length; h++) {
          toHide[h].style.display = 'none';
          toHide[h].setAttribute('data-relevance-hidden', '1');
        }
        // Correct the visible count only on single-page results, where the
        // matched cards are the whole result set. With pagination we can't know
        // the genuine total across pages, so leave Shopify's count as-is.
        var paginated = !!document.querySelector('#CollectionAjaxContent .pagination, .search-content .pagination');
        if (!paginated) {
          countEl.textContent = matched + (matched === 1 ? ' result for ' : ' results for ') +
            '“' + originalTerm + '”';
        }
        return;
      }

      // matched === 0: no product lexically matches the term — a near-zero
      // relevance result, the only case that needs the catalogue dictionary. If
      // it's a single word that's nowhere in the dictionary (built from titles,
      // types, tags, vendors, collections), it has no genuine match — Shopify's
      // semantic engine just returned loosely-related products (e.g. "cups" →
      // bras, t-shirts). Treat it as a true zero-results search. Otherwise
      // (in-dictionary term matching via a field we can't read in the DOM, or a
      // multi-word query) stay conservative and leave Shopify's results.
      if (words.length !== 1) return;

      getDictionary().then(function(dict) {
        var dictSet = {};
        for (var di = 0; di < dict.length; di++) { dictSet[dict[di]] = true; }
        function inDict(word) {
          var variants = relevanceVariants(word);
          for (var i = 0; i < variants.length; i++) { if (dictSet[variants[i]]) return true; }
          return false;
        }

        if (!inDict(words[0])) {
          showSearchZeroState(originalTerm);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initSearchCorrector();
        initMisspellingDetection();
        initResultsRelevanceFilter();
      });
    } else {
      initSearchCorrector();
      initMisspellingDetection();
      initResultsRelevanceFilter();
    }
  })();

  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`);
      this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
      this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
      this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
      this.dateInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
      this.addEventListener('change', () => this.onChange());
      this.recipientFields = this.querySelector('.recipient-fields');

      this.checkboxInput.addEventListener('change', () => {
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
      });
    }

    connectedCallback() {
      document.addEventListener('ajaxProduct:error', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.displayErrorMessage(event.detail.errorMessage);
        }
      });

      document.addEventListener('ajaxProduct:added', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      });
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearInputFields() {
      this.querySelectorAll('.field__input').forEach(el => el.value = '');
    }

    displayErrorMessage(body) {
      this.clearErrorMessage();
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;

          inputElement.setAttribute('aria-invalid', true);
          inputElement.classList.add('field__input--error');
        });
      }
    }

    clearErrorMessage() {
      this.querySelectorAll('.field__input').forEach(inputElement => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
        inputElement.classList.remove('field__input--error');
      });
    }
  };

  customElements.define('recipient-form', RecipientForm);


  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left',
      callbacks: {
        onInit: updateSlideAccessibility,
        onChange: updateSlideAccessibility
      }
    };
    var bar;
    var flickity;

    function updateSlideAccessibility(index) {
      if (!bar) {
        return;
      }

      var slides = bar.querySelectorAll('.announcement-slider__slide');
      var activeIndex = typeof index === 'number' ? index : 0;

      slides.forEach(function (slide, slideIndex) {
        var isActive = !bar.classList.contains('flickity-enabled') || slideIndex === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
          if (isActive) {
            if (el.hasAttribute('data-previous-tabindex')) {
              el.setAttribute('tabindex', el.getAttribute('data-previous-tabindex'));
              el.removeAttribute('data-previous-tabindex');
            } else {
              el.removeAttribute('tabindex');
            }
          } else {
            if (el.hasAttribute('tabindex')) {
              el.setAttribute('data-previous-tabindex', el.getAttribute('tabindex'));
            }
            el.setAttribute('tabindex', '-1');
          }
        });
      });
    }

    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }

      unload();

      updateSlideAccessibility();

      if (bar.dataset.blockCount === 1) {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }

      document.addEventListener('matchSmall', function () {
        unload();
        initSlider();
      });

      document.addEventListener('unmatchSmall', function () {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }

      updateSlideAccessibility();
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();

  theme.accessibilityFixes = (function () {
    var initialized = false;
    var reviewModals = {};

    function setPreviewBarTitle() {
      var previewBar = document.getElementById('PBarNextFrame');

      if (previewBar && !previewBar.getAttribute('title')) {
        previewBar.setAttribute('title', 'Shopify preview toolbar');
      }
    }

    function normalizeJudgeMeBadges(scope) {
      var root = scope || document;

      if (root.matches && root.matches('.jdgm-prev-badge__stars[role="button"]')) {
        root.removeAttribute('role');
        root.removeAttribute('tabindex');
      }

      root.querySelectorAll('.jdgm-prev-badge__stars[role="button"]').forEach(function (badge) {
        badge.removeAttribute('role');
        badge.removeAttribute('tabindex');
      });
    }

    function normalizeJudgeMeReviewWidgets(scope) {
      var root = scope || document;
      var widgets = [];
      var reviewsDrawer = null;
      var activeReviewState = null;
      var activeStarFilter = null;
      var reviewsRequestId = 0;
      var reviewsPerPage = 5;

      var starSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#0a0a0a" stroke="#0a0a0a" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>';

      function getOrCreateReviewsDrawer() {
        if (reviewsDrawer) {
          return reviewsDrawer;
        }

        var el = document.getElementById('ReviewsDrawer');
        if (!el) {
          return null;
        }

        reviewsDrawer = new theme.Drawers('ReviewsDrawer', 'reviews');

        // Wrap open to add dark overlay class
        var originalOpen = reviewsDrawer.open.bind(reviewsDrawer);
        reviewsDrawer.open = function (evt, returnFocusEl, skipTransition) {
          originalOpen(evt, returnFocusEl, skipTransition);
          document.documentElement.classList.add('js-reviews-drawer-open');
        };

        // Wrap close to clear drawer content and remove overlay class
        var originalClose = reviewsDrawer.close.bind(reviewsDrawer);
        reviewsDrawer.close = function (evt) {
          var wasOpen = reviewsDrawer.isOpen;
          originalClose(evt);
          if (wasOpen && !reviewsDrawer.isOpen) {
            finalizeReviewsDrawerClose();
          }
        };

        // The theme drawer binds the close button during construction, before
        // the instance method is wrapped above. Add an explicit cleanup hook.
        var closeButton = el.querySelector('.js-drawer-close');
        if (closeButton) {
          closeButton.addEventListener('click', function () {
            window.setTimeout(function () {
              if (!reviewsDrawer.isOpen) {
                finalizeReviewsDrawerClose();
              }
            }, 0);
          });
        }

        return reviewsDrawer;
      }

      function finalizeReviewsDrawerClose() {
        document.documentElement.classList.remove('js-reviews-drawer-open');
        closeReviewsDrawer();
      }

      function buildStarChips(widget) {
        var container = document.querySelector('[data-reviews-star-chips]');
        if (!container) {
          return;
        }

        // Read counts from Judge.me histogram
        var counts = [0, 0, 0, 0, 0];
        if (widget) {
          for (var i = 5; i >= 1; i--) {
            var row = widget.querySelector('.jdgm-histogram__row[data-rating="' + i + '"]');
            if (row) {
              var freqEl = row.querySelector('.jdgm-histogram__frequency');
              counts[5 - i] = freqEl ? parseInt(freqEl.textContent, 10) || 0 : 0;
            }
          }
        }

        var html = '';
        for (var s = 5; s >= 1; s--) {
          var stars = '';
          for (var j = 0; j < s; j++) {
            stars += starSvg;
          }
          html += '<button type="button" class="reviews-drawer__star-chip" data-reviews-star="' + s + '">' +
            '<span class="reviews-drawer__star-chip__stars">' + stars + '</span>' +
            '<span>(' + counts[5 - s].toLocaleString('en-US') + ')</span>' +
            '</button>';
        }
        container.innerHTML = html;

        // Bind click events
        container.querySelectorAll('[data-reviews-star]').forEach(function (chip) {
          chip.addEventListener('click', function () {
            var rating = parseInt(chip.getAttribute('data-reviews-star'), 10);
            toggleStarFilter(rating, container);
          });
        });
      }

      function toggleStarFilter(rating, container) {
        if (activeStarFilter === rating) {
          activeStarFilter = null;
          if (container) {
            container.querySelectorAll('[data-reviews-star]').forEach(function (chip) {
              chip.classList.remove('reviews-drawer__star-chip--active');
            });
          }
          fetchDrawerReviews(1, false);
          return;
        }

        activeStarFilter = rating;

        if (container) {
          container.querySelectorAll('[data-reviews-star]').forEach(function (chip) {
            var r = parseInt(chip.getAttribute('data-reviews-star'), 10);
            chip.classList.toggle('reviews-drawer__star-chip--active', r === rating);
          });
        }

        fetchDrawerReviews(1, false);
      }

      function getReviewState(widget) {
        if (!widget) {
          return null;
        }

        var widgetId = widget.dataset.pdpReviewsWidgetId;
        if (!widgetId) {
          widgetId = 'pdp-reviews-widget-' + Math.random().toString(36).slice(2, 10);
          widget.dataset.pdpReviewsWidgetId = widgetId;
        }

        if (!reviewModals[widgetId]) {
          reviewModals[widgetId] = {
            widgetId: widgetId,
            widget: widget,
            modalElement: null,
            modalHost: null,
            root: null,
            section: null,
            trigger: null,
            productId: null,
            productHandle: null,
            shopDomain: null,
            totalCount: null,
            lastPageCount: 0,
            currentPage: 1,
            isLoading: false
          };
        }

        var state = reviewModals[widgetId];
        state.widget = widget;
        return state;
      }

      function getProductRoot(widget) {
        if (!(widget instanceof Element)) {
          return null;
        }

        var section = widget.closest('[id^="shopify-section-"]');
        var previous = section ? section.previousElementSibling : null;
        if (previous) {
          var productRoot = previous.querySelector('[data-pdp-reviews-modal-id]');
          if (productRoot) {
            return productRoot;
          }
        }

        return document.querySelector('[data-pdp-reviews-modal-id]');
      }

      function getSectionWrapper(widget) {
        if (!(widget instanceof Element)) {
          return null;
        }

        return widget.closest('[id^="shopify-section-"]') || widget.closest('section') || widget.parentElement;
      }

      function getModalState(widget) {
        var state = getReviewState(widget);
        if (!state) {
          return null;
        }

        var productRoot = state.root && document.documentElement.contains(state.root) ? state.root : getProductRoot(widget);
        if (!productRoot) {
          return null;
        }

        var modalId = productRoot.getAttribute('data-pdp-reviews-modal-id');
        if (!modalId) {
          return null;
        }

        var modalElement = document.getElementById(modalId);
        var modalHost = modalElement ? modalElement.querySelector('[data-pdp-reviews-modal-host]') : null;
        if (!modalElement || !modalHost) {
          return null;
        }

        var section = getSectionWrapper(widget);
        state.root = productRoot;
        state.section = section;
        state.productId = productRoot.getAttribute('data-pdp-reviews-product-id') || (productRoot.getAttribute('data-product-id') || '');
        state.productHandle = productRoot.getAttribute('data-product-handle') || '';
        state.shopDomain = getReviewsShopDomain();

        state.modalElement = modalElement;
        state.modalHost = modalHost;

        return state;
      }

      function getReviewsShopDomain() {
        var jdgmLib = window.jdgm || window.JDGM;
        var candidates = [
          jdgmLib && jdgmLib.SHOP_DOMAIN,
          jdgmLib && jdgmLib.shopDomain,
          jdgmLib && jdgmLib.shopifyDomain,
          window.Shopify && window.Shopify.shop,
          document.domain
        ];

        for (var i = 0; i < candidates.length; i++) {
          var value = candidates[i];
          if (typeof value === 'function') {
            try {
              value = value();
            } catch (e) {
              value = '';
            }
          }

          if (typeof value === 'string' && value.indexOf('.') !== -1) {
            return value;
          }
        }

        return '';
      }

      function renderDrawerReviewsHtml(state, html, append) {
        if (!state || !state.widget || !state.modalHost) {
          return;
        }

        var host = state.modalHost;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html || '';
        var reviews = wrapper.querySelectorAll('.jdgm-rev');

        if (!append) {
          host.innerHTML = '<div class="jdgm-rev-widg"><div class="jdgm-rev-widg__reviews" data-pdp-reviews-list></div></div>';
        }

        var list = host.querySelector('[data-pdp-reviews-list]');
        if (!list) {
          list = document.createElement('div');
          list.className = 'jdgm-rev-widg__reviews';
          list.setAttribute('data-pdp-reviews-list', '');
          host.appendChild(list);
        }

        reviews.forEach(function (review) {
          normalizeDrawerReview(review);
          list.appendChild(review);
        });

        // Bulk re-normalize after a short delay — Judge.me's own JS sometimes
        // re-processes timestamps lazily on mobile and re-adds the spinner class
        window.setTimeout(function () {
          if (!state.modalHost) return;
          state.modalHost.querySelectorAll('.jdgm-rev__timestamp.jdgm-spinner').forEach(function (ts) {
            var reviewEl = ts.closest('.jdgm-rev');
            if (reviewEl) normalizeDrawerReview(reviewEl);
          });
        }, 300);

        renderDrawerLoadMore(state);
      }

      function normalizeDrawerReview(review) {
        var timestamp = review.querySelector('.jdgm-rev__timestamp');
        if (!timestamp) return;

        // Always strip the spinner class so Judge.me's external CSS animation stops
        timestamp.classList.remove('jdgm-spinner');

        // Try to extract a date from data-content, data-timestamp, or text content
        var raw = timestamp.getAttribute('data-content') ||
                  timestamp.getAttribute('data-timestamp') ||
                  timestamp.textContent.trim();
        if (!raw) return;

        var formatted = formatJudgeMeReviewDate(raw);
        if (formatted) timestamp.textContent = formatted;
      }

      function formatJudgeMeReviewDate(raw) {
        raw = (raw || '').trim();
        if (!raw) return '';

        function pad(value) {
          return ('0' + value).slice(-2);
        }

        function formatDate(date) {
          if (isNaN(date.getTime()) || date.getFullYear() < 2000) return '';
          return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear();
        }

        // Judge.me returns values like "2026-05-20 16:44:05 UTC".
        // iOS Safari does not reliably parse that format with new Date().
        var ymd = raw.match(/^(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})/);
        if (ymd) {
          return pad(ymd[3]) + '/' + pad(ymd[2]) + '/' + ymd[1];
        }

        var dmy = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
        if (dmy) {
          return pad(dmy[1]) + '/' + pad(dmy[2]) + '/' + dmy[3];
        }

        if (/^\d+$/.test(raw)) {
          var numeric = parseInt(raw, 10);
          if (numeric > 1000000000000) return formatDate(new Date(numeric));
          if (numeric > 1000000000) return formatDate(new Date(numeric * 1000));
        }

        return formatDate(new Date(raw));
      }

      function renderDrawerLoadMore(state) {
        if (!state || !state.modalHost) {
          return;
        }

        state.modalHost.querySelectorAll('.reviews-drawer__load-more-wrap').forEach(function (wrap) {
          wrap.remove();
        });

        if (state.totalCount) {
          if (state.modalHost.querySelectorAll('.jdgm-rev').length >= state.totalCount) {
            return;
          }
        } else if (state.lastPageCount < reviewsPerPage) {
          return;
        }

        var wrap = document.createElement('div');
        wrap.className = 'reviews-drawer__load-more-wrap';
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'jdgm-paginate__load-more';
        button.setAttribute('data-pdp-reviews-drawer-load-more', '');
        button.textContent = 'LOAD MORE REVIEWS';
        button.addEventListener('click', function (e) {
          e.preventDefault();
          loadMoreReviews(state);
        });
        wrap.appendChild(button);
        state.modalHost.appendChild(wrap);
      }

      function buildReviewsEndpoint(state, page, perPage) {
        if (!state || !state.shopDomain) {
          return null;
        }

        var url = new URL('https://api.judge.me/reviews/reviews_for_widget');
        url.searchParams.set('url', state.shopDomain);
        url.searchParams.set('shop_domain', state.shopDomain);
        url.searchParams.set('platform', 'shopify');
        url.searchParams.set('per_page', String(perPage || reviewsPerPage));
        url.searchParams.set('page', String(page || 1));

        if (state.productId) {
          url.searchParams.set('product_id', state.productId);
        } else if (state.productHandle) {
          url.searchParams.set('product_handle', state.productHandle);
        } else {
          return null;
        }

        if (activeStarFilter !== null) {
          url.searchParams.set('filter_rating', String(activeStarFilter));
        }

        return url.toString();
      }

      function setReviewsDrawerLoading(state, loading) {
        if (!state || !state.modalHost) {
          return;
        }

        state.modalHost.classList.toggle('reviews-drawer__loading', loading);

        var parent = state.modalHost.parentNode;
        if (parent) {
          var spinner = parent.querySelector('[data-reviews-spinner]');
          if (spinner) {
            var hasContent = state.modalHost.querySelectorAll('.jdgm-rev').length > 0;
            spinner.style.display = (loading && !hasContent) ? 'flex' : 'none';
          }
        }
      }

      function fetchDrawerReviews(page, append, perPage) {
        var state = activeReviewState;
        if (!state || !state.modalHost) {
          return;
        }

        // Cancel any in-flight request and mark loading
        var url = buildReviewsEndpoint(state, page, perPage);
        if (!url) {
          renderDrawerReviewsHtml(state, state.widget ? state.widget.innerHTML : '', false);
          return;
        }

        var requestId = ++reviewsRequestId;
        state.isLoading = true;
        setReviewsDrawerLoading(state, true);

        fetch(url, { credentials: 'omit' })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Judge.me reviews request failed');
            }
            return response.json();
          })
          .then(function (data) {
            if (requestId !== reviewsRequestId || activeReviewState !== state) {
              return;
            }

            state.totalCount = parseInt(data.total_count, 10) || 0;
            state.currentPage = parseInt(data.page, 10) || page || 1;
            state.lastPageCount = countReviewsInHtml(data.html || '');
            renderDrawerReviewsHtml(state, data.html || '', append);
          })
          .catch(function () {
            if (requestId !== reviewsRequestId || activeReviewState !== state) {
              return;
            }
            renderDrawerReviewsHtml(state, state.widget ? state.widget.innerHTML : '', false);
          })
          .finally(function () {
            if (requestId === reviewsRequestId && activeReviewState === state) {
              state.isLoading = false;
              setReviewsDrawerLoading(state, false);
            }
          });
      }

      function countReviewsInHtml(html) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html || '';
        return wrapper.querySelectorAll('.jdgm-rev').length;
      }

      function loadMoreReviews(state, onComplete) {
        if (!state || !state.modalHost || state.isLoading) {
          if (onComplete) onComplete();
          return;
        }

        // Check if all reviews are already loaded
        var loaded = state.modalHost.querySelectorAll('.jdgm-rev').length;
        if (state.totalCount && loaded >= state.totalCount) {
          if (onComplete) onComplete();
          return;
        }

        var page1 = state.currentPage + 1;
        var page2 = state.currentPage + 2;
        var url1 = buildReviewsEndpoint(state, page1);
        var url2 = buildReviewsEndpoint(state, page2);
        if (!url1) {
          if (onComplete) onComplete();
          return;
        }

        var cancelId = ++reviewsRequestId;
        state.isLoading = true;
        setReviewsDrawerLoading(state, true);

        var fetchPage = function (url) {
          return fetch(url, { credentials: 'omit' })
            .then(function (r) {
              if (!r.ok) throw new Error('Failed');
              return r.json();
            })
            .catch(function () {
              return { html: '', total_count: 0, page: 0 };
            });
        };

        Promise.all([fetchPage(url1), url2 ? fetchPage(url2) : Promise.resolve({ html: '', total_count: 0, page: 0 })])
          .then(function (results) {
            if (cancelId !== reviewsRequestId || activeReviewState !== state) return;

            var data1 = results[0];
            var data2 = results[1];
            var count1 = countReviewsInHtml(data1.html || '');
            var count2 = countReviewsInHtml(data2.html || '');

            state.totalCount = parseInt(data1.total_count, 10) || parseInt(data2.total_count, 10) || state.totalCount || 0;

            // Only advance currentPage to the last page that had reviews
            if (count2 > 0) {
              state.currentPage = page2;
            } else if (count1 > 0) {
              state.currentPage = page1;
            }
            state.lastPageCount = count2 > 0 ? count2 : count1;

            var combinedHtml = (data1.html || '') + (data2.html || '');
            renderDrawerReviewsHtml(state, combinedHtml, true);
          })
          .finally(function () {
            state.isLoading = false;
            if (cancelId === reviewsRequestId && activeReviewState === state) {
              setReviewsDrawerLoading(state, false);
            }
            if (onComplete) onComplete();
          });
      }

      function closeReviewsDrawer() {
        var state = activeReviewState;

        // Reset filter state
        activeStarFilter = null;
        reviewsRequestId++;

        // Reset star chip UI
        var starContainer = document.querySelector('[data-reviews-star-chips]');
        if (starContainer) {
          starContainer.querySelectorAll('[data-reviews-star]').forEach(function (chip) {
            chip.classList.remove('reviews-drawer__star-chip--active');
          });
        }

        // Clear drawer content
        var host = document.querySelector('[data-pdp-reviews-modal-host]');
        if (host) {
          host.innerHTML = '';
        }

        activeReviewState = null;
      }

      function bindReviewTriggers(state) {
        if (!state || !state.root) {
          return;
        }

        var triggers = [];

        state.root.querySelectorAll('[data-pdp-reviews-open]').forEach(function (trigger) {
          triggers.push(trigger);
        });

        if (state.section && state.section.querySelectorAll) {
          state.section.querySelectorAll('[data-pdp-reviews-open]').forEach(function (trigger) {
            if (triggers.indexOf(trigger) === -1) {
              triggers.push(trigger);
            }
          });
        }

        triggers.forEach(function (trigger) {
          if (trigger.dataset.pdpReviewsBound === 'true') {
            return;
          }

          trigger.dataset.pdpReviewsBound = 'true';
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-expanded', 'false');

          if (state.modalElement) {
            trigger.setAttribute('aria-controls', state.modalElement.id);
          }

          trigger.addEventListener('click', function (event) {
            if (!trigger.hasAttribute('data-pdp-reviews-open')) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();

            var drawer = getOrCreateReviewsDrawer();
            if (!drawer) {
              return;
            }

            state.trigger = trigger;
            activeReviewState = state;
            buildStarChips(state.widget);
            drawer.open(event, trigger);
            fetchDrawerReviews(1, false);
          }, true);
        });
      }

      function addWidget(widget) {
        if (widget && widgets.indexOf(widget) === -1) {
          widgets.push(widget);
        }
      }

      if (root instanceof Element && root.closest) {
        addWidget(root.closest('.jdgm-rev-widg'));
      }

      if (root.matches && root.matches('.jdgm-rev-widg')) {
        addWidget(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll('.jdgm-rev-widg').forEach(addWidget);
      }

      widgets.forEach(function (widget) {
        var modalState = getModalState(widget);

        widget.querySelectorAll('.jdgm-rev-widg__summary-average').forEach(function (averageEl) {
          var averageMatch = (averageEl.textContent || '').match(/[\d]+(?:[.,]\d+)?/);
          if (!averageMatch) {
            return;
          }

          var average = parseFloat(averageMatch[0].replace(',', '.'));
          if (!isNaN(average)) {
            averageEl.textContent = average.toFixed(1);
          }
        });

        // Add thousands separators to the long counts judge.me renders raw — the
        // rating breakdown frequencies and the review-count badges ("customer
        // recommended" area). Idempotent: a 3-digit run (already grouped) won't match.
        widget.querySelectorAll('.jdgm-histogram__frequency, .jdgm-prev-badge__text').forEach(function (el) {
          el.textContent = el.textContent.replace(/\d{4,}/g, function (m) {
            return Number(m).toLocaleString('en-US');
          });
        });

        widget.querySelectorAll('.jdgm-rev-widg__summary-text').forEach(function (summaryTextEl) {
          var countMatch = (summaryTextEl.textContent || '').match(/[\d,.]+/);
          if (!countMatch) {
            return;
          }

          var reviewCount = countMatch[0].replace(/[^\d]/g, '');
          var reviewCountLabel = Number(reviewCount).toLocaleString('en-US');
          summaryTextEl.textContent = reviewCountLabel + ' ' + (reviewCount === '1' ? 'review' : 'reviews');
        });

        // Set load-more button to act as drawer trigger
        var totalReviewCount = widget.getAttribute('data-number-of-reviews') || '';
        if (totalReviewCount) {
          var totalReviewCountLabel = String(totalReviewCount).replace(/\d{4,}/g, function (m) {
            return Number(m).toLocaleString('en-US');
          });
          widget.querySelectorAll('.jdgm-paginate__load-more').forEach(function (btn) {
            btn.textContent = 'Read all ' + totalReviewCountLabel + ' reviews';
            btn.setAttribute('data-pdp-reviews-open', '');
          });
        }

        widget.querySelectorAll('.jdgm-cf-bar').forEach(function (bar) {
          bar.setAttribute('aria-label', 'Review rating scale segment');
          bar.setAttribute('tabindex', '-1');
        });

        // Move the fit-rating averages box into the summary/histogram grid
        // so the CSS `order:2` rule can place it between the rating cards
        // and the Write a Review button. Judge.me renders it as a sibling of
        // .jdgm-row-stars by default, which puts it visually below the button.
        var rowStars = widget.querySelector('.jdgm-row-stars');
        var fitRating = widget.querySelector('.jdgm-custom-forms-avg-responses');
        if (rowStars && fitRating && fitRating.parentElement !== rowStars) {
          rowStars.appendChild(fitRating);
        }

        bindReviewTriggers(modalState);
      });
    }

    function init() {
      if (initialized || !document.body) {
        return;
      }

      initialized = true;
      setPreviewBarTitle();
      normalizeJudgeMeBadges();
      normalizeJudgeMeReviewWidgets();

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) {
              return;
            }

            if (node.id === 'PBarNextFrame') {
              setPreviewBarTitle();
            }

            normalizeJudgeMeBadges(node);
            normalizeJudgeMeReviewWidgets(node);
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    return {
      init: init
    };
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function () {
          newAddressForm.classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
            }
          }
        })
      });
    }
  };

  theme.CartDrawer = (function () {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm',
      toast: '[data-cart-added-toast]',
      toastImage: '[data-cart-added-toast-image]',
      toastTitle: '[data-cart-added-toast-title]',
      toastColor: '[data-cart-added-toast-color]',
      toastSize: '[data-cart-added-toast-size]',
      toastPrice: '[data-cart-added-toast-price]',
      toastUndo: '[data-cart-added-toast-undo]',
      removeItem: '[data-cart-remove]'
    };

    function getToastImage(product) {
      var imageUrl = '';

      if (product && product.featured_image && product.featured_image.url) {
        imageUrl = product.featured_image.url;
      } else if (product && product.image) {
        imageUrl = product.image;
      }

      if (imageUrl && theme.Images && typeof theme.Images.getSizedImageUrl === 'function') {
        return theme.Images.getSizedImageUrl(imageUrl, '180x225') || imageUrl;
      }

      return imageUrl;
    }

    function getToastOptionMeta(product) {
      var meta = {
        color: '',
        size: ''
      };

      if (!product) {
        return meta;
      }

      if (product.vendor) {
        meta.color = product.vendor;
      }

      if (product.properties && typeof product.properties._quick_add_color === 'string') {
        meta.color = product.properties._quick_add_color.trim();
      }

      if (Array.isArray(product.options_with_values)) {
        product.options_with_values.forEach(function (option) {
          var name = option && option.name ? option.name : '';
          var value = option && option.value ? option.value : '';

          if (!value || String(value).toLowerCase() === 'default title') {
            return;
          }

          if (!meta.color && /colou?r/i.test(name)) {
            meta.color = value;
            return;
          }

          if (!meta.size && /size/i.test(name)) {
            meta.size = value;
          }
        });
      }

      if (!meta.size && product.variant_title && product.variant_title !== 'Default Title') {
        meta.size = product.variant_title.split(' / ').filter(function (value) {
          return value && value !== meta.color;
        })[0] || '';
      }

      return meta;
    }

    function getToastPrice(product) {
      if (!product) {
        return 0;
      }

      if (typeof product.final_price === 'number') {
        return product.final_price;
      }

      if (typeof product.price === 'number') {
        return product.price;
      }

      if (typeof product.final_line_price === 'number' && typeof product.quantity === 'number' && product.quantity > 0) {
        return Math.round(product.final_line_price / product.quantity);
      }

      return 0;
    }

    function formatToastMoney(cents) {
      if (theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }

      return '$' + (cents / 100).toFixed(2);
    }

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      this.toast = document.querySelector(selectors.toast);
      this.toastTimer = null;
      this.toastProduct = null;
      this.toastQuantityAdded = 1;

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        if (this.toast) {
          document.body.appendChild(this.toast);
          this.toast.addEventListener('click', this.onToastClick.bind(this));
        }

        if (this.form) {
          this.form.addEventListener('click', this.onRemoveClick.bind(this));
        }

        document.addEventListener('ajaxProduct:added', function (evt) {
          // Rebuild every cart surface (drawer + cart page) so items added via
          // the cart upsell app appear immediately, without a page refresh.
          // Both CartForm instances listen to 'cart:build'.
          document.dispatchEvent(new CustomEvent('cart:build'));

          this.showAddedToast(
            evt.detail && evt.detail.product ? evt.detail.product : null,
            evt.detail && evt.detail.quantityAdded ? evt.detail.quantityAdded : 1
          );
        }.bind(this));

        // Dismiss the "item added" toast when any drawer opens (cart, burger
        // menu, etc.) or when the search opens.
        document.addEventListener('drawerOpen', function () {
          this.hideAddedToast(true);
        }.bind(this));

        document.addEventListener('predictive-search:open', function () {
          this.hideAddedToast(true);
        }.bind(this));

        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function () {
        this.hideAddedToast(true);
        this.drawer.open();

        theme.a11y.trapFocus({
          container: this.form,
          elementToFocus: this.form,
          namespace: 'cartdrawer_focus'
        });
      },

      close: function () {
        this.drawer.close();

        theme.a11y.removeTrapFocus({
          container: this.form,
          namespace: 'cartdrawer_focus'
        });
      },

      onRemoveClick: function (evt) {
        var removeLink = evt.target.closest(selectors.removeItem);

        if (!removeLink) {
          return;
        }

        var key = removeLink.dataset.key;

        if (!key) {
          return;
        }

        evt.preventDefault();
        removeLink.setAttribute('aria-disabled', 'true');

        theme.cart.changeItem(key, 0)
          .then(function (cart) {
            var parsedCart = JSON.parse(cart);

            if (parsedCart.status === 422) {
              alert(parsedCart.message);
              removeLink.removeAttribute('aria-disabled');
              return;
            }

            if (this.cartForm && typeof this.cartForm.buildCart === 'function') {
              this.cartForm.buildCart();
            }

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: parsedCart
              }
            }));
          }.bind(this))
          .catch(function (error) {
            console.error(error);
            removeLink.removeAttribute('aria-disabled');
          });
      },

      onToastClick: function (evt) {
        var undoButton = evt.target.closest(selectors.toastUndo);

        if (!undoButton) {
          // Clicking the toast (anywhere but Undo) dismisses it and opens the
          // cart — matches main. cart:open is already handled by the drawer
          // (see addEventListener('cart:open', this.open) above); hideAddedToast(true)
          // hides it immediately so it doesn't linger behind the opening cart.
          evt.preventDefault();
          evt.stopPropagation();
          this.hideAddedToast(true);
          document.dispatchEvent(new CustomEvent('cart:open'));
          return;
        }

        if (!this.toastProduct || !this.toastProduct.key) {
          return;
        }

        evt.preventDefault();
        undoButton.disabled = true;

        theme.cart.getCart()
          .then(function (cart) {
            var currentItem = cart.items.find(function (item) {
              return item.key === this.toastProduct.key;
            }.bind(this));

            if (!currentItem) {
              return null;
            }

            var nextQuantity = Math.max(currentItem.quantity - this.toastQuantityAdded, 0);

            return theme.cart.changeItem(this.toastProduct.key, nextQuantity);
          }.bind(this))
          .then(function (cart) {
            if (this.cartForm && typeof this.cartForm.buildCart === 'function') {
              this.cartForm.buildCart();
            }

            if (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                  cart: JSON.parse(cart)
                }
              }));
            }

            this.hideAddedToast();
          }.bind(this))
          .catch(function (error) {
            console.error(error);
            undoButton.disabled = false;
          });
      },

      showAddedToast: function (product, quantityAdded) {
        if (!this.toast) {
          return;
        }

        // Don't show the "item added" toast in a cart context. On the cart page
        // or while the cart drawer is open, the cart UI already updates inline,
        // so the toast is redundant (and the cart upsell app would trigger it).
        if (document.body.classList.contains('template-cart') || (this.drawer && this.drawer.isOpen)) {
          return;
        }

        var image = this.toast.querySelector(selectors.toastImage);
        var title = this.toast.querySelector(selectors.toastTitle);
        var color = this.toast.querySelector(selectors.toastColor);
        var size = this.toast.querySelector(selectors.toastSize);
        var price = this.toast.querySelector(selectors.toastPrice);
        var titleText = product && (product.product_title || product.title) ? (product.product_title || product.title) : '';

        this.toastProduct = product;
        this.toastQuantityAdded = Math.max(1, parseInt(quantityAdded, 10) || 1);
        this.toast.hidden = false;
        this.toast.classList.add('is-visible');

        var undoButton = this.toast.querySelector(selectors.toastUndo);
        if (undoButton) {
          undoButton.disabled = !(product && product.key);
        }

        if (title) {
          title.textContent = titleText;
          title.hidden = !titleText;
        }

        try {
          if (image) {
            var imageUrl = getToastImage(product);
            image.textContent = '';

            if (imageUrl) {
              var imageElement = document.createElement('img');
              // Prioritise the fetch + async-decode so the thumbnail shows
              // promptly instead of racing the cart rebuild / section renders.
              imageElement.fetchPriority = 'high';
              imageElement.decoding = 'async';
              imageElement.loading = 'eager';
              imageElement.alt = titleText;
              imageElement.src = imageUrl;
              image.appendChild(imageElement);
            }

            image.hidden = !imageUrl;
          }

          var optionMeta = getToastOptionMeta(product);

          if (color) {
            var colorText = optionMeta.color ? 'Color: ' + optionMeta.color : '';
            color.textContent = colorText;
            color.hidden = !colorText;
          }

          if (size) {
            var sizeText = optionMeta.size ? 'Size: ' + optionMeta.size : '';
            size.textContent = sizeText;
            size.hidden = !sizeText;
          }

          if (price) {
            var priceValue = getToastPrice(product);
            price.innerHTML = priceValue ? formatToastMoney(priceValue) : '';
            price.hidden = !priceValue;
          }
        } catch (error) {
          console.error(error);
        }

        window.clearTimeout(this.toastTimer);
        this.toastTimer = window.setTimeout(function () {
          this.hideAddedToast();
        }.bind(this), 3800);
      },

      hideAddedToast: function (immediate) {
        if (!this.toast) {
          return;
        }

        this.toast.classList.remove('is-visible');
        window.clearTimeout(this.toastTimer);
        this.toastTimer = null;
        this.toastProduct = null;

        if (immediate) {
          this.toast.hidden = true;
          return;
        }

        window.setTimeout(function () {
          if (this.toast && !this.toast.classList.contains('is-visible')) {
            this.toast.hidden = true;
          }
        }.bind(this), 180);
      }
    });

    return CartDrawer;
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      navDetails: '.site-nav__details',
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };

    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }

      menuDetailsHandler();
      // searchDrawer() removed: the old predictive-search overlay was replaced
      // by snippets/search-drawer.liquid, which binds .js-search-header itself
      // (capture phase). The old bindings were dead weight it had to pre-empt.
    }

    function menuDetailsHandler() {
      const navDetails = document.querySelectorAll(selectors.navDetails);

      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector('summary');

        // if the navDetail is open, then close it when the user clicks outside of it
        document.addEventListener('click', (evt) => {
          if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
            navDetail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            if (navDetail.hasAttribute('open')) {
              summary.setAttribute('aria-expanded', 'false');
            } else {
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderInitialPosition(siteHeader);
      stickyHeaderHeight();

      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function () {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderInitialPosition(header) {
      const headerParent = header.closest('.shopify-section-group-header-group');
      const parentNextSibling = headerParent.nextElementSibling;

      // if parentNextSibling has same class as headerParent, then header is above announcement bar
      if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
        // get height of announcement bar and set header wrapper top to that value
        const nextSiblingHeight = parentNextSibling.offsetHeight;
        document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }

      var h = siteHeader.offsetHeight;

      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }

      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;
    }

    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;

        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function () {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', function (evt) {
          var container = document.querySelector(selectors.searchContainer);

          evt.preventDefault();
          evt.stopPropagation();
          document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
          document.dispatchEvent(new CustomEvent('predictive-search:open', {
            detail: {
              context: 'header'
            },
            bubbles: true
          }));

          // add is-active class to .site-header__search-container
          if (container) {
            container.classList.add('is-active');
          }
        });
      });

      document.addEventListener('predictive-search:close-all', function () {
        closeSearchDrawer();
      });
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }

            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');

      window.setTimeout(function () {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);

      var container = document.querySelector(selectors.searchContainer);
      if (!container) {
        return;
      }

      theme.utils.prepareTransition(container, function () {
        container.classList.remove('is-active');
      }.bind(this));
    }

    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };

  theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSizes) {
    var output = '';

    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSizes);

      let priceMarkup = '';
      let vendorMarkup = '';

      if (theme.settings.predictiveSearchPrice) priceMarkup = `<div class="grid-product__price">${theme.strings.productFrom}${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}</div>`;
      if (theme.settings.predictiveSearchVendor) vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;

      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
                ${priceMarkup}
                ${vendorMarkup}
              </div>
            </a>
          </div>
        </div>
      `;

      output += markup;
    });

    return output;
  }

  theme.buildProductImage = function (product, imageSizes) {
    var size = theme.settings.productImageSize;
    var output = '';

    if (size === 'natural') {
      const template = document.getElementById("naturalImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.image-wrap');

      imageWrapperEl.style.paddingBottom = `${product.image_aspect_ratio}%`;

      addImageProperties(imageEl, imageSizes);

      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);

      output = imageDiv.innerHTML;
    } else {
      const template = document.getElementById("fixedRatioImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.grid__image-ratio');

      imageWrapperEl.classList.add(`grid__image-ratio--${size}`);

      if (!theme.settings.productImageCover) {
        imageEl.classList.add('grid__image-contain');
      }

      addImageProperties(imageEl, imageSizes);

      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);

      output = imageDiv.innerHTML;
    }

    function addImageProperties(imageEl, imageSizes) {
      imageEl.src = product.image_responsive_url;
      imageEl.srcset = product.image_responsive_urls.toString();
      imageEl.alt = product.title;
      imageEl.sizes = imageSizes;
    }

    return output;
  }


  /*============================================================================
    Age Verification Popup
  ==============================================================================*/

  class AgeVerificationPopup extends HTMLElement {
    constructor() {
      super();

      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);

      this.classes = {
        activeContent: 'age-verification-popup__content--active',
        inactiveContent: 'age-verification-popup__content--inactive',
        inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
        activeDeclineContent: 'age-verification-popup__decline-content--active',
      }

      this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
      this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
      this.content = this.querySelector('[data-age-verification-popup-content]');
      this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
      this.exitButton = this.querySelector('[data-age-verification-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        })

        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();

            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }

            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);

            if (!secondViewVisited) return;

            this.showDeclineContent();
          }
        })

        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.modal.close();
          }
        })
      }

      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR visibility is toggled in the editor
      if ((this.cookie) && this.dataset.testMode === 'false') return;

      this.init();
    }

    init() {
      this.modal = new theme.Modals(this.id, 'age-verification-popup-modal', {
        closeOffContentClick: false
      });

      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }

      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }

      this.modal.open();

      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));

      if (this.declineButton) {
        this.declineButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showDeclineContent();

          // If in editor, save to session storage to indicate that user has moved on to the second view
          // Allows view to persist while making changes in the editor
          if (Shopify.designMode) {
            sessionStorage.setItem(this.id, 'second-view');
          }
        });
      }

      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();

          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);

          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }

      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();

          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30, sameSite: 'none', secure: true });
          }

          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }

          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }

          this.modal.close();

          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }

    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);

      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }

    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);

      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }

  customElements.define('age-verification-popup', AgeVerificationPopup);



  theme.Maps = (function () {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];

    var errors = {};

    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };

    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function () {
      if (!Shopify.designMode) {
        return;
      }

      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });

      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });

      window.mapError(theme.strings.authError);
    };

    window.mapError = function (error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };

    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;

      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };

      if (!this.key) {
        return;
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }

    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }

    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();

      if (!map) {
        return;
      }

      var address = map.dataset.addressSetting;

      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });

      return deferred;
    }

    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function () {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);

          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined') {

              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },

      createMap: function () {
        var mapDiv = this.map;

        return geolocate(mapDiv)
          .then(
            function (results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };

              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());

              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });

              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function () {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );

              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function (status) {
            var errorMessage;

            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },

      onUnload: function () {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });

    return Map;
  })();

  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');

      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);

      if (!container) {
        return;
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }

      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }

      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };

      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }

      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }

      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));

      if (!this.cookie) {
        this.initPopupDelay();
      }

      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }

    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            sessionStorage.setItem('newsletterAppeared', true);
          }

        }.bind(this), this.data.secondsBeforeShow * 1000);
      },

      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');

        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if (!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },

      onLoad: function () {
        this.modal.open();
      },

      onSelect: function () {
        this.modal.open();
      },

      onDeselect: function () {
        this.modal.close();
      },

      onBlockSelect: function () {
        this.modal.close();
      },

      onBlockDeselect: function () {
        this.modal.open();
      },

      onUnload: function () {
        this.modal.close();
      }
    });

    return NewsletterPopup;
  })();

  theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function () {
        if (!document.querySelector('#LoginModal')) {
          return;
        }

        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });

        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });

    return PasswordHeader;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === 'false') {
        return;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },

      triggerClick: function (evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }

        this.items = this.getImageData();

        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;

        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
          : this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        }

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');

        window.addEventListener('resize', this.syncHeight);

        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, initialScrollPos);
        });
      }
    });

    return Photoswipe;
  })();


  /*============================================================================
    ProductRecommendations
  ==============================================================================*/

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.url = this.dataset.url;
      this.intent = this.dataset.intent;
      this.placeholder = this.querySelector('.product-recommendations-placeholder');
      this.productResults = this.querySelector('.grid-product');
      this.sectionId = this.dataset.sectionId;
      this.blockId = this.dataset.blockId;
      this.recommendationsListenerBound = false;
      this.handleRecommendationsLoaded = (e) => {
        this.colorImages = this.el.querySelectorAll('.grid-product__color-image');
        if (this.colorImages.length) {
          this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
          this.colorSwatchHovering();
        }
      };
    }

    connectedCallback() {
      if (!this.recommendationsListenerBound) {
        document.addEventListener('recommendations:loaded', this.handleRecommendationsLoaded);
        this.recommendationsListenerBound = true;
      }

      this.loadRecommendations();
    }

    refreshForProduct(productId) {
      if (!productId || productId === this.dataset.productId) return;

      const url = new URL(this.url, window.location.origin);
      url.searchParams.set('product_id', productId);
      this.url = url.pathname + url.search;
      this.dataset.url = this.url;
      this.dataset.productId = productId;

      this.loadRecommendations();
    }

    loadRecommendations() {
      const requestToken = (this.requestToken || 0) + 1;
      this.requestToken = requestToken;

      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          if (!this.isConnected || requestToken !== this.requestToken) return;

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (!recommendations) {
            this.el.classList.add('hide');
            if (AOS) { AOS.refreshHard() }
            return;
          }

          this.el.classList.remove('hide');
          this.placeholder.innerHTML = '';
          this.placeholder.innerHTML = recommendations.innerHTML;

          theme.reinitProductGridItem(this.el);

          this.slideshow = this.querySelector('[data-slideshow]');

          if (this.slideshow) {
            this.setupSlider();
          }

          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: this.el,
              intent: this.intent
            }
          }));

        })
        .catch(e => {
          console.error(e);
        });
    }

    disconnectedCallback() {
      if (this.recommendationsListenerBound) {
        document.removeEventListener('recommendations:loaded', this.handleRecommendationsLoaded);
        this.recommendationsListenerBound = false;
      }

      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }
    }

    setupSlider() {
      const controlType = this.slideshow.dataset.controls;
      const perSlide = parseFloat(this.slideshow.dataset.perSlide);
      const count = parseFloat(this.slideshow.dataset.count);

      let prevNextButtons = false;
      let pageDots = true;

      if (controlType === 'arrows') {
        pageDots = false;
        prevNextButtons = true;
      }

      if (perSlide < count) {
        this.flickity = new theme.Slideshow(this.slideshow, {
          prevNextButtons,
          pageDots,
          adaptiveHeight: true,
          wrapAround: false,
        });
      }
    }

    colorSwatchHovering() {
      this.swatches.forEach(swatch => {
        if (swatch.dataset.colorHoverInitialized === 'true') return;
        swatch.dataset.colorHoverInitialized = 'true';

        swatch.addEventListener('mouseenter', function () {
          this.setActiveColorImage(swatch);
        }.bind(this));

        swatch.addEventListener('touchstart', function (evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), { passive: true });

        swatch.addEventListener('mouseleave', function () {
          this.removeActiveColorImage(swatch);
        }.bind(this));
      });
    }

    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;

      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });

      // Unset all active swatches
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });

      // Set active image and swatch
      const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);

      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      // Update product grid item href with variant URL
      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }

    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  theme.SlideshowSection = (function () {

    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;

      this.initialIndex = 0;

      if (!this.slideshow) { return }

      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }

    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function () {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');

        this.slideshow.classList.remove('loading', 'loading--delayed');
        this.slideshow.classList.add('loaded');

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
      },

      forceReload: function () {
        this.onUnload();
        this.init();
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function () {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });

    return SlideshowSection;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function (variantId) {
        // A sibling swap re-inits the product section (fires updateContent once)
        // and restoreSelectedOptions dispatches a change event (fires it again),
        // producing back-to-back identical ?section_id=store-availability
        // requests. Skip a repeat fetch for the variant we already rendered.
        if (variantId != null && String(this._lastVariantId) === String(variantId)) {
          return;
        }
        this._lastVariantId = variantId;

        var baseUrl = (this.baseUrl || '').replace(/\/$/, '');
        var variantSectionUrl =
          baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';

        var self = this;

        fetch(variantSectionUrl)
          .then(function (response) {
            if (!response.ok) {
              return '';
            }

            return response.text();
          })
          .then(function (html) {
            if (html.trim() === '') {
              self.container.innerHTML = '';
              return;
            }

            self.container.innerHTML = html;
            if (!self.container.firstElementChild) {
              return;
            }
            self.container.innerHTML = self.container.firstElementChild.innerHTML;

            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }

            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }

            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          })
          .catch(function () {
            // Swallow network failures fetching store availability (non-critical)
          });
      }
    });

    return StoreAvailability;
  })();

  theme.VideoSection = (function () {
    var selectors = {
      videoParent: '.video-parent-section'
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function () {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch (type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },

      initVimeoVideo: function (videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },

      initMp4Video: function () {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add('loaded');

          var playPromise = document.querySelector('#' + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function () {
              // playback normal
            }).catch(function () {
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
          }
        }
      },

      onUnload: function (evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });

    return videoSection;
  })();

  /*============================================================================
    CountdownTimer
  ==============================================================================*/

  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;

      this.timerComplete = false;

      this.init();
    }

    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);

    }

    _calculate() {
      // Find time difference and convert to integer
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };

        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;

        setTimeout(() => {
          this.display.classList.add('countdown__display--loaded');
        }, 1);
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }

        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }

        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }

        this.timerComplete = true;
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);

  /*============================================================================
    HotSpots
  ==============================================================================*/

  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll('[data-button]');
      this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]');
      this.blockContainer = this.querySelector('[data-block-container]');
      this.colorImages = this.querySelectorAll('.grid-product__color-image');
      this.colorSwatches = this.querySelectorAll('.color-swatch--with-image');

      this._bindEvents();
      this._setupQuickShop();

      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }

    _colorSwatchHovering() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function () {
          this._setActiveColorImage(swatch);
        }.bind(this));

        swatch.addEventListener('touchstart', function (evt) {
          evt.preventDefault();
          this._setActiveColorImage(swatch);
        }.bind(this), { passive: true });

        swatch.addEventListener('mouseleave', function () {
          this._removeActiveColorImage(swatch);
        }.bind(this));
      });
    }

    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;

      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });

      // Unset all active swatches
      this.colorSwatches.forEach(el => {
        el.classList.remove('is-active');
      });

      // Set active image and swatch
      var imageEl = this.el.querySelector('.grid-product__color-image--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');

      if (gridItem) gridItem.setAttribute('href', variantUrl);
    }

    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }

    /* Setup event listeners */
    _bindEvents() {
      this.buttons.forEach(button => {
        const id = button.dataset.button;

        button.on('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id);
        });
      });

      // Display active hotspot block on theme editor select
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }

    /* Toggle sidebar content */
    _showContent(id) {
      // Hide all hotspotBlock
      // Show the hotspotBlock with the id
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      });
    }

    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // Ensure we are utilizing the right version of QuickShop based off of theme
        if (typeof theme.QuickShop === 'function') {
          new theme.QuickShop(this.blockContainer);
        } else if (typeof theme.initQuickShop === 'function') {
          theme.initQuickShop();
        }

        if (typeof theme.QuickAdd === 'function') {
          new theme.QuickAdd(this.blockContainer);
        }
      }
    }
  }

  customElements.define('hot-spots', HotSpots);

  /*============================================================================
    ImageCompare
  ==============================================================================*/

  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');

      this.calculateSizes();

      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;

      this.buttonOffset = this.button.offsetWidth / 2;

      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);

      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);

      window.on('resize', theme.utils.debounce(250, () => { this.calculateSizes(true) }));

      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }

    calculateSizes(hasResized = false) {
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;

      this.buttonOffset = this.button.offsetWidth / 2;

      this.elWidth = this.el.offsetWidth;

      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;

      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }

      if (hasResized) this.draggableContainer.style.width = `${this.elWidth / 2}px`;
    }

    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }

      if (e.target === this.button) {
        this.active = true;
      }
    }

    dragEnd(e) {
      this.initialX = this.currentX;

      this.active = false;
    }

    drag(e) {
      if (this.active) {

        e.preventDefault();

        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }

        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }

    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth / 2) + xPos;

      const boundaryPadding = 50;
      const XposMin = (this.elWidth / 2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth / 2 - this.buttonOffset;

      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }

      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }

  customElements.define('image-compare', ImageCompare);



  theme.Blog = (function () {



    function Blog(container) {

      this.tagFilters();

    }



    Blog.prototype = Object.assign({}, Blog.prototype, {

      tagFilters: function () {

        var filterBy = document.getElementById('BlogTagFilter');



        if (!filterBy) {

          return;

        }



        filterBy.addEventListener('change', function () {

          location.href = filterBy.value;

        });

      }

    });



    return Blog;

  })();


  theme.CollectionHeader = (function () {
    var hasLoadedBefore = false;

    function CollectionHeader(container) {
      this.namespace = '.collection-header';

      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        heroImageContainer.classList.remove('loading', 'loading--delayed');
        heroImageContainer.classList.add('loaded');
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      hasLoadedBefore = true;
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      }
    });

    return CollectionHeader;
  })();

  theme.CollectionSidebar = (function () {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
    };

    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function (skipDrawerReinit) {
        // Do not load when no sidebar exists
        if (!this.container) {
          return;
        }

        this.onUnload();

        drawerStyle = this.container.dataset.style === 'drawer';

        if (!skipDrawerReinit) {
          theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
        }
      },

      forceReload: function (skipDrawerReinit) {
        this.init(skipDrawerReinit);
      },

      onSelect: function () {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },

      onDeselect: function () {
        if (theme.FilterDrawer) {
          if (drawerStyle && document.documentElement.classList.contains('js-filter-drawer-persist')) {
            return;
          }
          theme.FilterDrawer.close();
        }
      },

      onUnload: function () {
        if (theme.FilterDrawer) {
          if (drawerStyle && document.documentElement.classList.contains('js-filter-drawer-persist')) {
            return;
          }
          theme.FilterDrawer.close();
        }
      }
    });

    return CollectionSidebar;
  })();

  theme.Collection = (function () {
    var isAnimating = false;

    var selectors = {
      sortSelect: '#SortBy',

      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',

      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };

    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };

    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      // One collection-grid per page (collection or search results); the
      // search drawer routes in-page re-searches through this instance so
      // only the results area refreshes (see runSearch).
      theme.activeCollectionGrid = this;
      this.sidebar = new theme.CollectionSidebar(container);
      this.context = container.getAttribute('data-context');
      this.drawerStyle = false;
      this.shouldReopenFilterDrawer = false;
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });

      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function (skipDrawerReinit) {

        /* Prevent extra JS from running for featured collection on a collection template */
        if (this.context && this.context === 'featured-collection') {
          this.colorSwatchHovering();
        } else {
          var sidebarEl = document.querySelector(selectors.sidebar);
          this.drawerStyle = sidebarEl && sidebarEl.dataset.style === 'drawer';
          this.initSort();
          this.colorSwatchHovering();
          this.initFilters();
          this.initPriceRange();
          this.sidebar.init(skipDrawerReinit);
          this.bindFilterDrawerOpen();
        }
      },

      bindFilterDrawerOpen: function () {
        var self = this;

        // Remove any existing handler
        if (this._filterDrawerClickHandler) {
          document.removeEventListener('click', this._filterDrawerClickHandler, true);
        }

        this._filterDrawerClickHandler = function (evt) {
          var trigger = evt.target.closest('.js-drawer-open-collection-filters');
          if (!trigger) {
            return;
          }

          evt.preventDefault();
          evt.stopPropagation();

          if (!theme.FilterDrawer) {
            return;
          }

          // Sync drawer reference
          var currentDrawer = document.getElementById('FilterDrawer');
          if (currentDrawer) {
            theme.FilterDrawer.drawer = currentDrawer;
          }

          // Force reset isOpen if drawer is not actually open
          if (!theme.FilterDrawer.drawer || !theme.FilterDrawer.drawer.classList.contains('drawer--is-open')) {
            theme.FilterDrawer.isOpen = false;
          }

          theme.FilterDrawer.open(null, trigger);
        };

        document.addEventListener('click', this._filterDrawerClickHandler, true);
      },

      setFilterDrawerState: function () {
        this.shouldReopenFilterDrawer = this.drawerStyle && theme.FilterDrawer && theme.FilterDrawer.isOpen;
        if (this.shouldReopenFilterDrawer) {
          document.documentElement.classList.add('js-filter-drawer-persist');
        }
      },

      initSort: function () {
        this.sortSelect = document.querySelector(selectors.sortSelect);

        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },

      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort;
      },

      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute('data-default-sortby');
      },

      onSortChange: function () {
        this.queryParams = new URLSearchParams(window.location.search);

        this.queryParams.set('sort_by', this.getSortValue());
        this.queryParams.delete('page'); // Delete if it exists

        // AJAX like the filters (was window.location.search = ... — the only
        // filter-drawer control that still tore down the whole page).
        this.startLoading();
        this.renderCollectionPage(this.queryParams);
      },

      // In-page search: swap only the results area for a new query — the
      // header/toolbar/nav stay mounted. Called by search-drawer.js when a
      // query is submitted while already on the search page. New query =
      // fresh filter scope (matches full-navigation behaviour), but the
      // user's sort choice is preserved (the old full reload dropped it).
      runSearch: function (term) {
        if (!term) return;
        var current = new URLSearchParams(window.location.search);
        this.queryParams = new URLSearchParams();
        this.queryParams.set('q', term);
        // The Liquid type=product redirect guard only runs on full loads.
        this.queryParams.set('type', 'product');
        if (current.get('sort_by')) this.queryParams.set('sort_by', current.get('sort_by'));
        // Full swap for a NEW query: a different term returns a different set
        // of filter facets, so the grid-only path (which keeps the existing
        // sidebar DOM) would leave the previous query's filters showing. The
        // "checkbox unmounts under cursor" issue the grid-only path avoids
        // only affects filter clicks, not a fresh query, so this is safe.
        this._fullAjaxSwap = true;
        this.startLoading();
        this.renderCollectionPage(this.queryParams);
      },

      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }

        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', () => {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = this.container.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', () => {
            var id = swatch.dataset.variantId;
            this.container.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
      },

      /*====================
        Collection filters
      ====================*/
      initFilters: function () {
        var tags = document.querySelectorAll(selectors.tags);

        if (!tags.length) {
          return;
        }

        this.bindBackButton();

        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();

          window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
        }

        document.querySelectorAll(selectors.activeTags).forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });

        document.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('input', this.onFormSubmit.bind(this));
        });
      },

      initPriceRange: function () {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new theme.PriceRange(el, {
          // onChange passes in formData
          onChange: this.renderFromFormData.bind(this),
        }));
      },

      tagClick: function (evt) {
        var el = evt.currentTarget;

        this.setFilterDrawerState();

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();

        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.parentNode;
        const newUrl = new URL(el.href);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },

      onFormSubmit: function (evt) {
        var el = evt.target;

        this.setFilterDrawerState();

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();
        if (isAnimating) {
          // A render is already in flight — that response was fetched
          // WITHOUT this click's change, so when it lands it would revert
          // the checkbox the user just ticked. Queue the form's latest
          // state (includes both the in-flight change and this one) and
          // re-render once the current pass completes (see
          // renderCollectionPage's .then).
          var pendingForm = el.closest('form');
          if (pendingForm) {
            this._pendingFilterParams = new URLSearchParams(new FormData(pendingForm));
          }
          return;
        }

        isAnimating = true;

        const parent = el.closest('li');
        const formEl = el.closest('form');
        const formData = new FormData(formEl);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },

      fetchOpenCollasibleFilters: function () {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },

      renderActiveTag: function (parent, el) {
        const textEl = parent.querySelector('.tag__text');

        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);

          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            document.querySelectorAll(selectors.activeTagList).forEach(list => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = textEl.innerText;
              newTag.appendChild(newTagLink);

              list.appendChild(newTag);
            });
          }
        }
      },

      renderFromFormData: function (formData) {
        this.setFilterDrawerState();
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },

      onReplaceAjaxContent: function (newDom, section) {
        // A newer filter click is queued (clicked while this render was in
        // flight) — skip painting this stale state; the queued render
        // (usually a prefetch cache hit) paints immediately after and
        // avoids a double grid swap.
        if (this._pendingFilterParams) {
          return;
        }

        // ── Grid-only swap (default for filter/sort renders) ──
        // Replacing the whole #CollectionAjaxContent rebuilt the filter UI
        // on every apply: the checkbox the user was ABOUT to click next
        // unmounted under their cursor mid-click — rapid clicks were simply
        // lost. Instead: swap only the grid column, keep the sidebar/drawer
        // DOM alive, and sync control STATE (checked/active) in place from
        // the response. Full swap remains for popstate (this._fullAjaxSwap).
        if (!this._fullAjaxSwap) {
          var currentContent = document.querySelector('#' + section.nodeId + ' .grid__item--content');
          var freshContent = newDom.querySelector('#' + section.nodeId + ' .grid__item--content');
          if (currentContent && freshContent) {
            currentContent.innerHTML = freshContent.innerHTML;
            this.syncFilterControls(newDom);
            // Fired only when a swap ACTUALLY happened (stale renders never
            // get here) — the loading-overlay controller keys off this.
            document.dispatchEvent(new CustomEvent('collection:painted'));
            return;
          }
          // structure missing — fall through to the full swap
        }
        this._fullAjaxSwap = false;

        var existingDrawer = null;
        var existingDrawerParent = null;

        if (this.shouldReopenFilterDrawer) {
          existingDrawer = document.getElementById('FilterDrawer');
          if (existingDrawer) {
            existingDrawerParent = existingDrawer.parentNode;
            document.body.appendChild(existingDrawer);
          }
        }

        const openCollapsibleIds = this.fetchOpenCollasibleFilters();

        openCollapsibleIds.forEach(selector => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });

        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          if (existingDrawer && existingDrawerParent) {
            existingDrawerParent.appendChild(existingDrawer);
          }
          return;
        }

        // The desktop sidebar scrolls internally (sticky, max-height 90vh);
        // replacing its DOM resets that scroll to the top mid-filtering.
        // Preserve it across the swap.
        var sidebarScroller = document.querySelector('.grid__item--sidebar');
        var sidebarScrollTop = sidebarScroller ? sidebarScroller.scrollTop : 0;

        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;

        // The "N results for X" header + document.title live OUTSIDE the
        // swapped node — full swaps (runSearch's new-query path, popstate)
        // left them showing the previous query. The grid-only path syncs
        // them via syncFilterControls; do the same here.
        this.syncSearchHeader(newDom);

        if (sidebarScrollTop > 0) {
          sidebarScroller = document.querySelector('.grid__item--sidebar');
          if (sidebarScroller) sidebarScroller.scrollTop = sidebarScrollTop;
        }

        if (this.shouldReopenFilterDrawer && existingDrawer) {
          var newDrawer = document.getElementById('FilterDrawer');
          if (newDrawer) {
            var newScrollable = newDrawer.querySelector('.drawer__scrollable');
            var existingScrollable = existingDrawer.querySelector('.drawer__scrollable');
            if (newScrollable && existingScrollable) {
              existingScrollable.innerHTML = newScrollable.innerHTML;
            }

            newDrawer.parentNode.replaceChild(existingDrawer, newDrawer);
          } else if (existingDrawerParent) {
            existingDrawerParent.appendChild(existingDrawer);
          }
        }

        document.dispatchEvent(new CustomEvent('collection:painted'));
      },

      openCollapsible: function (el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }

        el.classList.add(classes.isOpen);
      },

      // Sync filter control STATE from a rendered response without
      // replacing DOM nodes (grid-only swaps). Safe at paint time: every
      // interactive path issues its own render, and AjaxRenderer only
      // paints the newest one — so no user change can exist that isn't in
      // this response. Exception: an OPEN drawer holds deferred, not-yet-
      // applied ticks — never clobber those.
      syncFilterControls: function (newDom) {
        var esc = window.CSS && CSS.escape ? CSS.escape : function (s) { return String(s).replace(/"/g, '\\"'); };
        var drawerEl = document.getElementById('FilterDrawer');
        var drawerOpen = drawerEl && drawerEl.classList.contains('drawer--is-open');

        document.querySelectorAll('#CollectionSidebar .filter-form .tag__input, #CollectionSidebar .sort-radio__input').forEach(function (input) {
          if (drawerOpen && drawerEl.contains(input)) return;
          var match = newDom.querySelector(
            'input[name="' + esc(input.name) + '"][value="' + esc(input.value) + '"]'
          );
          if (!match || input.checked === match.checked) return;
          input.checked = match.checked;
          var li = input.closest('li.tag');
          if (li) li.classList.toggle('tag--active', match.checked);
        });

        // Small server-owned labels the grid swap doesn't cover
        var curHeader = document.querySelector('#CollectionSidebar .collection-sidebar__header');
        var newHeader = newDom.querySelector('.collection-sidebar__header');
        if (curHeader && newHeader) curHeader.innerHTML = newHeader.innerHTML;

        var curCount = document.querySelector('.category-slider__views .grid-col-count');
        var newCount = newDom.querySelector('.category-slider__views .grid-col-count');
        if (curCount && newCount) curCount.textContent = newCount.textContent;

        // Search page: the "N results for X" header lives OUTSIDE
        // #CollectionAjaxContent, so grid swaps (runSearch/sort/filters)
        // must copy it from the response or it goes stale.
        this.syncSearchHeader(newDom);
      },

      // Copy the search page's out-of-grid header ("N results for X") from a
      // rendered response, and keep document.title in step. Used by BOTH the
      // grid-only path (via syncFilterControls) and the full-swap path.
      syncSearchHeader: function (newDom) {
        var curSearchCount = document.querySelector('.search-page-header__count');
        var newSearchCount = newDom.querySelector('.search-page-header__count');
        if (curSearchCount && newSearchCount) {
          curSearchCount.replaceWith(newSearchCount);
          // Title format: "<page part> – <shop>". Keep the shop suffix,
          // refresh the page part from the new header text.
          var parts = document.title.split('–');
          if (parts.length > 1) {
            document.title = newSearchCount.textContent.trim() + ' – ' + parts[parts.length - 1].trim();
          }
        }
      },

      renderCollectionPage: function (searchParams, updateURLHash = true) {
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit('collection-grid', this.shouldReopenFilterDrawer);
            // No updateScroll here: yanking the viewport to the grid top on
            // every filter apply was a major part of the "flicky" feel.
            // The user's scroll position stays exactly where it is.
            // (initPriceRange already ran in init()/forceReload — not
            // repeated here; each call destroys+recreates the noUiSlider.)
            theme.reinitProductGridItem();

            var drawerShouldReopen = false;
            if (theme.FilterDrawer && theme.FilterDrawer.drawer) {
              drawerShouldReopen = this.shouldReopenFilterDrawer &&
                theme.FilterDrawer.drawer.classList.contains(theme.FilterDrawer.config.activeDrawer);
              if (!drawerShouldReopen) {
                document.documentElement.classList.remove(theme.FilterDrawer.config.openClass);
                theme.FilterDrawer.isOpen = false;
              }
            }

            if (drawerShouldReopen) {
              theme.FilterDrawer.isOpen = true;
              theme.FilterDrawer.bindEvents();
            }

            document.dispatchEvent(new CustomEvent('collection:reloaded'));

            document.documentElement.classList.remove('js-filter-drawer-persist');
            this.shouldReopenFilterDrawer = false;
            isAnimating = false;

            // A filter was clicked while this render was in flight — apply
            // the queued (latest) form state now so that click isn't lost.
            if (this._pendingFilterParams) {
              var pendingParams = this._pendingFilterParams;
              this._pendingFilterParams = null;
              isAnimating = true;
              this.startLoading();
              this.renderCollectionPage(pendingParams);
            }
          });
      },

      bindBackButton: function () {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function (state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            // Back/forward changes the URL out from under the filter UI —
            // the sidebar/drawer must be fully re-rendered to match it,
            // not grid-only swapped.
            this._fullAjaxSwap = true;
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },

      updateScroll: function (animate) {
        var scrollToElement = document.querySelector('[data-scroll-to]');
        var scrollTo = scrollToElement && scrollToElement.offsetTop;

        if (!theme.config.bpSmall) {
          scrollTo -= 15;
        }

        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }

        if (animate) {
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: scrollTo });
        }
      },

      setFilterStickyPosition: function () {
        // All layout READS happen up front, before any style write — the
        // old write→read→write order forced two extra synchronous layouts
        // (style.top write invalidates layout, the following
        // getComputedStyle/offsetHeight reads then had to recompute it).
        var siteHeader = document.querySelector('.site-header');
        var headerHeight = siteHeader.offsetHeight;

        // Desktop: the tab bar sticks flush below the STUCK header, and the
        // sidebar pins flush below the stuck tab bar — the sidebar's own
        // 28px padding-top then keeps HIDE FILTERS exactly 28px under the
        // tab-bar divider, stuck or not (Andrew). If the header is ALREADY
        // stuck when this runs (mid-page load, resize while scrolled),
        // offsetHeight IS the true stuck height — use it directly. Only
        // when it isn't stuck yet do we fall back to deriving the stuck
        // height from the padding delta (at-rest padding -> the --stuck
        // 10px/side) — a best-effort estimate the redesign bundle's
        // syncDesktopTops replaces with a real measurement the moment the
        // header's stuck state flips (the derivation silently broke when
        // the new nav made the header taller). position:sticky on
        // .category-slider is desktop-only CSS, so these tops are inert
        // on mobile.
        var stuckHeaderHeight = headerHeight;
        if (!theme.config.bpSmall && !siteHeader.classList.contains('site-header--stuck')) {
          var headerStyles = window.getComputedStyle(siteHeader);
          stuckHeaderHeight = headerHeight
            - (parseFloat(headerStyles.paddingTop) || 0)
            - (parseFloat(headerStyles.paddingBottom) || 0)
            + 20; // .site-header--stuck padding: 10px top + 10px bottom
        }
        var stickyTabBar = document.querySelector('.category-slider');
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        var tabBarHeight = stickyTabBar ? stickyTabBar.offsetHeight : 0;

        // WRITES below this line only.
        // Mobile FILTER & SORT bar pins FLUSH under the header — the old
        // +10px made the stuck bar carry 10px more white above the button
        // than below it (Andrew's screenshot); the bar's own internal
        // spacing is symmetric without it. Desktop .collection-filter is
        // not position:sticky, so this top is inert there.
        // The header is only position:fixed after scrollY > 250, so while
        // it's off-screen the bar must pin at 0 — a headerHeight top left
        // a header-sized white band above the bar on pages whose bar pins
        // before 250 (Andrew: "big space between the toolbar and the
        // header"). collection-redesign.js keeps this in sync on scroll;
        // this write covers init and resize with the same rule.
        // ONLY for the redesigned bar (marked by its bundle script — the
        // scroll sentinel is NOT a valid marker, live's grid ships one
        // too): legacy templates (search uses live-mirror forks of the
        // grid) have no scroll-sync JS to correct this later, so they
        // keep the live theme's constant headerHeight + 10.
        var mobileBarTop = headerHeight + 10;
        if (document.querySelector('script[src*="collection-redesign"]')) {
          mobileBarTop = headerHeight;
          if (theme.config.bpSmall && !siteHeader.classList.contains('site-header--stuck')) {
            mobileBarTop = 0;
          }
        }
        document.querySelector(selectors.filters).style.top = mobileBarTop + 'px';
        if (stickyTabBar) {
          stickyTabBar.style.top = stuckHeaderHeight + 'px';
        }
        if (stickySidebar) {
          var sidebarTop = stuckHeaderHeight + tabBarHeight;
          stickySidebar.style.top = sidebarTop + 'px';
          // Fit the internally-scrolling panel to the space below its stuck
          // position (theme.css's flat 90vh overhung the viewport bottom,
          // hiding the tail of the panel even when scrolled internally).
          stickySidebar.style.maxHeight = 'calc(100vh - ' + sidebarTop + 'px)';
        }
      },

      forceReload: function (skipDrawerReinit) {
        this.init(skipDrawerReinit);
      },

      startLoading: function () {
        if (this.drawerStyle && theme.FilterDrawer && theme.FilterDrawer.isOpen) {
          return;
        }

        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });

    return Collection;
  })();

  theme.FooterSection = (function () {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      this.init();
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function () {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return FooterSection;
  })();

  theme.HeaderSection = (function () {

    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }

        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
        this.hoverMenu();
      },

      hoverMenu: function () {
        const detailsEl = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
        const mainContent = document.querySelector(".main-content");
        const header = document.getElementById("SiteHeader");
        const headerSVG = header.querySelector("svg");
        const path = headerSVG.querySelector("path");
        const toolbar = document.querySelector(".toolbar");
        const styles = window.getComputedStyle(path);


        detailsEl.forEach((detail) => {
          const summary = detail.querySelector('summary');
          const summaryLink = summary.dataset.link;

          summary.addEventListener('click', e => {
            e.preventDefault();
            window.location.href = summaryLink;
          });

          // if detail has :focus-within
          detail.addEventListener('focusin', () => {
            if (!detail.hasAttribute('open')) {

              // close all other details
              detailsEl.forEach((detail) => {
                detail.removeAttribute('open');
                detail.setAttribute('aria-expanded', 'false');
              });

              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });

          detail.addEventListener('focusout', () => {
            if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });


          function removeBackgroundHover() {
            const SiteHeaderBackground = document.getElementById("SiteHeader");

            window.addEventListener("scroll", () => {
              if (window.scrollY < 150) {
                // At the very top
                SiteHeaderBackground.classList.add("background-new-colour");
              } else {
                // Scrolled down
                SiteHeaderBackground.classList.remove("background-new-colour");
              }
            });
          }

          detail.addEventListener('mouseover', () => {

            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
              mainContent.classList.add('hoverlay');

              if (window.scrollY < 150 && window.location.pathname === "/" || window.location.pathname.startsWith('/pages/shop-all')) {
                const flipLogoColour = document.getElementsByClassName("header-item--logo");

                // if (flipLogoColour.length > 0) {
                //   flipLogoColour[0].style.filter = "invert(1)";
                // }
              }

              // header.style.backgroundColor = "white";
              // header.classList.add('active');

            }
          });

          detail.addEventListener('mouseleave', () => {

            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
              mainContent.classList.remove('hoverlay');

              const flipLogoColour = document.getElementsByClassName("header-item--logo")
              flipLogoColour[0].style.filter = "invert(0)";

              header.style.backgroundColor = "";
              header.classList.remove('active');
            }
          });
        });
      },

      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },

      initDrawers: function () {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }

        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },

      onUnload: function () {
        theme.NavDrawer.close();
        theme.announcementBar.unload();

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return HeaderSection;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
      lowInventory: 'inventory--low',
    };

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };

    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');

      this.inModal = (container.dataset.modal === 'true');
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }

      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',

        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',

        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',

        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',

        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',

        availabilityContainer: '[data-store-availability-holder]'
      };

      this.onProductMediaResize = theme.utils.debounce(150, this.updateSlideAccessibility.bind(this));

      this.cacheElements();

      this.firstProductImage = this.cache.mainSlider.querySelector('img');

      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          window.addEventListener('resize', this.onProductMediaResize);
        }
      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),

          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        this.setImageSizes();
        this.initImageZoom();
        this.initCursorZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled
        };

        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('updateSwatch', function (evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }

        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));

        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }

        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;

          // Update inventory on page load
          this.updateInventory({ detail: { variant: this.variants.currentVariant } });

          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }

        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);

          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function () {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },

      initAjaxProductForm: function () {
        new theme.AjaxProduct(this.cache.form);
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);

        if (!cartBtn) return;

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      updatePrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');

            var savings = variant.compare_at_price - variant.price;

            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;

        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },

      getImageSetName: function (string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Override to display in stock message for sold out variants with policy set to continue
        // Must be set to true in order to display in stock message for sold out variants
        const inStockForOOSAndContinueSelling = false;

        if (!variant) {
          // Variant is unavailable
          // So we want to hide both the inventory quantity + incoming transfer notice
          this.toggleInventoryQuantity('hidden', false);
          this.toggleIncomingInventory(false);
          return;
        }

        // Inventory management is nil
        // So we want to hide the low inventory message but show an In stock status
        // And hide the incoming transfer notice
        if (!variant.inventory_management) {
          this.toggleInventoryQuantity('visible', false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          const variantInventoryObject = window.inventories[this.productId][variant.id];

          const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};

          this.toggleInventoryQuantity(undefined, quantity);

          if (inStockForOOSAndContinueSelling) {
            if (quantity <= 0 && policy === 'continue') {
              this.toggleInventoryQuantity('visible', false);
              this.toggleIncomingInventory(false);
              return;
            }
          }

          if ((incoming && !variant.available) || (quantity <= 0 && policy === 'continue')) {
            this.toggleIncomingInventory(true, next_incoming_date, policy);
          } else {
            this.toggleIncomingInventory(false);
          }
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (state = undefined, quantity) {
        const productInventoryEl = this.container.querySelector(this.selectors.inventory);
        const inventorySalesPoint = productInventoryEl.closest('.sales-point');

        if (state && state === 'hidden') {
          // variant is unavailable
          // hide and return
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }

          return;
        }

        let showLowInventoryMessage = false;

        // Check if we should show low inventory message
        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && parseInt(quantity) > 0) {
          showLowInventoryMessage = true;
        }

        if (parseInt(quantity) > 0 || (state && state === 'visible')) {
          if (showLowInventoryMessage) {
            productInventoryEl.parentNode.classList.add(classes.lowInventory);
            if (quantity > 1) {
              productInventoryEl.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
            } else {
              productInventoryEl.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
            }
          } else {
            productInventoryEl.parentNode.classList.remove(classes.lowInventory);
            productInventoryEl.textContent = theme.strings.inStockLabel;
          }

          if (inventorySalesPoint) {
            inventorySalesPoint.classList.remove(classes.hidden);
          }

        } else {
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (showIncomingInventory, incomingInventoryDate, policy) {

        const incomingInventoryEl = this.container.querySelector(this.selectors.incomingInventory);
        const incomingInventoryIcon = incomingInventoryEl.querySelector('.icon-and-text');

        if (!incomingInventoryEl) return;

        const incomingInventoryBlockEnabled = incomingInventoryEl.dataset.enabled === 'true';
        const textEl = incomingInventoryEl.querySelector('.js-incoming-text');

        // If incoming inventory block is disabled, hide it
        if (!incomingInventoryBlockEnabled) {
          incomingInventoryEl.classList.add(classes.hidden);
          return;
        }

        if (showIncomingInventory) {
          if (incomingInventoryDate) {
            textEl.textContent = theme.strings.willBeInStockAfter.replace('[date]', incomingInventoryDate);
            incomingInventoryEl.classList.remove(classes.hidden);
          } else {
            textEl.textContent = theme.strings.waitingForStock;
            incomingInventoryEl.classList.remove(classes.hidden);
          }

          // When OOS and incoming inventory and continue selling disabled, update icon to low inventory
          if (incomingInventoryIcon) {
            if (policy !== 'continue') {
              incomingInventoryIcon.classList.add(classes.lowInventory);
            } else {
              incomingInventoryIcon.classList.remove(classes.lowInventory);
            }
          }

        } else {
          incomingInventoryEl.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.videoId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },

      initVimeoVideo: function (div) {
        videoObjects[div.id] = new theme.VimeoPlayer(
          div.id,
          div.dataset.videoId,
          {
            videoParent: selectors.videoParent,
            autoplay: false,
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
          }
        )
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== 'sound') {
          player.mute();
        }

        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute('data-video-type');
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise.then(function () {
            // Playing as expected
          })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute('controls', '');
              player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function (evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },

      initCursorZoom: function () {
        var zoomItems = this.container.querySelectorAll('[data-pdp-cursor-zoom]');
        if (!zoomItems.length) {
          return;
        }

        zoomItems.forEach(function (zoomItem) {
          if (zoomItem.dataset.cursorZoomInitialized === 'true') {
            return;
          }

          var image = zoomItem.querySelector('img');
          var cursor = zoomItem.querySelector('[data-pdp-cursor-zoom-cursor]');
          var zoomed = false;

          if (!image) {
            return;
          }

          zoomItem.dataset.cursorZoomInitialized = 'true';

          // The base <img> is sized for its ~1x slot; when magnified it looks soft.
          // Swap in the high-res zoom source (the same asset PhotoSwipe uses) on the
          // first zoom interaction, preloaded so there's no visible flash.
          var upgradeToHighRes = function () {
            if (image.dataset.zoomHighResLoaded === 'true') {
              return;
            }
            var highResSrc = image.getAttribute('data-photoswipe-src');
            if (!highResSrc) {
              return;
            }
            image.dataset.zoomHighResLoaded = 'true';
            var preload = new Image();
            var applyHighRes = function () {
              // Order matters: while srcset is present it governs source
              // selection, so setting src first is invisible; removing
              // srcset then re-selects directly onto the already-decoded
              // high-res source. (The old order — remove srcset, then set
              // src — re-selected onto the stale src attribute for one
              // frame and repainted twice: a visible flash on hover.)
              image.src = highResSrc;
              image.removeAttribute('srcset');
              image.removeAttribute('sizes');
            };
            preload.onload = function () {
              // Swap only after decode so the repaint is a single,
              // ready-to-paint frame (loaded bytes still need decoding).
              if (preload.decode) {
                preload.decode().then(applyHighRes).catch(applyHighRes);
              } else {
                applyHighRes();
              }
            };
            preload.src = highResSrc;
          };

          var setPosition = function (evt) {
            if (typeof evt.clientX !== 'number' || typeof evt.clientY !== 'number') {
              return;
            }

            var rect = zoomItem.getBoundingClientRect();
            var x = Math.max(0, Math.min(1, (evt.clientX - rect.left) / rect.width));
            var y = Math.max(0, Math.min(1, (evt.clientY - rect.top) / rect.height));

            zoomItem.style.setProperty('--pdp-cursor-zoom-x', (x * 100) + '%');
            zoomItem.style.setProperty('--pdp-cursor-zoom-y', (y * 100) + '%');

            if (cursor) {
              cursor.style.left = (x * 100) + '%';
              cursor.style.top = (y * 100) + '%';
            }
          };

          var setZoomed = function (isZoomed) {
            zoomed = isZoomed;
            zoomItem.classList.toggle('is-zoomed', zoomed);
          };

          zoomItem.addEventListener('mouseenter', function (evt) {
            zoomItem.classList.add('is-active');
            upgradeToHighRes();
            setPosition(evt);
          });

          zoomItem.addEventListener('mousemove', function (evt) {
            setPosition(evt);
          });

          zoomItem.addEventListener('mouseleave', function () {
            zoomItem.classList.remove('is-active');
            setZoomed(false);
          });

          zoomItem.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            upgradeToHighRes();
            setPosition(evt);
            setZoomed(!zoomed);
          });
        });
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);

        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);

        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }

        // Update mobile progress bar on init
        this.updateProgressBar(this.settings.currentSlideIndex || 0);

        // Ensure inactive slides are not focusable for accessibility
        this.updateSlideAccessibility();
      },

      onSlideChange: function (index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]');

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
          this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
          this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + index + '"]');

        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;

        // Update mobile progress bar
        this.updateProgressBar(index);

        // Ensure inactive slides are not focusable for accessibility
        this.updateSlideAccessibility();
      },

      updateProgressBar: function (index) {
        var progressEl = this.container.querySelector('[data-pdp-progress]');
        if (!progressEl) return;
        var bars = progressEl.querySelectorAll('[data-pdp-progress-bar]');
        if (!bars.length || bars.length <= 1) return;
        bars.forEach(function (bar, i) {
          bar.classList.toggle('is-active', i <= index);
        });
      },

      updateSlideAccessibility: function() {
        var slides = this.cache.mainSlider.querySelectorAll('.product-main-slide');
        var desktopMediaGrid = window.matchMedia && window.matchMedia('(min-width: 769px)').matches;

        slides.forEach(function(slide) {
          var isActive = desktopMediaGrid || slide.classList.contains('is-selected');

          if (desktopMediaGrid) {
            slide.removeAttribute('aria-hidden');
            if (slide.getAttribute('tabindex') === '-1') {
              slide.removeAttribute('tabindex');
            }
          } else if (isActive) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }

          slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function(el) {
            if (isActive) {
              if (el.hasAttribute('data-previous-tabindex')) {
                var previousTabindex = el.getAttribute('data-previous-tabindex');
                if (previousTabindex === '') {
                  el.removeAttribute('tabindex');
                } else {
                  el.setAttribute('tabindex', previousTabindex);
                }
                el.removeAttribute('data-previous-tabindex');
              }
            } else {
              if (!el.hasAttribute('data-previous-tabindex')) {
                var currentTabindex = el.getAttribute('tabindex');
                el.setAttribute('data-previous-tabindex', currentTabindex || '');
              }
              el.setAttribute('tabindex', '-1');
            }
          });
        });
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute('data-index');
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;

          fetch(url).then(function (response) {
            return response.text();
          }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);

            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-modal');

              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }

              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });

            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            if (form) {
              var formId = form.getAttribute('id');
              blocks.querySelectorAll('[form]').forEach(el => {
                el.setAttribute('form', formId);
              });
            }

            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');

            this.cacheElements();

            this.formSetup();
            this.updateModalProductInventory();

            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.productId
              }
            }));
          }.bind(this));

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function (evt) {
                if (evt.detail.productId === this.productId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        AOS.refreshHard();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};

          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          'shopify_xr_launch',
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
              ':not(.' +
              self.classes.hidden +
              ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function () {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });

        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function (evt) {
              this.mediaLoaded(evt);
            }.bind(this));

            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function (evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);
        window.removeEventListener('resize', this.onProductMediaResize);

        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    });

    return Product;
  })();

  theme.SiblingProductSwatches = (function () {
    var selectors = {
      link: '[data-sibling-product-link]',
      productSection: '.product-section[data-section-type="product"]',
      shopifySection: '[id^="shopify-section-"]',
      swatches: '[data-sibling-product-swatches]',
      scrollWrap: '[data-sibling-product-swatches] .sibling-product-swatches__scroll-wrap',
      scrollList: '.sibling-product-swatches__list',
      activeLabel: '.sibling-product-swatches__active',
      labelValue: '.sibling-product-swatches__label-value',
      itemText: '.sibling-product-swatches__text',
      variantInput: '[data-variant-input]'
    };

    var primarySectionIds = ['main'];
    // Note: product-recommendations is intentionally NOT refreshed via the
    // Section Rendering API — re-rendering it picks up the sibling template's
    // own products_per_row setting, which can differ between product templates
    // and visibly resize the grid. Instead, the existing <product-recommendations>
    // element is asked to re-fetch for the new product (see refreshProductRecommendations),
    // keeping the layout the page loaded with.
    var secondaryBaseSectionIds = ['17321898911583408b'];
    var activeRequestId = 0;
    var activeNavigationController = null;
    var requestCache = {};
    var requestCacheKeys = [];
    var maxRequestCacheEntries = 12;
    var prefetchedUrls = {};
    var preloadedImageUrls = {};
    var listenersBound = false;
    var resizeTimer;
    var siblingScrollStorageKey = 'dfyne:sibling-product-swatches-scroll';

    function getProductSection() {
      return document.querySelector(selectors.productSection);
    }

    function getSectionWrapper(sectionId) {
      return document.getElementById('shopify-section-' + sectionId) ||
        document.querySelector('[id^="shopify-section-"][id$="__' + sectionId + '"]');
    }

    function getMainWrapper() {
      var productSection = getProductSection();
      return productSection ? productSection.closest(selectors.shopifySection) : getSectionWrapper('main');
    }

    function normalizeSectionId(id) {
      if (!id) return '';

      var normalized = id.replace(/^shopify-section-/, '');
      var templateDivider = normalized.lastIndexOf('__');

      return templateDivider === -1 ? normalized : normalized.slice(templateDivider + 2);
    }

    function addUniqueSectionId(ids, id) {
      id = normalizeSectionId(id);

      if (id && ids.indexOf(id) === -1) {
        ids.push(id);
      }
    }

    function getPrimarySectionIds() {
      var ids = [];

      primarySectionIds.forEach(function (sectionId) {
        addUniqueSectionId(ids, sectionId);
      });

      var mainWrapper = getMainWrapper();
      if (mainWrapper) {
        addUniqueSectionId(ids, mainWrapper.id);
      }

      return ids;
    }

    // The Section Rendering API's plural `sections=` param keys the response
    // by the FULL section id (e.g. template--123__main). The normalized suffix
    // 'main' comes back as {"main":null} — 100% wasted — which then forced a
    // fallback fetch of the entire product page. Map each normalized primary id
    // to the real DOM id so the render is actually usable.
    function getSectionRequestId(normalizedId) {
      if (normalizedId === 'main') {
        var mainWrapper = getMainWrapper();
        if (mainWrapper && mainWrapper.id) {
          return mainWrapper.id.replace(/^shopify-section-/, '');
        }
      }

      var wrapper = getSectionWrapper(normalizedId);
      if (wrapper && wrapper.id) {
        return wrapper.id.replace(/^shopify-section-/, '');
      }

      return normalizedId;
    }

    function getPrimaryRequestSectionIds() {
      return getPrimarySectionIds().map(getSectionRequestId);
    }

    // The response is keyed by whatever id we asked for (the full id). Downstream
    // swap/warm code reads sections.main, so mirror each full-id entry onto its
    // normalized key.
    function normalizeSectionsResponse(sections) {
      if (!sections || typeof sections !== 'object') return sections;

      Object.keys(sections).forEach(function (key) {
        var normalized = normalizeSectionId(key);
        if (normalized && normalized !== key && sections[normalized] === undefined) {
          sections[normalized] = sections[key];
        }
      });

      return sections;
    }

    function getSecondarySectionIds(primaryIds) {
      var ids = [];

      secondaryBaseSectionIds.forEach(function (sectionId) {
        addUniqueSectionId(ids, sectionId);
      });

      document.querySelectorAll('[data-sibling-product-refresh-section]').forEach(function (el) {
        addUniqueSectionId(ids, el.dataset.siblingProductRefreshSection);
      });

      primaryIds = primaryIds || [];
      return ids.filter(function (sectionId) {
        return primaryIds.indexOf(sectionId) === -1;
      });
    }

    function buildRequestUrl(url, sectionIds) {
      var requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('sections', sectionIds.join(','));
      return requestUrl.toString();
    }

    function rememberRequestCacheKey(requestUrl) {
      var existingIndex = requestCacheKeys.indexOf(requestUrl);
      if (existingIndex > -1) {
        requestCacheKeys.splice(existingIndex, 1);
      }

      requestCacheKeys.push(requestUrl);

      while (requestCacheKeys.length > maxRequestCacheEntries) {
        var expiredUrl = requestCacheKeys.shift();
        if (expiredUrl && expiredUrl !== requestUrl) {
          delete requestCache[expiredUrl];
        }
      }
    }

    function forgetRequestCacheKey(requestUrl) {
      var existingIndex = requestCacheKeys.indexOf(requestUrl);
      if (existingIndex > -1) {
        requestCacheKeys.splice(existingIndex, 1);
      }
    }

    function fetchSections(url, sectionIds, options) {
      sectionIds = sectionIds || getPrimarySectionIds();
      if (!sectionIds.length) return Promise.resolve({});

      var requestUrl = buildRequestUrl(url, sectionIds);
      var fetchOptions = {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      };

      if (options && options.signal) {
        fetchOptions.signal = options.signal;
      }

      if (!requestCache[requestUrl]) {
        requestCache[requestUrl] = fetch(requestUrl, fetchOptions).then(function (response) {
          if (!response.ok) {
            throw new Error('Could not load product sections');
          }

          return response.json();
        }).then(normalizeSectionsResponse).catch(function (error) {
          delete requestCache[requestUrl];
          forgetRequestCacheKey(requestUrl);
          throw error;
        });
      }

      rememberRequestCacheKey(requestUrl);

      return requestCache[requestUrl];
    }

    function captureSelectedOptions() {
      var productSection = getProductSection();
      if (!productSection) return [];

      return Array.prototype.slice.call(productSection.querySelectorAll(selectors.variantInput)).reduce(function (selectedOptions, input) {
        var type = input.getAttribute('type');
        var isChoiceInput = type === 'radio' || type === 'checkbox';

        if (isChoiceInput && !input.checked) {
          return selectedOptions;
        }

        selectedOptions.push({
          index: input.dataset.index,
          name: input.name || '',
          value: input.value
        });

        return selectedOptions;
      }, []);
    }

    function restoreSelectedOptions(productSection, selectedOptions) {
      if (!productSection || !selectedOptions || !selectedOptions.length) return;

      var inputs = Array.prototype.slice.call(productSection.querySelectorAll(selectors.variantInput));
      var lastMatch = null;

      selectedOptions.forEach(function (selected) {
        var match = inputs.find(function (input) {
          var sameName = !selected.name || !input.name || input.name === selected.name;
          var type = input.getAttribute('type');
          var isChoiceInput = type === 'radio' || type === 'checkbox';
          var valueExists = isChoiceInput ? input.value === selected.value : Array.prototype.some.call(input.options || [], function (option) {
            return option.value === selected.value;
          });

          return input.dataset.index === selected.index &&
            sameName &&
            valueExists;
        });

        if (match) {
          var type = match.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            match.checked = true;
          } else {
            match.value = selected.value;
          }

          lastMatch = match;
        }
      });

      if (lastMatch) {
        lastMatch.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function updateSwatchScrollButtons(wrap) {
      if (!wrap) return;

      var list = wrap.querySelector(selectors.scrollList);
      var leftWrapper = wrap.querySelector('.sibling-product-swatches__scroll-wrapper[data-navigation="left"]');
      var rightWrapper = wrap.querySelector('.sibling-product-swatches__scroll-wrapper[data-navigation="right"]');
      if (!list || !leftWrapper || !rightWrapper) return;

      var maxScroll = list.scrollWidth - list.clientWidth;
      leftWrapper.classList.toggle('is-visible', list.scrollLeft > 1);
      rightWrapper.classList.toggle('is-visible', maxScroll > 0 && list.scrollLeft < maxScroll - 1);
    }

    function updateAllSwatchScrollButtons() {
      document.querySelectorAll(selectors.scrollWrap).forEach(updateSwatchScrollButtons);
    }

    function getSiblingScrollState(source) {
      if (!source) return null;

      var swatches = null;
      if (source.matches && source.matches(selectors.swatches)) {
        swatches = source;
      } else if (source.closest) {
        swatches = source.closest(selectors.swatches);
      }

      if (!swatches && source.querySelector) {
        swatches = source.querySelector(selectors.swatches);
      }

      if (!swatches) return null;

      var list = swatches.querySelector(selectors.scrollList);
      if (!list) return null;

      return {
        handles: getSwatchHandleSet(swatches),
        left: list.scrollLeft
      };
    }

    function getCurrentPath() {
      return window.location.pathname + window.location.search;
    }

    function storeSiblingScrollState(targetPath, scrollState) {
      if (!targetPath || !scrollState) return;

      try {
        window.sessionStorage.setItem(siblingScrollStorageKey, JSON.stringify({
          handles: scrollState.handles || '',
          left: scrollState.left || 0,
          path: targetPath
        }));
      } catch (error) {
        return;
      }
    }

    function getStoredSiblingScrollState(swatches) {
      var storedState = null;

      try {
        storedState = JSON.parse(window.sessionStorage.getItem(siblingScrollStorageKey) || 'null');
      } catch (error) {
        clearStoredSiblingScrollState();
        return null;
      }

      if (!storedState) return null;

      if (storedState.path !== getCurrentPath()) {
        clearStoredSiblingScrollState();
        return null;
      }

      if (storedState.handles && swatches && storedState.handles !== getSwatchHandleSet(swatches)) {
        clearStoredSiblingScrollState();
        return null;
      }

      return storedState;
    }

    function clearStoredSiblingScrollState() {
      try {
        window.sessionStorage.removeItem(siblingScrollStorageKey);
      } catch (error) {
        return;
      }
    }

    function restoreSiblingScrollState(swatches, scrollState) {
      if (!swatches || !scrollState) return;

      var list = swatches.querySelector(selectors.scrollList);
      if (!list) return;

      // Set scrollLeft directly without reading scrollWidth/clientWidth first.
      // Reading those properties forces a synchronous layout at scroll=0,
      // giving the compositor a chance to paint that intermediate state.
      // The browser clamps scrollLeft to the valid range automatically.
      var previousScrollBehavior = list.style.scrollBehavior;
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = scrollState.left || 0;
      list.style.scrollBehavior = previousScrollBehavior;

      // Defer button update to avoid forced layout during the critical swap
      var wrap = list.closest(selectors.scrollWrap);
      if (wrap) {
        window.requestAnimationFrame(function () {
          updateSwatchScrollButtons(wrap);
        });
      }
    }

    function restoreStoredOrScrollActiveSwatch(swatches) {
      var storedScrollState = getStoredSiblingScrollState(swatches);

      if (storedScrollState) {
        restoreSiblingScrollState(swatches, storedScrollState);
        clearStoredSiblingScrollState();
        return;
      }

      scrollActiveSwatchIntoView(swatches);
    }

    function scrollSiblingList(list, amount) {
      if (!list) return;

      var maxScroll = list.scrollWidth - list.clientWidth;
      var currentScroll = list.scrollLeft;
      var targetScroll = currentScroll + amount;

      targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

      if (typeof list.scrollTo === 'function') {
        list.scrollTo({ left: targetScroll, behavior: 'smooth' });
      } else {
        list.scrollLeft = targetScroll;
      }
    }

    function initSwatchScrollers(scope) {
      scope = scope || document;

      var wraps = [];
      if (scope.matches && scope.matches(selectors.scrollWrap)) {
        wraps = [scope];
      } else {
        wraps = Array.prototype.slice.call(scope.querySelectorAll(selectors.scrollWrap));
      }

      wraps.forEach(function (wrap) {
        if (!wrap || wrap.dataset.siblingScrollInitialized === 'true') {
          updateSwatchScrollButtons(wrap);
          return;
        }

        var list = wrap.querySelector(selectors.scrollList);
        var leftBtn = wrap.querySelector('.sibling-product-swatches__scroll--left');
        var rightBtn = wrap.querySelector('.sibling-product-swatches__scroll--right');
        if (!list || !leftBtn || !rightBtn) return;

        var scrollAmount = 210;
        var pendingFrame = null;
        var scheduleButtonUpdate = function () {
          if (pendingFrame) return;
          pendingFrame = window.requestAnimationFrame(function () {
            pendingFrame = null;
            updateSwatchScrollButtons(wrap);
          });
        };
        var handleKeydown = function (evt, amount) {
          if (evt.key !== 'Enter' && evt.key !== ' ') return;
          evt.preventDefault();
          scrollSiblingList(list, amount);
        };

        wrap.dataset.siblingScrollInitialized = 'true';
        leftBtn.addEventListener('click', function () {
          scrollSiblingList(list, -scrollAmount);
        });
        rightBtn.addEventListener('click', function () {
          scrollSiblingList(list, scrollAmount);
        });
        leftBtn.addEventListener('keydown', function (evt) {
          handleKeydown(evt, -scrollAmount);
        });
        rightBtn.addEventListener('keydown', function (evt) {
          handleKeydown(evt, scrollAmount);
        });
        list.addEventListener('scroll', scheduleButtonUpdate, { passive: true });
        updateSwatchScrollButtons(wrap);
      });
    }

    function markPendingLink(link) {
      var swatches = link.closest(selectors.swatches);
      if (!swatches) return;

      swatches.querySelectorAll(selectors.link).forEach(function (item) {
        delete item.dataset.siblingPending;
      });

      syncSwatchesToHandle(swatches, link.dataset.productHandle, {
        preserveScroll: true
      });

      link.dataset.siblingPending = 'true';
    }

    function getSwatchHandleSet(swatches) {
      if (!swatches) return '';

      return Array.prototype.slice.call(swatches.querySelectorAll(selectors.link)).map(function (link) {
        return link.dataset.productHandle || '';
      }).filter(Boolean).sort().join('|');
    }

    function getSwatchHandleOrder(swatches) {
      if (!swatches) return '';

      return Array.prototype.slice.call(swatches.querySelectorAll(selectors.link)).map(function (link) {
        return link.dataset.productHandle || '';
      }).filter(Boolean).join('|');
    }

    function syncSwatchesToHandle(swatches, handle, options) {
      if (!swatches || !handle) return false;
      options = options || {};

      var matchedLink = null;
      swatches.querySelectorAll(selectors.link).forEach(function (item) {
        var isActive = item.dataset.productHandle === handle;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          matchedLink = item;
          item.setAttribute('aria-current', 'true');
          item.dataset.siblingCurrent = 'true';
        } else {
          item.removeAttribute('aria-current');
          delete item.dataset.siblingCurrent;
        }
        // The server bakes ", selected" into each item's aria-label; when
        // this strip is preserved across a sibling swap the old product's
        // swatch kept announcing itself as selected. Keep the suffix in
        // step with the visual active state (colour name first, optional
        // ", Sold out" tail preserved).
        var ariaLabel = item.getAttribute('aria-label');
        if (ariaLabel) {
          var strippedLabel = ariaLabel.replace(/, selected/i, '');
          if (isActive) {
            var itemColour = item.querySelector(selectors.itemText);
            itemColour = itemColour ? itemColour.textContent.trim() : '';
            if (itemColour && strippedLabel.indexOf(itemColour) === 0) {
              strippedLabel = itemColour + ', selected' + strippedLabel.slice(itemColour.length);
            } else {
              strippedLabel += ', selected';
            }
          }
          if (strippedLabel !== ariaLabel) {
            item.setAttribute('aria-label', strippedLabel);
          }
        }
        delete item.dataset.siblingPending;
      });

      if (!matchedLink) return false;

      var activeLabel = swatches.querySelector(selectors.activeLabel);
      var itemText = matchedLink.querySelector(selectors.itemText);
      if (activeLabel && itemText) {
        activeLabel.textContent = ' - ' + itemText.textContent.trim();
      }
      // "COLOUR: <value>" header — also server-rendered into the preserved
      // strip, so it froze on the first product's colour after swaps.
      var labelValue = swatches.querySelector(selectors.labelValue);
      if (labelValue && itemText) {
        labelValue.textContent = itemText.textContent.trim();
      }

      if (!options.preserveScroll) {
        scrollActiveSwatchIntoView(swatches);
      }

      return true;
    }

    function scrollActiveSwatchIntoView(swatches) {
      if (!swatches) return;

      var activeLink = swatches.querySelector(selectors.link + '.is-active');
      if (!activeLink) return;

      var list = swatches.querySelector(selectors.scrollList);
      if (!list) return;

      var listRect = list.getBoundingClientRect();
      var linkRect = activeLink.getBoundingClientRect();
      var delta = 0;

      if (linkRect.left < listRect.left) {
        delta = linkRect.left - listRect.left;
      } else if (linkRect.right > listRect.right) {
        delta = linkRect.right - listRect.right;
      }

      if (delta) {
        list.scrollLeft += delta;
      }
      updateSwatchScrollButtons(list.closest(selectors.scrollWrap));
    }

    // Converts the scroll position of the swatch list into a negative
    // margin-left on the first item + overflow:hidden so the visual
    // appearance is identical but no longer depends on scrollLeft.
    // Inline styles survive DOM detach/reattach, whereas scrollLeft
    // gets reset to 0 by the browser when an element leaves the document.
    // Call unfreezeSwatchScroll() after all DOM swaps and init are done
    // to atomically switch back to real scrollLeft.
    function freezeSwatchScroll(swatches) {
      if (!swatches) return null;

      var list = swatches.querySelector(selectors.scrollList);
      if (!list) return null;

      var scrollLeft = list.scrollLeft;
      if (scrollLeft <= 0) return null;

      var firstChild = list.firstElementChild;
      if (!firstChild) return null;

      var state = {
        scrollLeft: scrollLeft,
        savedOverflow: list.style.overflow || '',
        savedOverflowX: list.style.overflowX || '',
        savedScrollBehavior: list.style.scrollBehavior || '',
        firstChild: firstChild,
        savedMarginLeft: firstChild.style.marginLeft || ''
      };

      // Convert scroll position → negative margin on first child.
      // With overflow:hidden the clipped region matches what the
      // scroll viewport showed, so the visual result is identical.
      firstChild.style.marginLeft = '-' + scrollLeft + 'px';
      list.style.overflow = 'hidden';
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = 0;

      return state;
    }

    function unfreezeSwatchScroll(swatches, frozenState) {
      if (!frozenState || !swatches) return;

      var list = swatches.querySelector(selectors.scrollList);
      if (!list) return;

      // Restore the first child's margin
      var fc = frozenState.firstChild;
      if (!fc || fc.parentNode !== list) {
        fc = list.firstElementChild;
      }
      if (fc) {
        fc.style.marginLeft = frozenState.savedMarginLeft;
      }

      // Restore overflow, then set scrollLeft — all synchronous so the
      // browser will only paint the final state.
      list.style.overflow = frozenState.savedOverflow;
      list.style.overflowX = frozenState.savedOverflowX;
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = frozenState.scrollLeft;
      list.style.scrollBehavior = frozenState.savedScrollBehavior;

      // Defer button update to next frame
      var wrap = list.closest(selectors.scrollWrap);
      if (wrap) {
        window.requestAnimationFrame(function () {
          updateSwatchScrollButtons(wrap);
        });
      }
    }

    function preserveSiblingSwatches(currentWrapper, nextWrapper, options) {
      if (!currentWrapper || !nextWrapper) return false;
      options = options || {};

      var currentSwatches = currentWrapper.querySelector(selectors.swatches);
      var nextSwatches = nextWrapper.querySelector(selectors.swatches);
      var nextProductSection = nextWrapper.querySelector(selectors.productSection);
      if (!currentSwatches || !nextSwatches) return false;

      if (getSwatchHandleSet(currentSwatches) !== getSwatchHandleSet(nextSwatches)) return false;

      // If the order changed (subgroup reordering), use the new server-rendered HTML
      if (getSwatchHandleOrder(currentSwatches) !== getSwatchHandleOrder(nextSwatches)) return false;

      if (!syncSwatchesToHandle(currentSwatches, nextProductSection ? nextProductSection.dataset.productHandle : '', {
        preserveScroll: !!options.preserveScroll
      })) return false;

      nextSwatches.replaceWith(currentSwatches);
      return true;
    }

    function warmImageElement(image) {
      if (!image) return;

      var src = image.getAttribute('src');
      var srcset = image.getAttribute('srcset');
      var sizes = image.getAttribute('sizes');
      var cacheKey = srcset || src;
      if (!cacheKey || preloadedImageUrls[cacheKey]) return;

      var preloadImage = new Image();
      preloadedImageUrls[cacheKey] = preloadImage;
      if (sizes) preloadImage.sizes = sizes;
      if (srcset) preloadImage.srcset = srcset;
      if (src) preloadImage.src = src;
    }

    function preloadFirstProductImage(html) {
      if (!html || typeof Image === 'undefined') return;

      var container = document.createElement('div');
      container.innerHTML = html.trim();

      // Desktop shows TWO slides above the fold; warming only the featured
      // slide left slide 2 fetching at lazy priority after a swatch swap.
      // Mobile shows one slide, so it never pays for the second warm.
      var warmCount = window.matchMedia && window.matchMedia('(min-width: 769px)').matches ? 2 : 1;
      var images = container.querySelectorAll('[data-product-photos] img, .product-main-slide img');
      for (var i = 0; i < images.length && i < warmCount; i++) {
        warmImageElement(images[i]);
      }
    }

    function warmProductSections(sections) {
      if (sections && sections.main) {
        preloadFirstProductImage(sections.main);
      }
    }

    function shouldPrefetchSiblingProducts() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!connection) return true;
      if (connection.saveData) return false;
      return !connection.effectiveType || connection.effectiveType.indexOf('2g') === -1;
    }

    function scheduleIdleWork(callback) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 1500 });
      } else {
        window.setTimeout(callback, 300);
      }
    }

    function prefetchProductUrl(url) {
      if (!shouldPrefetchSiblingProducts()) return;

      var targetUrl = new URL(url, window.location.origin);
      if (targetUrl.origin !== window.location.origin || targetUrl.pathname.indexOf('/products/') === -1) return;

      var targetPath = targetUrl.pathname + targetUrl.search;
      if (targetPath === window.location.pathname + window.location.search) return;

      // Use the SAME full-id request ids loadProduct uses, so the prefetched
      // response lands under the identical requestCache key and the click path
      // reuses it instead of re-fetching.
      var sectionIds = getPrimaryRequestSectionIds();
      var requestUrl = buildRequestUrl(targetPath, sectionIds);
      if (prefetchedUrls[requestUrl]) return;

      prefetchedUrls[requestUrl] = true;
      fetchSections(targetPath, sectionIds).then(warmProductSections).catch(function () {});
    }

    function queueSiblingPrefetch(scope) {
      if (!shouldPrefetchSiblingProducts()) return;

      scope = scope || document;
      // Eagerly warm only the first few siblings: each prefetch is a full
      // server-rendered main section plus warmed hero images, so 12 of them
      // cost real bandwidth (and 12 Liquid renders) for swatches most
      // shoppers never click. The rest still warm on hover/touchstart via
      // handlePrefetch, and the blur-free LQIP covers any cold swap.
      var links = Array.prototype.slice.call(scope.querySelectorAll(selectors.link)).filter(function (link) {
        return link.dataset.siblingCurrent !== 'true';
      }).slice(0, 4);

      if (!links.length) return;

      scheduleIdleWork(function () {
        var index = 0;
        var prefetchNext = function () {
          if (index >= links.length) return;

          prefetchProductUrl(links[index].href);
          index += 1;

          if (index < links.length) {
            window.setTimeout(prefetchNext, 120);
          }
        };

        prefetchNext();
      });
    }

    function parseSection(sectionId, html, currentWrapper) {
      if (!html) return null;

      var container = document.createElement('div');
      container.innerHTML = html.trim();

      var wrapper = container.querySelector('#shopify-section-' + sectionId) ||
        container.querySelector('[id^="shopify-section-"][id$="__' + sectionId + '"]');

      if (wrapper) {
        return wrapper;
      }

      if (currentWrapper) {
        wrapper = document.createElement(currentWrapper.tagName.toLowerCase());
        wrapper.id = currentWrapper.id;
        wrapper.className = currentWrapper.className;
        wrapper.innerHTML = html;
        return wrapper;
      }

      return container.firstElementChild;
    }

    function unloadProductSection(productSection) {
      if (!productSection || !theme.sections) return;

      var sectionId = productSection.dataset.sectionId;
      if (!sectionId) return;

      document.dispatchEvent(new CustomEvent('shopify:section:unload', {
        detail: {
          sectionId: sectionId
        }
      }));
    }

    function replaceSection(sectionId, html, options) {
      options = options || {};

      var currentWrapper = sectionId === 'main' ? getMainWrapper() : getSectionWrapper(sectionId);
      if (!currentWrapper || !html) return null;

      var nextWrapper = parseSection(sectionId, html, currentWrapper);
      if (!nextWrapper) return null;

      if (sectionId === 'main') {
        preserveSiblingSwatches(currentWrapper, nextWrapper, {
          preserveScroll: !!options.siblingScrollState,
          siblingScrollState: options.siblingScrollState
        });
      }

      // The blur-up treatment is for initial page loads only — swapped-in
      // sections arrive with the veil at full opacity AND the 32px LQIP
      // background (itself blurry) under the incoming image; the template
      // can't know this render is an in-page sibling swap. Merely marking
      // the veil done still left the blurry LQIP showing while the new
      // image streamed in, so strip the whole placeholder: removing the
      // class drops both the ::after veil and the background-image rule.
      nextWrapper.querySelectorAll('.image-wrap--blur-up').forEach(function (wrap) {
        wrap.classList.remove('image-wrap--blur-up');
        wrap.style.removeProperty('--pdp-lqip');
      });

      currentWrapper.replaceWith(nextWrapper);

      if (options.siblingScrollState && !options.skipScrollRestore) {
        restoreSiblingScrollState(nextWrapper.querySelector(selectors.swatches), options.siblingScrollState);
      }

      return nextWrapper;
    }

    function refreshProductRecommendations(productId) {
      if (!productId) return;

      document.querySelectorAll('product-recommendations').forEach(function (el) {
        if (typeof el.refreshForProduct === 'function') {
          el.refreshForProduct(productId);
        }
      });
    }

    function refreshSecondarySections(targetPath, sectionIds, requestId) {
      if (!sectionIds || !sectionIds.length) return Promise.resolve();

      // The reviews widget (and other app-rendered secondary sections) do not
      // come back usable from the Section Rendering API — the Judge.me widget
      // returns an empty shell, so swapping it in makes the reviews vanish.
      // Fetch the sibling's full page (the same HTML a real navigation gets)
      // and extract each section from it instead. Never removeSection: if a
      // section isn't present we keep the existing one rather than deleting it.
      return fetch(targetPath, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Secondary sections fetch failed: ' + response.status);
        return response.text();
      }).then(function (fullHtml) {
        if (requestId !== activeRequestId) return null;

        var doc = new DOMParser().parseFromString(fullHtml, 'text/html');

        sectionIds.forEach(function (sectionId) {
          var sectionEl = doc.getElementById('shopify-section-' + sectionId);
          if (sectionEl) {
            replaceSection(sectionId, sectionEl.outerHTML);
          }
        });

        document.dispatchEvent(new CustomEvent('dfyne:sibling-product:secondary-loaded', {
          detail: {
            url: targetPath,
            sectionIds: sectionIds
          }
        }));
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        console.error(error);
      });
    }

    function initProductSection(wrapper) {
      var productSection = wrapper && wrapper.matches && wrapper.matches(selectors.productSection) ?
        wrapper :
        wrapper ? wrapper.querySelector(selectors.productSection) : getProductSection();

      if (!productSection) return null;

      if (theme.sections && typeof theme.sections._onSectionLoad === 'function') {
        theme.sections._onSectionLoad(null, productSection, productSection.dataset.sectionId);
      } else if (theme.Product) {
        new theme.Product(productSection);
      }

      return productSection;
    }

    function updateTitle(productSection) {
      if (!productSection || !productSection.dataset.productTitle) return;

      var titleParts = document.title.split(' – ');
      var shopName = titleParts.length > 1 ? titleParts[titleParts.length - 1] : '';
      document.title = shopName ? productSection.dataset.productTitle + ' – ' + shopName : productSection.dataset.productTitle;
    }

    // The Kiwi Sizing app injects its "What's my size" trigger into the main
    // product section on initial page load only, so replacing the section
    // during sibling navigation silently drops it. Detach the injected node
    // before the swap and re-insert it (listeners intact) after the new
    // section is initialized. Siblings are colourways of the same product
    // family and share size charts, so reusing the trigger node is safe.
    function findKiwiSizingNode(scope) {
      if (!scope) return null;

      // Prefer the rendered trigger: Kiwi marks its rendered elements with
      // _ks_* classes (e.g. the "What's my size?" span is ._ks_text), while
      // the app block / data script only has "kiwi" in its id. Searching for
      // "kiwi" first would match the data block instead of the button.
      var node = scope.querySelector('[class*="_ks_"]');

      if (!node) {
        var candidates = scope.querySelectorAll('a, button, p, div, span');
        for (var i = 0; i < candidates.length; i++) {
          if (candidates[i].children.length <= 2 && /what.?s my size/i.test(candidates[i].textContent || '')) {
            node = candidates[i];
            break;
          }
        }
      }

      if (!node) {
        try {
          node = scope.querySelector('[class*="kiwi" i], [id*="kiwi" i]');
        } catch (error) {
          node = scope.querySelector('[class*="kiwi"], [id*="kiwi"], [class*="Kiwi"], [id*="Kiwi"]');
        }
      }

      if (!node) return null;

      // Climb to the outermost wrapper that contains nothing but the injected
      // trigger, so the whole injected block is preserved.
      var nodeText = (node.textContent || '').trim();
      while (node.parentElement && node.parentElement !== scope &&
        (node.parentElement.textContent || '').trim() === nodeText) {
        node = node.parentElement;
      }

      return node;
    }

    function preserveKiwiSizing(currentWrapper) {
      var node = findKiwiSizingNode(currentWrapper);
      if (!node) return null;

      var anchorSelector = null;
      var prev = node.previousElementSibling;
      if (prev && prev.classList.length) {
        anchorSelector = '.' + Array.prototype.slice.call(prev.classList).join('.');
      }

      node.remove();

      return { node: node, anchorSelector: anchorSelector };
    }

    function restoreKiwiSizing(newWrapper, preserved) {
      if (!newWrapper || !preserved || !preserved.node) return;

      // If the app re-rendered its trigger on its own, leave it alone.
      var existing = findKiwiSizingNode(newWrapper);
      if (existing && /what.?s my size/i.test(existing.textContent || '')) return;

      // Kiwi moves its rendered trigger to its configured position at runtime
      // (below the variant picker), away from the app data block higher up in
      // the template — so re-insert at the position the trigger actually
      // occupied (its previous sibling), not at the data block.
      var anchor = null;
      if (preserved.anchorSelector) {
        try {
          anchor = newWrapper.querySelector(preserved.anchorSelector);
        } catch (error) {
          anchor = null;
        }
      }
      if (!anchor) {
        anchor = newWrapper.querySelector('.product-block--variant-picker');
      }

      if (anchor) {
        anchor.insertAdjacentElement('afterend', preserved.node);
        return;
      }

      // Last resort: take the fresh (empty, unrendered) app data block's spot.
      if (existing) {
        existing.replaceWith(preserved.node);
      }
    }

    // Preferred path: Kiwi's plugin exposes a re-render API
    // (loadKiwiSizingChart). Re-inserting the OLD trigger node only restores
    // the old product's charts — KiwiSizing.data is rendered once at layout
    // level and goes stale after a section swap, leaving the modal degraded
    // to its footer (a kiwisizing.com privacy/terms link) on chart mismatch.
    // Rebuild the data from the new product's JSON and let Kiwi re-render
    // trigger + charts itself; fall back to the DOM restore only when the
    // plugin (or fetch) isn't available.
    function refreshKiwiSizing(newWrapper, preserved, productPath) {
      if (typeof window.loadKiwiSizingChart !== 'function' || !window.KiwiSizing || !window.fetch || !productPath) {
        restoreKiwiSizing(newWrapper, preserved);
        return;
      }

      fetch(productPath.split('?')[0] + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('product json ' + response.status);
          return response.json();
        })
        .then(function (product) {
          var prev = window.KiwiSizing.data || {};
          window.KiwiSizing.data = {
            // product .js has no collections; siblings are colourways of the
            // same family, so the previous page's collection ids still match
            // the same charts.
            collections: prev.collections || '',
            tags: product.tags.join(','),
            product: String(product.id),
            vendor: product.vendor,
            type: product.type,
            title: product.title,
            // The Kiwi plugin writes whatever sits in images[] straight into
            // the popup's img src — the {id, position, src} object format
            // rendered as "/products/[object Object]" and 404'd, leaving only
            // the alt text in the modal after a sibling swap. product .js
            // returns CDN URL strings; pass them through unchanged (verified
            // on the live-mirror port: correct colourway image, naturalWidth
            // 2000, after a swap).
            images: product.images.slice(0, 3),
            options: product.options,
            variants: product.variants.map(function (v) {
              return {
                id: v.id, title: v.title,
                option1: v.option1, option2: v.option2, option3: v.option3,
                options: v.options, available: v.available,
                price: v.price, sku: v.sku
              };
            })
          };
          window.loadKiwiSizingChart();
        })
        .catch(function () {
          restoreKiwiSizing(newWrapper, preserved);
        });
    }

    function loadProduct(url, options) {
      options = options || {};

      var requestId = activeRequestId + 1;
      activeRequestId = requestId;

      var currentProductSection = getProductSection();
      var selectedOptions = options.preserveOptions === false ? [] : captureSelectedOptions();
      var previousScrollY = window.scrollY;
      var primaryRefreshSectionIds = getPrimarySectionIds();
      // Full DOM ids for the sections= request (see getSectionRequestId); the
      // normalized ids above are still used to exclude primaries from secondary.
      var primaryRequestSectionIds = getPrimaryRequestSectionIds();
      var secondaryRefreshSectionIds = getSecondarySectionIds(primaryRefreshSectionIds);
      var targetUrl = new URL(url, window.location.origin);
      var targetPath = targetUrl.pathname + targetUrl.search;
      var siblingScrollState = getSiblingScrollState(options.link || currentProductSection);
      var navigationController = window.AbortController ? new AbortController() : null;

      storeSiblingScrollState(targetPath, siblingScrollState);

      if (activeNavigationController && typeof activeNavigationController.abort === 'function') {
        activeNavigationController.abort();
      }
      activeNavigationController = navigationController;

      document.documentElement.classList.add('is-loading-sibling-product');
      if (currentProductSection) {
        currentProductSection.classList.add('is-loading-sibling-product');
        currentProductSection.setAttribute('aria-busy', 'true');
      }

      return fetchSections(targetPath, primaryRequestSectionIds, {
        signal: navigationController ? navigationController.signal : null
      }).then(function (sections) {
        if (requestId !== activeRequestId) return null;

        // If the Section Rendering API returned null for the main section
        // (happens on password-protected stores), fall back to fetching
        // the full product page HTML and extracting the section from it.
        if (!sections || !sections.main) {
          return fetch(targetPath, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: navigationController ? navigationController.signal : null
          }).then(function (response) {
            if (!response.ok) throw new Error('Full page fetch failed: ' + response.status);
            return response.text();
          }).then(function (fullHtml) {
            var doc = new DOMParser().parseFromString(fullHtml, 'text/html');
            var mainWrapper = getMainWrapper();
            var sectionEl = mainWrapper
              ? (doc.getElementById(mainWrapper.id) || doc.querySelector('[id^="shopify-section-"][id$="__main"]'))
              : doc.querySelector('[id^="shopify-section-"][id$="__main"]');

            if (!sectionEl) throw new Error('Could not extract main section from page HTML');

            sections = sections || {};
            sections.main = sectionEl.outerHTML;
            return sections;
          });
        }

        return sections;
      }).then(function (sections) {
        if (!sections || requestId !== activeRequestId) return null;

        if (!sections.main) {
          throw new Error('Product section was not returned');
        }

        // Cold swaps (un-hovered, beyond the idle-prefetch warm set) had no
        // image warming at all — with the blur placeholder stripped on swaps,
        // that gap would show as a white slot for the full fetch. Kick the
        // above-fold image fetches off now, before any DOM work.
        warmProductSections(sections);

        unloadProductSection(currentProductSection);

        var kiwiSizingPreserved = preserveKiwiSizing(
          currentProductSection ? currentProductSection.closest(selectors.shopifySection) : getMainWrapper()
        );

        // Freeze the swatch scroll position into a CSS margin + overflow:hidden
        // BEFORE any DOM manipulation.  Inline styles survive detach/reattach,
        // whereas scrollLeft gets reset to 0 by the browser.  This means the
        // visual position is locked no matter what happens during replaceSection
        // or initProductSection.  We unfreeze (reverse the hack and set
        // scrollLeft) after all initialization is complete.
        var currentSwatches = currentProductSection
          ? currentProductSection.closest(selectors.shopifySection).querySelector(selectors.swatches)
          : null;
        var frozenScroll = siblingScrollState
          ? freezeSwatchScroll(currentSwatches)
          : null;

        var mainWrapper = replaceSection('main', sections.main, {
          siblingScrollState: siblingScrollState,
          skipScrollRestore: !!frozenScroll
        });
        clearStoredSiblingScrollState();

        var prevRefresh = window.AOS && window.AOS.refreshHard;
        if (window.AOS) window.AOS.refreshHard = function() {};

        var newProductSection = initProductSection(mainWrapper);

        if (prevRefresh) window.AOS.refreshHard = prevRefresh;
        if (!newProductSection) {
          throw new Error('Product section could not be initialized');
        }

        updateTitle(newProductSection);

        if (window.history && window.history.pushState && options.pushState !== false) {
          window.history.pushState({ siblingProduct: true }, '', targetPath);
        }

        restoreSelectedOptions(newProductSection, selectedOptions);
        refreshKiwiSizing(mainWrapper, kiwiSizingPreserved, targetPath);
        initSwatchScrollers(newProductSection);
        queueSiblingPrefetch(newProductSection);

        window.scrollTo(0, previousScrollY);

        // Unfreeze the swatch scroll — atomically reverses the margin hack
        // and sets scrollLeft to the correct value.  All synchronous, so
        // the browser only paints the final correct state.
        if (frozenScroll && mainWrapper) {
          unfreezeSwatchScroll(mainWrapper.querySelector(selectors.swatches), frozenScroll);
        } else if (siblingScrollState && mainWrapper) {
          // Fallback when freeze wasn't used (scrollLeft was 0)
          var postInitSwatches = mainWrapper.querySelector(selectors.swatches);
          if (postInitSwatches) {
            restoreSiblingScrollState(postInitSwatches, siblingScrollState);
          }
        }

        // AOS does not initialise elements added after page load, and the swap
        // above intentionally suppresses AOS.refreshHard during init. Without
        // this, the new section's [data-aos] elements stay at their hidden
        // start state (.image-element is opacity:0 until .aos-animate), which
        // leaves images — e.g. the complete-the-look carousel — invisible.
        if (newProductSection.querySelectorAll) {
          newProductSection.querySelectorAll('[data-aos]').forEach(function (el) {
            el.classList.add('aos-animate');
          });
        }

        document.dispatchEvent(new CustomEvent('dfyne:sibling-product:loaded', {
          detail: {
            url: url,
            productSection: newProductSection
          }
        }));

        refreshProductRecommendations(newProductSection.dataset.productId);
        refreshSecondarySections(targetPath, secondaryRefreshSectionIds, requestId);
      }).catch(function (error) {
        if (requestId !== activeRequestId) return;
        if (error && error.name === 'AbortError') return;

        console.error(error);

        if (options.fallback !== false) {
          window.location.href = targetPath;
        } else {
          throw error;
        }
      }).finally(function () {
        if (requestId !== activeRequestId) return;

        if (activeNavigationController === navigationController) {
          activeNavigationController = null;
        }

        document.documentElement.classList.remove('is-loading-sibling-product');

        var productSection = getProductSection();
        if (productSection) {
          productSection.classList.remove('is-loading-sibling-product');
          productSection.removeAttribute('aria-busy');
        }
      });
    }

    function handleClick(evt) {
      if (!evt.target || !evt.target.closest) return;

      var link = evt.target.closest(selectors.link);
      if (!link) return;

      if (link.dataset.siblingCurrent === 'true') {
        evt.preventDefault();
        return;
      }

      if (link.dataset.siblingPending === 'true') {
        evt.preventDefault();
        return;
      }

      if (link.getAttribute('aria-disabled') === 'true') {
        evt.preventDefault();
        return;
      }

      if (evt.defaultPrevented || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      if (link.target && link.target !== '_self') return;

      var targetUrl = new URL(link.href, window.location.origin);
      if (targetUrl.origin !== window.location.origin || targetUrl.pathname.indexOf('/products/') === -1) return;

      evt.preventDefault();
      markPendingLink(link);
      loadProduct(targetUrl.pathname + targetUrl.search, { pushState: true, link: link });
    }

    function handlePrefetch(evt) {
      if (!evt.target || !evt.target.closest) return;

      var link = evt.target.closest(selectors.link);
      if (!link || link.dataset.siblingCurrent === 'true') return;

      var targetUrl = new URL(link.href, window.location.origin);
      if (targetUrl.origin !== window.location.origin || targetUrl.pathname.indexOf('/products/') === -1) return;

      prefetchProductUrl(targetUrl.pathname + targetUrl.search);
    }

    function handlePopState() {
      if (window.location.pathname.indexOf('/products/') === -1) {
        window.location.reload();
        return;
      }

      loadProduct(window.location.pathname + window.location.search, {
        pushState: false,
        preserveOptions: false,
        fallback: false
      }).catch(function () {
        window.location.reload();
      });
    }

    function init() {
      initSwatchScrollers(document);

      document.querySelectorAll(selectors.swatches).forEach(restoreStoredOrScrollActiveSwatch);

      // In the theme editor, let swatch clicks navigate normally. Hijacking
      // them with pushState + section replacement desyncs the editor's
      // section overlays and settings panel from the rendered preview.
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (evt) {
          initSwatchScrollers(evt.target || document);
        });
        return;
      }

      queueSiblingPrefetch(document);

      if (listenersBound) return;

      document.addEventListener('click', handleClick);
      document.addEventListener('mouseover', handlePrefetch);
      document.addEventListener('touchstart', handlePrefetch, { passive: true });
      window.addEventListener('popstate', handlePopState);
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateAllSwatchScrollButtons, 100);
      });

      listenersBound = true;
    }

    return {
      init: init,
      loadProduct: loadProduct
    };
  })();

  theme.RecentlyViewed = (function () {
    var init = false;

    function RecentlyViewed(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
      this.imageSizes = this.container.getAttribute('data-image-sizes');

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function () {
        if (init) {
          return;
        }

        init = true;

        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }

        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');

        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== 'undefined') {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));

        Promise.all(promises).then(function (result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },

      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            // Share the page-wide product-JSON cache (dedupes concurrent
            // requests and caches 404s), then re-serialize to keep this path's
            // string contract — setupOutput JSON.parse()s the resolved value.
            theme.fetchProductJson(handle).then(function (product) {
              if (!product) {
                // Product no longer exists, remove from recently viewed
                theme.removeRecentlyViewedHandle(handle);
                resolve(null);
                return;
              }
              resolve(JSON.stringify(product));
            }).catch(function () {
              resolve(null);
            });
          }
        });
      },

      setupOutput: function (products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute('data-recent-count');

        var i = 0;

        Object.keys(products).forEach(function (key) {
          if (!products[key]) {
            return;
          }
          var product = JSON.parse(products[key]);

          // Ignore current product
          if (product.handle === this.handle) {
            return;
          }

          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return;
          }

          i++;

          // New or formatted properties
          const widths = [180, 360, 540, 720, 900];
          product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.Images.buildImagePath(product.featured_image),
            product.image_responsive_urls = theme.Images.buildImagePath(product.featured_image, widths),
            product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;

          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';

            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }

            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }

          allProducts.unshift(product);
        }.bind(this));

        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }

        var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf, this.imageSizes);

        this.outputContainer.innerHTML = productMarkup;

        if (AOS) {
          AOS.refreshHard();
        }
      },

      captureProductDetails: function (products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }

        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },

      onUnload: function () {
        init = false;
      }
    });

    return RecentlyViewed;
  })();

  theme.Testimonials = (function () {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };

    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function () {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function () {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return Testimonials;
  })();


  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function (scope) {
    if (AOS) { AOS.refreshHard() }

    if (!document.documentElement.classList.contains('modal-open')) {
      theme.initQuickShop();
    }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  theme.modelSize = (function () {
    var selectors = {
      unitButton: '[data-model-size-unit]',
      unitValue: '[data-model-size-value]',
      kiwiButton: '[data-model-size-open-kiwi]'
    };

    var classes = {
      active: 'is-active'
    };

    var kiwiTriggerSelectors = [
      '.ks-calculator-modal-link',
      '.sizing-calculator-modal-link',
      '.ks-container-app-block a',
      '.ks-container-app-block button',
      '[class*="kiwi"] a',
      '[class*="kiwi"] button',
      '[id*="kiwi"] a',
      '[id*="kiwi"] button',
      '[data-kiwi] a',
      '[data-kiwi] button',
      '[data-kiwi-trigger]',
      '[data-kiwi-recommender]',
      '[data-kiwi-size-chart]'
    ];

    var kiwiTextMatches = [
      'size guide',
      'size chart',
      'find my size',
      "what's my fit",
      'whats my fit',
      'size recommender',
      'fit guide'
    ];

    function init() {
      if (document.documentElement.dataset.modelSizeBound === 'true') {
        return;
      }

      document.documentElement.dataset.modelSizeBound = 'true';
      document.addEventListener('click', handleClick);
    }

    function handleClick(event) {
      var unitButton = event.target.closest(selectors.unitButton);
      if (unitButton) {
        event.preventDefault();
        setUnit(unitButton.closest('[data-model-size]'), unitButton.getAttribute('data-model-size-unit'));
        unitButton.blur();
        return;
      }

      var kiwiButton = event.target.closest(selectors.kiwiButton);
      if (!kiwiButton) {
        return;
      }

      event.preventDefault();

      var scope = kiwiButton.closest('.product-section') || kiwiButton.closest('.modal') || document.body;
      var trigger = findKiwiTrigger(scope);

      if (trigger) {
        trigger.click();
      } else {
        waitForKiwiTrigger(scope);
      }

      closeContainingPanel(kiwiButton);
    }

    function closeContainingPanel(button) {
      var panel = button.closest('[data-pdp-panel]');
      if (!panel) {
        return;
      }

      var closeButton = panel.querySelector('[data-pdp-panel-close]');
      if (closeButton) {
        closeButton.click();
      }
    }

    function setUnit(component, unit) {
      if (!component || !unit) {
        return;
      }

      component.dataset.activeUnit = unit;

      component.querySelectorAll(selectors.unitButton).forEach(function (button) {
        var isActive = button.getAttribute('data-model-size-unit') === unit;
        button.classList.toggle(classes.active, isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      component.querySelectorAll(selectors.unitValue).forEach(function (node) {
        var nextValue = unit === 'cm' ? node.getAttribute('data-unit-cm') : node.getAttribute('data-unit-in');
        if (nextValue) {
          node.textContent = nextValue;
        }
      });
    }

    function waitForKiwiTrigger(scope) {
      var observerRoot = scope && scope.nodeType === 1 ? scope : document.body;
      if (!observerRoot) {
        return;
      }

      var observer = new MutationObserver(function () {
        var trigger = findKiwiTrigger(scope);
        if (!trigger) {
          return;
        }

        observer.disconnect();
        trigger.click();
      });

      observer.observe(observerRoot, { childList: true, subtree: true });

      window.setTimeout(function () {
        observer.disconnect();
      }, 1500);
    }

    function findKiwiTrigger(scope) {
      var roots = uniqueRoots([
        scope,
        scope && scope.closest ? scope.closest('.product-section') : null,
        scope && scope.closest ? scope.closest('.modal') : null,
        document
      ]);

      for (var i = 0; i < roots.length; i++) {
        var selectorMatch = findKiwiTriggerBySelector(roots[i]);
        if (selectorMatch) {
          return selectorMatch;
        }

        var textMatch = findKiwiTriggerByText(roots[i]);
        if (textMatch) {
          return textMatch;
        }
      }

      return null;
    }

    function findKiwiTriggerBySelector(root) {
      if (!root || !root.querySelectorAll) {
        return null;
      }

      var candidates = root.querySelectorAll(kiwiTriggerSelectors.join(','));
      for (var i = 0; i < candidates.length; i++) {
        if (isUsableKiwiTrigger(candidates[i])) {
          return candidates[i];
        }
      }

      return null;
    }

    function findKiwiTriggerByText(root) {
      if (!root || !root.querySelectorAll) {
        return null;
      }

      var candidates = root.querySelectorAll('a, button, [role="button"]');
      for (var i = 0; i < candidates.length; i++) {
        var candidate = candidates[i];
        if (!isUsableKiwiTrigger(candidate)) {
          continue;
        }

        var text = (candidate.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!text) {
          continue;
        }

        for (var j = 0; j < kiwiTextMatches.length; j++) {
          if (text.indexOf(kiwiTextMatches[j]) > -1) {
            return candidate;
          }
        }
      }

      return null;
    }

    function isUsableKiwiTrigger(node) {
      if (!node || node.matches(selectors.kiwiButton)) {
        return false;
      }

      if (node.hasAttribute('disabled') || node.getAttribute('aria-hidden') === 'true') {
        return false;
      }

      // Don't require visibility — the native Kiwi trigger is intentionally hidden via CSS
      return true;
    }

    function uniqueRoots(roots) {
      return roots.filter(function (root, index) {
        return root && roots.indexOf(root) === index;
      });
    }

    return {
      init: init,
      setUnit: setUnit
    };
  })();

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
    theme.modelSize.init();
  }

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);

    theme.initGlobals();
    theme.SiblingProductSwatches.init();
    theme.accessibilityFixes.init();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})();
